// Japanese for the HEVN Portal — GENERATED by scripts/i18n_langs.cjs from flat translations of `en` in
// i18n.js (2026-10-21). Edit a string here or re-run the script; a key absent here falls back to English.
// Acronyms, system and product names stay as written (EXF, FOB, MOQ, SAP, NetSuite, Helinox …).
const ja = {
  "common": {
    "notif": {
      "title": "通知",
      "unreadCount": "未読の通知が{{count}}件あります",
      "markAll": "すべて既読にする",
      "markRead": "既読にする",
      "loading": "読み込み中…",
      "empty": "現在、お知らせはありません。業務に関するメールがポータルから届いた場合も、ここに表示されます。",
      "open": "関連するページを開く",
      "by": "{{name}} による",
      "settings": "通知する項目を選択",
      "settingsHint": "ベルに表示するグループを選んでください。メールはこれまで通り届きます。オフにしたグループはここで非表示になるだけで、オンに戻すとまた表示されます。",
      "save": "保存",
      "cancel": "戻る",
      "saved": "保存しました",
      "unreadIn": "未読{{count}}件",
      "g_approvals": "承認と決定",
      "g_access": "アクセス依頼（新規ユーザー）",
      "g_tickets": "チケット",
      "g_samples": "サンプルの期日",
      "g_projects": "プロジェクト（SKUの追加・移動・中止）",
      "g_cycletime": "サイクルタイムのチェック",
      "g_ceo": "CEOオフィス",
      "g_chat": "グループチャット（GCC）",
      "g_tasks": "システムプロジェクト",
      "g_other": "その他",
      "hidden": "{{count}}グループを非表示"
    },
    "common": {
      "language": "言語",
      "theme": "テーマ",
      "light": "ライト",
      "dark": "ダーク",
      "allRoles": "すべてのロール"
    },
    "cpAtt": {
      "photos": "写真",
      "messages": "メッセージ",
      "you": "あなた",
      "pendingTag": "保存時に送信されます",
      "noMessages": "メッセージはまだありません。",
      "placeholder": "この見積についてメモを書く…",
      "send": "送信",
      "withdraw": "削除",
      "deleteConfirm": "このメッセージを削除しますか？全員から削除され、元に戻せません。",
      "saveFailed": "メッセージを保存できませんでした。",
      "deleteFailed": "メッセージを削除できませんでした。"
    },
    "bench": {
      "title": "Inline コストシート",
      "sub": "Inline ベンチマークに読み込んだ仕入先のコストシートです。ファイルがなくても見積と比較できるよう保管しています。",
      "search": "スタイル、ファイル、仕入先、シーズンを検索…",
      "empty": "読み込み済みのコストシートはまだありません。上の「コストシートをインポート」を使ってください。読み込んだ内容はここに保管され、見積の Inline ベンチマークを入力する際に候補として表示されます。",
      "noHit": "「{{q}}」に一致するものはありません。",
      "loading": "シートを読み込み中…",
      "lines": "{{n}}行",
      "edit": "詳細を編集",
      "remove": "削除",
      "save": "保存",
      "saved": "保存しました。",
      "removed": "ライブラリから削除しました。",
      "editTitle": "シーズン、仕入先、メモ",
      "editBody": "ワークブックに記載されていない3つの項目です。コストは仕入先が提示した値のため編集できません。隣の仕入原価は、それらを照合した基準です。",
      "season": "シーズン",
      "vendor": "仕入先",
      "note": "メモ",
      "removeTitle": "このコストシートを削除しますか？",
      "removeBody": "{{file}} はライブラリから外れ、ベンチマーク入力時の候補に表示されなくなります。すでにこのシートと比較した見積は、数値と隣に印字された行をそのまま保持します。",
      "colLine": "行",
      "colVariant": "コストバージョン",
      "colStated": "シート記載の仕入原価",
      "import": "コストシートをインポート",
      "readOk": "{{file}} — {{n}}行を読み込み、保管しました。",
      "readRefused": "{{n}}行は、各列の合計が隣に印字された仕入原価と一致しないため受け付けられませんでした。"
    },
    "ceo": {
      "title": "CEOオフィス",
      "sub": "開始したものをすべて、完了まで追跡します。ceo.office@ に転送されたメールはチケットになります。カウンターは各チケット自身のイベントログから計算されます。",
      "desk": "デスク",
      "bothDesks": "両方",
      "desk_business": "ビジネス",
      "desk_executive": "エグゼクティブ",
      "refresh": "更新",
      "newTicket": "新規チケット",
      "newSub": "チケットは1つのデスクに作成され、そのデスクに残ります。法人と社内担当は空のままでも構いません。多くの案件は担当先が未定の状態で始まります。",
      "create": "作成",
      "cancel": "キャンセル",
      "close": "クローズ",
      "needTitle": "チケットにはタイトルが必要です。",
      "fromWho": "差出人",
      "notSet": "未設定",
      "noTickets": "このデスクにはまだチケットがありません。",
      "noDesk": "デスクに所属していないため、表示できるものがありません。Young に Business または Executive への追加を依頼してください。",
      "filteredBy": "{{name}} のみ表示中 — {{n}}件。",
      "clearFilter": "すべて表示",
      "cardOpen": "対応中",
      "cardOpenRule": "クローズも中止もされていないもの",
      "cardOverdue": "期限超過",
      "cardOverdueRule": "未完了で期日を過ぎたもの",
      "cardUntouched": "3日以上未対応",
      "cardUntouchedRule": "最後の連絡イベントから",
      "cardWaiting": "CEO待ち",
      "cardWaitingRule": "ステータスがそう示しているもの",
      "cardNoEntity": "法人未設定",
      "cardNoEntityRule": "担当先が未定",
      "cardClosed": "今週クローズ",
      "cardClosedRule": "過去7日間にクローズされたもの",
      "colTicket": "チケット",
      "colTitle": "タイトル／差出人",
      "colDesk": "デスク",
      "colType": "種別",
      "colEntity": "法人",
      "colContact": "社内担当",
      "colOwner": "オーナー",
      "colDue": "期日",
      "colStatus": "ステータス",
      "colLast": "最終連絡",
      "colDday": "D-day",
      "logTitle": "イベントログ",
      "logContacted": "こちらから連絡した",
      "logReply": "先方から返信があった",
      "ev_created": "作成",
      "ev_contacted": "連絡",
      "ev_reply": "返信",
      "ev_status": "ステータス",
      "ev_field": "編集",
      "ev_closed": "クローズ",
      "ev_reopened": "再開",
      "ev_note": "メモ",
      "closeTicket": "チケットをクローズ",
      "reopenTicket": "再開",
      "closeTitle": "{{id}} をクローズ",
      "reopenTitle": "{{id}} を再開",
      "closeSub": "「対応中」と「期限超過」から外れ、「今週クローズ」にカウントされます。履歴とともに一覧と検索には残り、再開することもできます。",
      "reopenSub": "クローズ前のステータスに戻り、再び未完了として数えられます。",
      "closeNote": "クローズメモ（任意）",
      "reopenNote": "再開の理由（任意）",
      "closeNotePh": "例：通話で合意済み。これ以上の対応は不要。",
      "reopenNotePh": "例：先方から新たな依頼が届いた。",
      "closedBy": "{{who}} がクローズ · {{when}}",
      "statusClosedHint": "クローズ済みです。ステータスを変更するには「再開」を押してください。",
      "logNote": "社内メモを追加",
      "logNoteSub": "このチケットを開ける人にはポータル内で表示され、誰にもメール送信されません。連絡には当たらず、最終連絡も更新されません。Ctrl+Enter で記録します。",
      "logNoteWhy": "デスクとCEO向けのメモです。日付もカウンターも動きません。",
      "notePh": "何があったか、何を決めたか、次に何をするか。",
      "historyTitle": "履歴",
      "hist_all": "すべて",
      "hist_mail": "メール",
      "hist_note": "メモ",
      "hist_change": "変更",
      "historyEmpty": "このチケットには、この種類の履歴はまだありません。",
      "hSent": "メール送信",
      "hReceived": "メール受信",
      "hSentWhy": "CEO Office のメールボックス、またはデスクのメンバーから送信されたものです。",
      "hReceivedWhy": "外部から CEO Office に送信されたものです。",
      "hTo": "宛先",
      "hCc": "Cc",
      "hQuoted": "このメールに引用されている過去のメッセージを表示",
      "hQuotedHide": "引用されたメッセージを非表示",
      "hNote": "社内メモ",
      "hCreated": "チケット作成",
      "hCreatedMail": "CEO Office のメールボックスからチケットを作成",
      "hClosed": "クローズ（元：{{from}}）",
      "hReopened": "再開 → {{to}}",
      "hFile": "ファイル添付",
      "historyScope": "{{mailbox}} に届いたメール（宛先、コピー、または送信元として含まれるもの）がここに表示されます。デスクのメンバーが {{mailbox}} をコピーに入れずに自分のメールボックスから送ったメールは、ポータルでは確認できません。",
      "restricted": "制限あり — 他のデスク",
      "otherDesk": "このチケットは他のデスクのものです。存在は確認できますが、履歴は閲覧できません。",
      "entityTitle": "法人別のCCアドレス",
      "entityFilled": "{{total}}件中{{n}}件を設定済み",
      "entitySub": "法人と社内担当は、チケットの送信メールでコピーに入るアドレスです。Young から8件のアドレスが届くまでは空のままです。ここに入れたアドレスには実際にメールが届くため、推測では入力していません。",
      "entityPh": "未設定",
      "fTitle": "タイトル",
      "fTitlePh": "何を開始したか — このチケットで追跡する内容",
      "fFromPh": "誰からのものか（ある場合）",
      "fTypePh": "フォローアップ、法務、書類…",
      "newLater": "タイトル以外は空のままにして後から入力できます。多くの案件は担当先が未定の状態で始まります。",
      "fLaterPh": "未定の場合は空のままにしてください",
      "tabTickets": "チケット",
      "allDesks": "すべて",
      "unassigned": "未割り当て",
      "choosedesk": "配置先…",
      "deskRule": "デスクは自分のチケットのみ閲覧できます。CEOは両方を閲覧できます。",
      "open": "開く",
      "fAllStatuses": "すべてのステータス",
      "fAllTypes": "すべての種別",
      "fAllEntities": "すべての法人",
      "fAllContacts": "すべての社内担当",
      "fAllOwners": "すべてのオーナー",
      "searchPh": "タイトルまたは差出人を検索…",
      "searchLeadPh": "取引先を検索…",
      "ddayWhat": "期日から数えます。+ は超過日数、- は残り日数です。",
      "ddayLegend": "D-day は期日から数えます。+5 は5日超過、-5 は残り5日を意味します。チケットが未完了の間のみ数えられます。",
      "ev_file": "ファイル",
      "fileUnreadable": "そのファイルを読み込めませんでした。",
      "files": "添付ファイル",
      "filesSub": "このチケットが待っているもの、または一緒に届いたものです。1ファイル10 MBまで、1チケットあたり{{n}}件まで。",
      "addFile": "ファイルを追加",
      "removeFile": "削除",
      "removeFileSub": "ファイルはサーバーから削除されます。この操作は元に戻せません。",
      "uploading": "アップロード中…",
      "logContactedSub": "どこへ送り、何を伝えたか。どちらも任意です。日付はどちらの場合も記録されます。Ctrl+Enter で記録します。",
      "logReplySub": "どこから返ってきて、先方が何と言ったか。どちらも任意です。日付はどちらの場合も記録されます。Ctrl+Enter で記録します。",
      "channel": "方法",
      "channelPh": "メール、電話、ミーティング…",
      "contactNote": "メモ",
      "contactNotePh": "例：署名済みの控えを催促した",
      "replyNotePh": "例：あと2週間必要とのこと",
      "record": "記録",
      "colDwell": "現ステータスの日数",
      "nDays": "{{n}}日",
      "atStageN": "この段階で{{n}}日",
      "worstN": "最長{{n}}日",
      "lateShape": "遅延している箇所",
      "lateShapeSub": "特定のキューが滞っているのか、全体なのか",
      "nothingLate": "期日を過ぎているものはありません。",
      "howLong": "このデスクの所要時間",
      "howLongSub": "イベントログから算出 — 手入力はありません",
      "toFirstAnswer": "作成 → 最初の回答",
      "toClose": "作成 → クローズ",
      "neverAnswered": "未完了で、一度も回答がないもの",
      "medianOf": "{{n}}件の中央値",
      "notEnough": "データ不足です — 現在{{n}}件",
      "loading": "読み込み中…",
      "noHistory": "記録はまだありません。",
      "reset": "リセット",
      "resetN": "リセット（{{n}}）",
      "sortedBy": "{{col}}で並べ替え",
      "showingN": "{{total}}件中{{n}}件を表示 —",
      "leadContactHint": "日付を記録します。最終連絡と「返信なし」は、どちらもこの日付から数えます。",
      "exportExcel": "Excelにエクスポート",
      "contactHint": "日付を記録します。最終連絡と「3日以上未対応」は、どちらもこの日付から数えます。",
      "logContactedWhy": "こちらから連絡しました。このチケットに本日の日付を記録し、未対応のカウントをやり直します。",
      "logReplyWhy": "先方が回答しました。こちらも本日の日付を記録します。催促したことと回答を受けたことは別の事実のため、分けています。",
      "tab_tickets": "チケット",
      "tab_leads": "リード",
      "tab_daily": "日次",
      "sub_tickets": "開始したものをすべて、完了まで追跡します。ceo.office@ に転送されたメールはチケットになります。カウンターは各チケット自身のイベントログから計算されます。",
      "sub_leads": "新規アカウントのパイプラインです。CEOが探す先と条件を決め、デスクが連絡を取り、回答を条件に照らして確認します。",
      "sub_daily": "毎朝4つのブロックを表示します。画面と自動送信メールは同じ内容です。",
      "newLead": "新規リード",
      "newLeadSub": "リードは Business デスクに属します。リードには所属するチケットを指定でき、チケットがまだない段階で開始することもできます。",
      "needCounterparty": "リードには取引先が必要です。",
      "counterpartyPh": "やり取りしている相手",
      "sectorPh": "ディストリビューション、リテール、オンライン…",
      "leadTicketPh": "このリードが属するチケットがあれば選択してください",
      "countryPh": "タイ、ベトナム…",
      "criteriaPh": "CEOの条件に照らして…",
      "noLeads": "リードはまだありません。",
      "noReply": "返信なし{{n}}日",
      "colLead": "リード",
      "colCounterparty": "取引先",
      "colCountry": "国",
      "colSector": "業種",
      "colStage": "ステージ",
      "colCriteria": "基準",
      "colNext": "次回連絡",
      "leadsNote": "リードは Business デスクのみに属します。CEOが対象市場と条件を決め、デスクが連絡を取り、回答を得て、基準に照らして確認します。",
      "stageRule_Contacted": "最初のメールを送信済み",
      "stageRule_Replied": "取引先から返信あり",
      "stageRule_Checking_criteria": "CEOの条件に照らして確認",
      "stageRule_With_CEO": "通過、決定待ち",
      "stageRule_Closed": "成約、または基準未満",
      "dOpened": "昨日以降に開始",
      "dMoved": "移動",
      "dOverdue": "期限超過",
      "dWaiting": "CEO待ち",
      "nItems": "{{n}}件",
      "reachFirst": "先に連絡",
      "nothingHere": "なし",
      "dailyNote": "平日の KL 08:30 に送信します。各デスクには自デスクのチケットをまとめたメールが届き、CEOには両方が届きます。画面とメールは同じ内容です。"
    },
    "pricing": {
      "title": "Collab 価格計算ツール",
      "subtitle": "コスト、T1、MSRP、ロイヤリティを1画面で — 原価計算は USD",
      "modeGeneral": "一般 Collab · OEM / ODM",
      "modeGeneralSub": "ロイヤリティなし · マークアップベース → T1 → MSRP",
      "modeLicensed": "ライセンス Collab（ロイヤリティ）",
      "modeLicensedSub": "グローバル MSRP → 現地価格 → ロイヤリティ",
      "padClose": "閉じる",
      "padNeedInstruction": "下の「指示」欄に条件を書いてから、もう一度押してください。",
      "padOptionN": "オプション{{n}}",
      "padInlineRrp": "Inline 小売価格",
      "padPremium": "Collab プレミアム",
      "padTargetMsrp": "目標 MSRP",
      "padOwnRetailRef": "Inline、参考値",
      "padPartnerNa": "該当なし — Inline はパートナーには販売しません",
      "padGapOwn": "自社小売：Collab は {{c}}% を確保（Inline は {{i}}%）",
      "padGapPartnerBelow": "パートナー卸：追加分を含めると原価を{{amt}}下回ります",
      "padGapPartnerOk": "パートナー卸：追加分を含めて{{pct}}%",
      "padToB7": "→ ブロック7：パートナー側でこの1個あたり{{amt}}を誰が負担するか？",
      "padSkuN": "SKU {{n}}",
      "padB7NoteMany": "見積全体で1つの決定です：{{n}} SKU、注文全体で追加分は{{e}}。A、B、C のいずれでも MSRP とパートナー単価は変わらず、追加分を誰が負担するかだけが異なります。",
      "padFrameModel": "フレームモデル",
      "padB1": "1 · 注文",
      "padKindOrder": "これらの数値の見積条件",
      "padLeadDays": "{{d}}日 → 短納期 {{r}}",
      "padWhyShow": "差が出る理由（{{n}}）",
      "padWhyHide": "閉じる",
      "padNoReason": "理由の記載なし",
      "padMoqNote": "MOQ 割増だけで{{amt}}です。この数量での追加分の{{pct}}%にあたります。",
      "padB2": "2 · 工場コスト",
      "padB3": "3 · フレームコスト",
      "padB4": "4 · 追加コスト",
      "padB5": "5 · 総コスト",
      "padB6": "6 · 価格とマージン",
      "padB7": "7 · 追加分の負担者 — 注文全体 {{n}} EA で{{amt}}",
      "padB7Kind": "判断 · ワンクリック · O.H 控除後の純利益",
      "padB7KindCalc": "閲覧のみ · 承認者が判断するカード",
      "method": "価格設定方式",
      "methodCbd": "CBD コストプラス（HEVN Costing）",
      "methodGuideline": "コスティングガイドライン（O.H 15% + 階層別比率）",
      "methodCbdHint": "CBD から求めた工場価格に、設定で定めた HPAC 諸経費と T2 マークアップを加え、価格はドル単位に切り上げます。",
      "methodGuidelineHint": "マークアップベース、固定 O.H 15%、この見積に入力した T1 / T2 比率を使用します。",
      "cbdSub": "Calculation シートと同じ計算です。HPAC 諸経費は Base + Frame の {{oh}}%、T2 = (Base + Frame + O.H) × {{x}}。割増は原価のまま転嫁されます。HPAC が負担する場合はチェックしてください。",
      "cbdBase": "ベース価格",
      "cbdBaseSub": "Skin + CMT + 仕入先 OH と利益、さらに荷役費と国内輸送費",
      "cbdFrame": "フレーム",
      "cbdBaseFrame": "Base + Frame",
      "cbdOh": "HPAC 諸経費（{{pct}}%）",
      "cbdOhSub": "ドル単位に丸め",
      "cbdMoq": "生産 MOQ 割増",
      "cbdSl": "短納期割増",
      "cbdAbsorb": "HPAC が負担",
      "cbdAbsorbed": "（HPAC が負担）",
      "cbdT1": "T1 · HPAC → Helinox 法人",
      "cbdT1Sub": "Base + Frame + O.H + 割増、切り上げ",
      "cbdT2": "T2 · HPAC → パートナー",
      "cbdT2Unit": "T2 パートナー価格 / 個",
      "cbdT2Sub": "(Base + Frame + O.H) × {{x}} + 割増、切り上げ",
      "cbdFactory": "仕入先コスト",
      "cbdFactorySub": "Base + Frame + 両方の割増 — 工場が請求する金額",
      "cbdGp": "粗利（仕入先コスト比）",
      "cbdMargin": "マージン %（T2 基準）",
      "cbdExtraSub": "CBD 方式では、荷役費、輸送費、追加資材、FF CMT はベース価格に含まれます。上乗せして請求されるのは MOQ 割増と短納期割増のみです。",
      "cbdMsrpNote": "目標 MSRP {{msrp}} は T2 の {{x}} 倍です。",
      "cbdSetMarkup": "T2 マークアップ",
      "cbdOrderValue": "T2 での注文金額",
      "cbdOrderValueRule": "T2 × 数量を全 SKU で合計",
      "cbdFactoryAmt": "仕入先コスト合計",
      "cbdFactoryAmtRule": "仕入先コスト × 数量 — 仕入先は、誰が負担するかにかかわらず両方の割増を請求します",
      "cbdAbsorbedAmt": "HPAC が負担する割増",
      "cbdAbsorbedRule": "このカードで T2 から除外した割増の、注文全体での合計",
      "cbdGpRule": "T2 での注文金額 − 仕入先コスト合計",
      "cbdMarginRule": "粗利 ÷ T2 での注文金額",
      "cbdCard_A": "パートナーが両方の割増を負担",
      "cbdCard_B": "HPAC が両方の割増を負担",
      "cbdCard_HM": "HPAC が MOQ 割増を負担",
      "cbdCard_HL": "HPAC が短納期割増を負担",
      "cbdCardWho_A": "MOQ 割増と短納期割増を T1 と T2 に加算します。",
      "cbdCardWho_B": "両方の割増を T1 と T2 から除外し、HPAC が工場に支払います。",
      "cbdCardWho_HM": "MOQ 割増は T1 と T2 から除外し、短納期割増は請求します。",
      "cbdCardWho_HL": "短納期割増は T1 と T2 から除外し、MOQ 割増は請求します。",
      "padPerUnitHead": "1個あたり",
      "cbdOfferBox": "オファー — 見積全体",
      "padLiveDraft": "まだ提出されていません。これは固定されたコピーではなく、計算ツール上の現在の見積です。",
      "cbdSlYesHint": "短納期 = はい：Offer Sheet の請求方法に従い、仕入先 CMT（人件費）の{{pct}}%。",
      "cbdSlNoHint": "短納期 = いいえ：割増なし。",
      "cbdPartner": "パートナー",
      "cbdSeason": "シーズン",
      "cbdTerm": "価格条件",
      "cbdValidFrom": "有効開始日",
      "cbdValidTo": "有効終了日",
      "cbdColor": "カラー",
      "cbdSlFlag": "短納期",
      "cbdSlAuto": "リードタイムから自動判定（{{rate}}）",
      "cbdSlYes": "はい — CMT の 50%",
      "cbdSlNo": "いいえ",
      "cbdKeyPoints": "判断のポイント",
      "cbdKpMargin": "加重マージン（T2 基準）{{pct}}%、T2 売上合計 {{rev}}（仕入先コスト比の粗利 {{gp}}）。",
      "cbdKpLowest": "最低マージン：{{name}}（{{pct}}%）。",
      "cbdKpT0": "仕入先コスト = Base + Frame + MOQ 割増 + 短納期割増。",
      "cbdStripTitle": "価格、利益、マージン",
      "cbdStripWhole": "見積全体",
      "cbdStripAsCard": "見積全体、価格設定：{{card}}",
      "cbdStripTry": "マージンを試す",
      "cbdStripTryHint": "販売価格 = 仕入先コスト ÷ (1 − マージン)、ドル単位に切り上げ。マージンを試しても見積は変更されません。",
      "cbdStripClear": "クリア",
      "cbdStripNow": "見積どおり",
      "cbdStripAt": "マージン{{pct}}%の場合",
      "cbdStripPrice": "販売価格（T2）",
      "cbdStripProfit": "利益 / 個",
      "cbdStripMargin": "マージン",
      "cbdStripInline": "Inline 小売価格",
      "cbdStripTotal": "注文",
      "cbdStripQty": "数量（EA）",
      "paS1": "1. Inline との価格オプション比較 — USD/pc",
      "paS1Kind": "オプション1〜2は Sales/Costing が作成 · 最後のオプション：YL が粗利率 % を入力",
      "paOption": "オプション",
      "paOptionN": "オプション{{n}}",
      "paItem": "品名 / カラー",
      "paStyle": "スタイルコード",
      "paQty": "数量（pcs）",
      "paCost": "仕入原価",
      "paOh": "HPAC 諸経費",
      "paT1": "T1 価格（HPAC → 他の Helinox 法人）",
      "paInlineT1": "Inline T1 価格",
      "paT1vs": "T1 と Inline T1 の比較",
      "paInlineMsrp": "Inline MSRP",
      "paPartnerMsrp": "パートナー MSRP（参考）",
      "paGmIn": "粗利率 %（YL 入力）",
      "paT2": "T2 価格",
      "paGp": "粗利 /pc",
      "paGm": "粗利率 %（T2 基準）",
      "paNet": "純利益率 %（HPAC 諸経費控除後）",
      "paNetTot": "純利益率 %（合計）",
      "paSales": "売上合計（USD）",
      "paGpTot": "粗利合計（USD）",
      "paOfMsrp": "パートナー MSRP に対する T2 の割合 %（参考）",
      "paCheck": "T2 ≥ T1 チェック",
      "paApprove": "承認（YL ✔）",
      "paBelow": "T1 未満",
      "paOptTotal": "オプション合計",
      "paOpt1": "パートナーが割増を負担",
      "paOpt1Sub": "標準の計算式、割増を転嫁",
      "paOpt2": "HPAC が割増を負担",
      "paOpt2Sub": "標準の計算式",
      "paOptGm": "YL の判断",
      "paOptGmSub": "T2 基準の粗利率 % — ここに入力",
      "paOptOSub": "Sales/Costing が作成した原価計算。パートナーが割増を負担する前提で価格設定",
      "paTick": "これを承認",
      "paApproved": "承認済みオプション",
      "paApproveOne": "オプションを1つだけ選択してください",
      "paGmAll": "全アイテム共通の1つのマージン",
      "paGmEach": "アイテムごとのマージン",
      "paGmToAll": "全件に同じ値を適用",
      "paYlOnly": "YL が Pricing Approval でここからオプションを1つ選択します",
      "paSwitch": "代わりにこちらを選択",
      "paNote1": "仕入原価 = MOQ 割増と短納期割増を含め、Helinox が工場に支払う価格。T1 と Inline T1 の比較 = 同等の Inline スタイルとの差（%）。",
      "paNote2": "粗利率 % = (T2 − 仕入原価) ÷ T2（マークアップではなく販売価格に対するマージン）。純利益率 % = (T2 − 仕入原価 − HPAC 諸経費) ÷ T2。YL がオプション{{n}}の粗利率 % を入力すると、すべての結果が即座に更新されます。",
      "paNote3": "{{partner}} MSRP（参考）= Inline MSRP × {{pct}}%、参考値のみ。「T1 未満」= T2 が Collab の T1 を下回る状態。承認列の ✔ は1つのオプションにのみ付けてください。",
      "paNoInlineT1": "この見積には Inline T1 価格がまだありません。T1 を Inline スタイルと比較できるよう、Sales/Costing が計算ツール（Inline T1 価格）に入力してください。",
      "paGrpShow": "Inline の列を表示（Inline T1、T1 と Inline の比較、Inline MSRP、パートナー MSRP）",
      "paGrpHide": "Inline の列を折りたたむ",
      "paPartnerWord": "パートナー",
      "paHProject": "プロジェクト",
      "paHPartner": "パートナー（T2 顧客）",
      "paHSeason": "シーズン",
      "paHFactory": "工場",
      "paHPrepared": "作成者",
      "paHReviewed": "確認者",
      "paHPriceTerm": "価格条件",
      "paHCurrency": "通貨",
      "paHLead": "総リードタイム（日）",
      "paHApprover": "承認者",
      "paApprovedBy": "承認者",
      "paApprovalDate": "承認日",
      "paYlComments": "YL コメント",
      "paYlCommentsPh": "任意 — チェックしたオプションとともに保存されます",
      "paS2": "2. マージン感度 — 粗利率 % ごとの T2 と利益",
      "paS2Kind": "T2 = 仕入原価 ÷ (1 − マージン)、切り上げ",
      "paS3": "3. 承認",
      "paApprovedOpt": "承認済みオプション",
      "paApprovedT2": "承認済み T2 — {{name}}（USD/pc）",
      "paNoneYet": "未承認 — 上のオプションを1つだけチェックしてください",
      "paExport": "Price Approval をエクスポート（Excel）",
      "paExportHint": "この見積を Linda の Price Approval テンプレートに数式付きで出力します。YL はファイル内でもマージンを入力できます。",
      "inlineT1": "Inline T1 価格",
      "inlineT1Hint": "同等の Inline スタイルの T1 — 承認シートはこれと Collab の T1 を比較します",
      "styleCode": "スタイルコード",
      "cbdFactoryName": "工場",
      "cbdStripVsInline": "Inline 小売価格に対する %",
      "cbdKpInline": "販売価格（T2）は Inline 小売価格の{{pct}}%です。",
      "cbdKpInlineSome": "（Inline 小売価格のない SKU：{{n}}件）",
      "cbdStripUse": "この価格を指示に入れる",
      "cbdStripUseHint": "下の「指示」欄に入ります。条件カードでこの価格を承認してください。",
      "cbdStripInstr": "T2 基準のマージン{{pct}}%での価格（仕入先コスト ÷ (1 − マージン)、切り上げ）：{{list}}。注文金額 {{rev}}、利益 {{gp}}。",
      "cbdKpLead": "リードタイム{{days}}日（PO {{po}} → 工場出荷 {{xf}}）。",
      "cbdKpAbsorbs": "HPAC が負担：{{what}}。",
      "cbdKpAbsorbsNone": "HPAC が負担：なし — すべての割増をパートナーに請求。",
      "cbdOffer": "パートナーオファー（Excel）",
      "cbdOfferTitle": "パートナーへのオファー：品名、カラー、数量、T2 価格のみ — コストデータは含みません",
      "cbdOfferNeedSave": "先に見積を保存してください",
      "cbdOfferNeedApproval": "見積の承認後に利用できます",
      "cbdOfferNeedCard": "カードを選択後に利用できます",
      "cbdOfferTerms": "別の条件が選ばれています — 指示からオファーを作成してください",
      "cbdB7": "割増の負担者 — 注文全体 {{n}} EA で{{amt}}",
      "cbdB7Note": "工場は、誰が負担するかにかかわらず MOQ 割増と短納期割増を請求します。A〜D は Calculation シートの4つの回答で、上のオプションはもう1枚のカード（パートナーが両方を負担する前提の価格設定）です。",
      "padOrderHead": "注文（{{qty}} EA）",
      "rule_cbd_oh_pct": "CBD · HPAC 諸経費 %",
      "rule_cbd_t2_markup_pct": "CBD · T2 マークアップ %（30 = × 1.3）",
      "padB7NoteCalc": "A、B、C はすべての見積に表示されます。追加分を別の方法で分担する場合は、上でオプションを追加してください。ここと承認者の画面にカードがもう1枚増えます。",
      "padB7Note": "パートナー卸チャネルのみに適用されます。A、B、C のいずれでも MSRP {{m}} とパートナー単価 {{p}} は変わらず、1個あたり{{e}}の追加分の負担先だけが動きます。",
      "padKindCompare": "比較",
      "padKindSolo": "Collab のみ · 比較なし",
      "padThisQuote": "この見積",
      "padCompareOnly": "比較のみ",
      "padInlineShort": "Inline",
      "padSameWord": "同じ",
      "padNoBench": "ベンチマークなし",
      "padNoneWord": "なし",
      "padFactory": "工場コスト",
      "padFrame": "フレームコスト",
      "padFactoryN": "工場コスト（2）",
      "padFrameN": "フレームコスト（3）",
      "padExtraN": "追加コスト（4）",
      "padExtraPerUnit": "1個あたりの追加コスト",
      "padBaseFrom": "= 工場 {{f}} + フレーム {{r}}",
      "padBaseSub": "工場 + フレーム",
      "padPctOfTotal": "合計の{{n}}%",
      "padMultBase": "ベースのみ：Collab は Inline の{{x}}倍",
      "padMultAll": "追加分込み：Inline の{{x}}倍",
      "padLead": "ベースは近い水準です。問題は追加分です。",
      "padOwnRetailSub": "HINC などは MSRP で販売",
      "padPartnerWs": "パートナー卸",
      "padPartnerWsSub": "MSRP の{{p}}%で供給",
      "padCallout": "自社小売は追加分を負担しても{{pct}}%を確保できます。パートナー卸では原価割れになります。パートナー側で誰が追加分を払うかは、ブロック7で決めます。",
      "padMsrp": "MSRP",
      "padPartnerUnit": "パートナー単価",
      "padExtraBilledUnit": "+ 請求する追加分",
      "padPerUnit": "/個",
      "padExtraAbsorbed": "Helinox が負担する追加分",
      "padGrossSub": "= O.H + 純利益",
      "padWhoA": "追加分は正味原価で別行として請求します。マージンは乗せません。",
      "padWhoB": "追加分は HPAC のマーケティングコストとして計上します。パートナーには単価のみ表示されます。",
      "padWhoC": "半分をパートナーに請求し、半分を Helinox が負担します。",
      "padCeoDecision": "CEO の決定",
      "padCeoDecisionSub": "承認とともに記録されます。依頼者はこの条件で見積を仕上げます。再提出は不要です。",
      "padDrowFinal": "最終条件",
      "padDrowRecorded": "記録済み",
      "padOpenCalc": "計算ツールで開く",
      "approverView": "承認者に表示される内容",
      "approverViewSub": "Pricing Approval 画面が描画するものと同じ2つのブロックを、同じ数値で表示します。閲覧のみで、数値は上で入力します。",
      "padSubmittedBy": "提出者",
      "padNoSnapshot": "この見積は数値が固定される前に提出されたため、表示できる記録がありません。計算ツールで開くと現在の状態を確認できます。",
      "padFrozen": "以下の数値は、承認依頼として提出されたものです。",
      "padEdited": "この見積は送信後に編集されています。",
      "padLine": "項目",
      "padCollab": "Collab",
      "padInline": "Inline",
      "padGap": "差",
      "padBase": "ベースコスト",
      "padExtra": "追加コスト",
      "padExtraNote": "Inline の生産では発生しません",
      "padTotal": "1個あたりの総コスト",
      "padOrder": "注文合計 · {{qty}} EA",
      "padPriceMargin": "価格とマージン",
      "padOwnRetail": "自社小売",
      "padPartner": "パートナー卸 · MSRP の{{pct}}%",
      "padWeSell": "販売価格",
      "padMarginPre": "追加分を含める前のマージン",
      "padMarginPost": "追加分を含めた後のマージン",
      "padWhoCarries": "追加分の負担者 — {{qty}} EA で{{total}}",
      "padWhoSub": "パートナー卸チャネルのみ。MSRP {{msrp}} とパートナー単価 {{unit}} はどのオプションでも変わらず、動くのは追加分だけです。",
      "padOptA": "A · パートナーが追加分を負担",
      "padOptB": "B · Helinox が負担",
      "padOptC": "C · 50 / 50 で分担",
      "fxBilledRule": "追加分 × パートナーが負担する割合",
      "fxRevenueRule": "各 SKU の数量 × MSRP を注文全体で合計",
      "fxAbsorbedRule": "追加分 − パートナーへの請求額",
      "fxGrossRule": "パートナー売上 + 請求する追加分 − 総コスト",
      "fxOhRule": "注文のベースコスト × O.H 率",
      "fxNetRule": "粗利 − Helinox O.H",
      "fxMarginRule": "純利益 ÷ パートナー売上",
      "padGate": "この見積を承認しますか？",
      "padGateSub": "現在のステータスは {{status}} です。次のステップで SKU ごとに判断し、メモを添えます。",
      "padGateApprove": "承認",
      "padGateReject": "差し戻し",
      "padGateCancel": "そのままにする",
      "padOtherCostings": "この見積には他に{{n}}件の原価計算があります",
      "padOtherCostingsSub": "計算ツールで作成した、同じ見積の別の原価計算です。カード A と比較できるよう、それぞれ A の条件で価格設定されています。1つを選ぶと、パートナーが追加分を負担する前提でその原価計算を採用することになります。",
      "padRefAt": "A の条件で価格設定 · パートナーが追加分を負担",
      "padSettings": "これらの数値の算出に使用した設定",
      "padSetPremium": "Collab プレミアム",
      "padSetPartner": "パートナーマージン",
      "padSetSplitC": "分担比率（カード C）",
      "padSetOh": "Helinox O.H",
      "padSetOhVal": "ベースコストの{{pct}}%",
      "padSetCase": "ケース",
      "padOptTerms": "その他の条件",
      "padOptTermsSub": "上のカードに当てはまるものがありませんか？下の「指示」欄に条件を書いてください。依頼者がそのテキストをもとに見積を仕上げます。",
      "padSrcPortal": "ポータルの既定値",
      "padSrcQuote": "依頼者が追加",
      "padSrcApprover": "条件を自分で記入",
      "padSumHead": "この見積の{{all}} SKU のうち{{n}}件を承認します",
      "padSumCard": "追加分の負担者",
      "padSumQty": "承認数量",
      "padSumNoCard": "まだカードが選ばれていないため、この承認は SKU のみを確定し、追加分は未配分のままになります。",
      "padSumNothing": "すべての SKU が取り消されています。見積全体は「差し戻し」を使ってください。",
      "padSumUnread": "そのうち{{n}}件はまだ開いていません。",
      "padSkuUnseen": "未確認",
      "padSkuCut": "除外",
      "padSkuSeen": "この見積の{{all}} SKU のうち{{n}}件を確認しました",
      "padSkuAllSeen": "{{n}} SKU をすべて確認しました",
      "padSkuCutN": "以前に{{n}}件を除外済み",
      "padCardScope": "これらの数値は、見積の{{all}} SKU すべてではなく、残っている{{n}} SKU が対象です。",
      "padCardGone": "— このオプションは見積から削除されています",
      "padBilled": "請求する追加分",
      "padRevenue": "売上（数量 × MSRP）",
      "padAllIn": "パートナー支払額（全込み）",
      "padGross": "注文の粗利",
      "padOh": "Helinox O.H · ベースコストの{{pct}}%",
      "padNetProfit": "注文における Helinox の純利益",
      "padNetMargin": "純利益率 · パートナー価格に対する %",
      "padSelect": "{{key}} を選択",
      "padDecision": "記録された決定",
      "padChosen": "追加分の負担者",
      "padUndecided": "未決定",
      "padInstruction": "指示",
      "padInstructionPh": "例：A で進めるが、パートナー単価は $60 に丸め、追加分は一括で請求する。",
      "padSaveInstruction": "指示を保存",
      "padDecisionSaved": "決定を記録しました。",
      "padMemo": "Sales OP 最終メモ",
      "padMemoSub": "上の決定を確認したうえで合意した最終価格と条件です。記入は1回のみで、後から編集できません。",
      "padMemoPh": "合意した最終価格と条件…",
      "padMemoWaitShort": "未記録",
      "padMemoWait": "この見積については、まだ何も決定されていません。",
      "padMemoSave": "メモを記録",
      "padMemoSaved": "メモを記録しました。",
      "modeRules": "価格設定ルール",
      "modeRulesSub": "Admin · すべての見積の価格設定に使う定数",
      "rulesTitle": "価格設定ルール",
      "rulesSub": "変更は、保存後に作成される見積に適用されます。すでに作成済みの見積は価格設定時のルールを保持するため、見積済みの内容は動きません。",
      "ruleName": "ルール",
      "ruleNow": "現在の値",
      "ruleNew": "新しい値",
      "ruleWhy": "理由",
      "ruleWhyPh": "変更する理由は何ですか？",
      "ruleSave": "保存",
      "ruleSaved": "保存しました。今後作成する見積は新しいルールを使用します。",
      "ruleHistory": "すべての変更履歴（新しい順）",
      "ruleValue": "値",
      "ruleBy": "変更者",
      "ruleFrom": "適用開始",
      "rule_partner_ratio_pct": "パートナー価格",
      "ruleHint_partner_ratio_pct": "MSRP に対するパートナー価格の割合です。",
      "rule_tier_oh_pct": "Helinox O.H",
      "ruleHint_tier_oh_pct": "階層別比率のうち諸経費にあたる部分です。新しい見積の初期値になり、保存済みの見積は自身の値を保持します。",
      "rule_frame_profit_pct": "フレーム利益",
      "ruleHint_frame_profit_pct": "フレームコスト × この率。フレームが無償支給の場合は適用されません。",
      "modeSaved": "保存済みプロジェクト",
      "modeSavedSub": "閲覧 · 読み込み · Excel にエクスポート",
      "modeOpa": "OPA / SCT",
      "modeOpaSub": "作業分析 · 標準サイクルタイム",
      "projectPlaceholder": "プロジェクト名 — 例：26FW MICRO KICKBOARD x Chair One (re)",
      "template": "テンプレートをインポート",
      "importExcel": "Excel をインポート",
      "importBom": "仕入先 BOM をインポート",
      "bomRead": "{{vendor}} の BOM として読み込みました — {{n}} SKU（{{names}}）",
      "bomFailed": "この BOM を読み込めませんでした",
      "bomLookedFor": "ポータルは2種類の仕入先フォーマットに対応しており、次を探しました：",
      "bomSheets": "このファイルのシート：{{list}}",
      "dismiss": "閉じる",
      "imported": "ファイルから{{n}} SKU を読み込みました。数値を確認してから「プロジェクトを保存」を押してください。",
      "save": "プロジェクトを保存",
      "saveChanges": "変更を保存",
      "newProject": "新規プロジェクト",
      "exportExcel": "Excel をエクスポート",
      "savedAs": "{{id}} として保存しました。次の入力に進めます。",
      "loaded": "{{id}} を読み込みました。保存すると更新され、その後画面がクリアされます。",
      "needName": "先にプロジェクト名を入力してください。",
      "needSave": "先にプロジェクトを保存してください。エクスポートは保存済みの内容を読み込みます。",
      "deleteAsk": "{{id}} を削除しますか？一覧からは消えますが、原価計算自体は保持されます。",
      "sku": "SKU",
      "addSku": "SKU を追加",
      "duplicate": "複製",
      "del": "削除",
      "inputs": "入力",
      "collapse": "折りたたむ",
      "expand": "展開",
      "results": "結果",
      "skuName": "SKU / 品名",
      "skuNameHint": "プロジェクト内でこのアイテムを識別する名前です。",
      "qty": "注文数量（EA）",
      "qtyHint": "MOQ 割増と HPAC 借方の算出に使われます。",
      "poDate": "PO 発行日",
      "poDateHint": "リードタイムの起点です。",
      "xfDate": "希望 XF 日",
      "xfDateHint": "XF − PO = リードタイム。",
      "moqLabel": "MOQ",
      "moqNone": "500 pcs 以上 → 割増なし",
      "moqApplied": "{{qty}} pcs → {{of}} の {{rate}}",
      "moqQtyPcs": "{{qty}} pcs →",
      "moqOfBase": "{{of}} の",
      "leadLabel": "リードタイム",
      "leadNone": "両方の日付を入力すると計算されます",
      "leadDays": "{{days}}日 → 短納期 {{rate}}",
      "leadWarn": "{{days}}日は60日未満のため、ガイドラインでは価格設定されていません。仮に50%を適用していますが、割増は交渉が必要です。",
      "baseTitle": "マークアップベースコスト",
      "baseSub": "マージンはこれらと FM 手数料のみを基準に算出します。",
      "skin": "Skin + Case + 梱包",
      "skinHint": "生地の Skin、Case、Packaging の合計です。",
      "cmt": "仕入先 CMT",
      "cmtHint": "仕入先の縫製工賃（Cut · Make · Trim）。",
      "ohp": "仕入先 OH と利益",
      "ohpHint": "仕入先の諸経費とマージンです。",
      "frame": "フレームコスト",
      "frameHint": "モデルを選ぶと、フレーム価格表から自動入力されます。",
      "framePick": "フレームモデルを選択…",
      "frameSupply": "フレームの調達方法",
      "supplySell": "仕入先に販売",
      "supplySellHint": "フレーム利益 + 荷役費 $0.50 + 運賃（p.19）",
      "supplyFoc": "無償支給（FOC）",
      "supplyFocHint": "FM 手数料 $0.04 のみ（p.13、p.20）",
      "matSupply": "資材の調達方法",
      "matVendor": "仕入先が購入",
      "matVendorHint": "生地、Case、Packaging は仕入先自身の購入品です。",
      "matFf": "Helinox が支給（FF）",
      "matFfHint": "資材は仕入先の負担がないため、代わりに FF CMT 手数料を請求します。",
      "frameProfitRate": "フレーム利益率",
      "excludedTitle": "除外項目",
      "excludedSub": "Inline の生産では発生しないコストです。T1 のマージンベースに含まれ、HPAC マーケティング借方としてパートナーからも回収されます。T2 はこれらを除いて価格設定されます。フィールドに入力すると、そのフィールドに限りルールを上書きします。",
      "autoToggle": "ガイドラインから自動",
      "autoTag": "自動",
      "resetOverride": "手動 — リセット",
      "fprofit": "フレーム利益",
      "fprofitHint": "フレームコスト × 利益率。フレームが無償支給の場合はゼロです。",
      "handling": "荷役費",
      "handlingHint": "Helinox がフレームを仕入先に販売する場合は $0.50（p.19）。",
      "fmfee": "FM 手数料",
      "fmfeeHint": "フレームが無償支給の場合は $0.04（p.13、p.20）。ベースコストに含まれます。",
      "transport": "輸送費",
      "transportHint": "実際の運賃です。推測では入力しません。",
      "moqCharge": "MOQ 割増",
      "moqChargeHint": "マークアップベース x MOQ 率（p.15）。",
      "addMat": "追加資材",
      "addMatHint": "ベースに含まれない、注文に必要なものすべて。",
      "ffcmt": "FF CMT 手数料",
      "ffcmtHint": "Helinox が支給する資材に対する仕入先の工賃です。割増の後に加算されます。",
      "ffcmtOff": "Helinox が資材を支給する場合のみ — 「資材の調達方法」を参照してください。",
      "shortLead": "短納期割増",
      "shortLeadHint": "仕入先 CMT x (1 + MOQ 率) x 短納期率（p.21）。",
      "moqBaseLabel": "MOQ 割増の対象",
      "moqBaseHint": "この仕入先が割増に含めず、割増の後に加算する項目はチェックを外してください。",
      "part_skin": "Skin + Case + 梱包",
      "part_cmt": "仕入先 CMT",
      "part_ohp": "OH と利益",
      "part_frame": "フレーム",
      "part_fmfee": "FM 手数料",
      "pricingTitle": "価格設定",
      "stepProfit": "利益 / MSRP シミュレーター",
      "stepTarget": "目標 MSRP",
      "t1Ratio": "HPAC 外部利益（T2 比率）",
      "t1RatioHint": "ベースへのマークアップではなく、T2 に対するマージンです。ケース A では必須。",
      "t0Ratio": "HPAC 内部利益（T1 比率）",
      "t0RatioHint": "Helinox 法人の階層です。ケース B では必須。",
      "options": "オプション",
      "optionsNote": "各オプションは、この見積の1〜2項目の回答を変えたものです。上の数値すべてに連動します。",
      "optionAdd": "オプションを追加",
      "optionN": "オプション{{n}}",
      "optAsQuoted": "この見積",
      "optAsQuotedSub": "上で入力した数値",
      "optNoCond": "まだ変更はありません",
      "optSameAsQuote": "見積と同じです。左の値を変更すると、これらの数値も動きます。",
      "optEdit": "条件",
      "optCancel": "キャンセル",
      "optDone": "完了",
      "optRemove": "削除",
      "optCondNote": "ここで任意の値を変更できます。そのままの項目は見積に連動します。",
      "optQuoteReadOnly": "見積自体の回答です。オプションと照合するために表示しており、変更は上のブロックで行ってください。",
      "optClose": "閉じる",
      "optOrderProfitT1": "T1 での注文利益",
      "optOrderProfitT2": "T2 での注文利益",
      "optQty": "注文数量",
      "optBasis": "マージンの算出基準",
      "optT1Profit": "T1 利益",
      "optT2Ratio": "T2 比率",
      "optCbdMargin": "T2 基準のマージン",
      "optT2Profit": "T2 利益",
      "optPremium": "Collab プレミアム",
      "optShortLead": "短納期割増",
      "benchTitle": "Inline ベンチマーク",
      "benchTag": "比較のみ",
      "benchLine": "コスト項目",
      "benchThis": "この見積",
      "benchInline": "Inline 製品",
      "benchDiff": "差",
      "vsInline": "Inline 小売価格との比較",
      "linesApplied": "このオプションが請求する追加コスト1の項目",
      "qtyWord": "注文数量",
      "targetHint": "Inline 小売価格 × (1 + Collab プレミアム)",
      "lineDropped": "請求なし",
      "inclTitle": "マージンの算出基準に含まれる金額",
      "exclTitle": "基準の外 — HPAC マーケティング借方として回収",
      "inclBoth": "マージンベースにも含まれるため、二重に回収されます",
      "inclTotal": "マージンの算出基準",
      "exclTotal": "パートナーへの借方",
      "quotedIn": "マージン対象",
      "quotedOut": "マージン対象外",
      "estIsCheck": "見積の MSRP ではなく、検算用の値です。下流では参照されません。この見積の MSRP はブロック6にあります。",
      "msrpIsQuote": "見積の MSRP",
      "factoryWord": "工場",
      "frameWord": "フレーム",
      "marginAtQty": "{{n}} EA でのマージン",
      "gapWord": "差",
      "collabCol": "Collab",
      "benchCol": "Inline",
      "benchTotal": "工場コスト",
      "benchWhy": "両者に差がある理由",
      "benchWhyHint": "Inline 版と比べてコラボで加わるもの、除かれるものです。承認者が差の横で読む説明文になります。このステップでは見積は変更されません。",
      "ohPart": "O.H",
      "ohPartFixed": "O.H（固定）",
      "frameModelLabel": "フレームモデル",
      "benchLinkedTo": "連動先",
      "benchNoModel": "フレームモデル未選択",
      "benchFollowsFrame": "ブロック3で選んだフレームモデルに連動",
      "benchFromCollab": "Collab から",
      "benchFrameHint": "Inline 製品が使うフレームを、そのフレーム自身の定価で計算します。",
      "benchModelHint": "ブロック3に連動します。同じ部品のため、差は設計ではなく価格によるものです。",
      "benchSame": "同じ",
      "benchBase": "ベース",
      "blkExtra": "追加分",
      "fxBuying": "マージン前の1個あたりのコスト",
      "fxBuyingRule": "ベースは工場 + フレームで、階層別比率の算出基準となる数値です。追加コストはマージンの後に加算され、マークアップされません。この2つを合わせたものが仕入原価です。",
      "fxBenchBase": "Inline コスト（Skin + CMT + OH と利益 + フレーム）",
      "fxBenchBaseRule": "Inline 製品自身の工場コストに、そのフレームを定価で加えたものです。以降の加算はありません。Inline 側には追加コストの設定がないためです。",
      "benchFrameLabel": "フレームコスト",
      "benchImport": "コストシートから入力",
      "benchImportHint": "Inline コストシートに登録済みのコストシートから、この列を入力します。",
      "benchSrc": "参照元",
      "benchPickTitle": "この見積はどの行と比較しますか？",
      "benchPickBody": "{{file}} には{{n}}行の価格があります。この見積の比較対象を選んでください。各行の数値は、シート自身が記載している仕入原価です。",
      "benchVariant": "コストバージョン",
      "benchApply": "ベンチマークに入力",
      "benchRefused": "{{n}}行は、各列の合計が隣に印字された仕入原価と一致しないため、読み込めませんでした：",
      "benchLibBody": "Inline コストシートに登録済みのコストシートを、スタイル、SKU、カラーウェイ、ファイル名で検索します。",
      "benchSearch": "スタイル、SKU、カラーウェイ、ファイルを検索…",
      "benchNewFile": "新しいファイルを読み込む…",
      "benchBackToLib": "ライブラリに戻る",
      "benchLibEmpty": "登録済みのコストシートはまだありません。Sales Operation → Inline コストシートで読み込みます。",
      "benchNoHit": "ライブラリに「{{q}}」に一致するものはありません。",
      "benchLineCol": "行",
      "benchWhyCol": "説明",
      "benchWhyPh": "両者に差がある理由",
      "benchNoGap": "差なし — 説明は不要です",
      "benchAllLevel": "すべての行が Inline 製品と一致しています。説明は不要です。",
      "benchNotFilled": "Inline ベンチマークを入力すると、両者の差がわかります。",
      "benchElsePh": "その他…",
      "benchBomSub": "Collab 価格と Inline 価格の BOM の違い。",
      "stepExtra2": "追加コスト2",
      "stepExtra2Sub": "（コスト比較）",
      "addMatWhat": "内容…",
      "addLine": "行を追加",
      "removeLine": "この行を削除",
      "ohLine": "Helinox O.H",
      "profitLine": "Helinox 利益",
      "extraLine": "追加コスト",
      "extraFromBlock": "ブロック4より",
      "inclExtra": "O.H + 利益 + 追加コスト — パートナーが支払う金額",
      "fxOpen": "{{what}}の算出方法",
      "fxFactory": "工場コスト",
      "fxFrame": "フレームコスト",
      "fxExtra": "追加コスト1",
      "t2Divide": "{{basis}} ÷ (1 − {{r}}%)",
      "t2ThisQuote": "この見積",
      "t2Both": "2つの原価計算方式のそれぞれに同じ比率を適用しています。見積では印の付いた方式を使用し、その選択はオプションで行います。",
      "t2BasisFromOpt": "オプションごとに設定",
      "fxT2": "T2 の価格設定方法",
      "fxT2Rule": "価格に上乗せするのではなく、価格の中から差し引くマージンです。基準を、1 から T2 比率を引いた値で割ります。保存済みのすべての見積がこの方式を使っており、T1 に使う積み上げ方式とは異なる数値になります。",
      "fxExtraAfter": "マージンの後に加算、マークアップなし",
      "fxT1Base": "工場コスト + フレームコスト + 追加コスト1",
      "t1BaseLine": "工場コスト + フレームコスト + 追加コスト1",
      "optExtraOff": "適用する追加コスト1の項目",
      "optExtraOffLbl": "なし",
      "optExtraOffNone": "すべて",
      "optExtraOffSome": "{{n}}件を除外",
      "t1Sum": "ベース + O.H + 利益",
      "fxT1On": "{{n}} を基準に算出",
      "fxOh": "Helinox O.H",
      "fxProfit": "Helinox 利益",
      "fxTier": "階層価格",
      "fxMsrp": "目標 MSRP",
      "fxLead": "リードタイム",
      "fxBenchProfit": "Inline 製品の利益",
      "fxMoq": "MOQ 割増",
      "fxSl": "短納期割増",
      "fxFprofit": "フレーム利益",
      "byOption": "同じ見積をオプション別に表示",
      "optPick": "このオプションで変更する内容：",
      "optName": "オプション名",
      "optNamePh": "オプション{{n}} — 皆がわかる名前を入力",
      "fxBenchRule": "Inline 製品自身のコストを、Collab の T1 利益率で計算します。ベンチマーク専用の率はありません。",
      "optDropCond": "オプションからこれを外す",
      "tierSubAny": "O.H + 利益 + 追加コスト（その列自身の率で計算）",
      "tierSubOwn": "O.H + 利益 + 追加コスト",
      "fxTimesQty": "1個あたり × 注文数量 — 1個ではなく注文全体です。",
      "fxDebitRule": "除外した項目すべてを、階層価格に上乗せしてパートナーに請求します。",
      "fxDebitInPrice": "借方計上はありません。この方式では、すでに価格に含まれています。",
      "profitSubOwn": "この階層が得る O.H と利益（1個あたり）",
      "ohShareAny": "うち O.H",
      "profitShareAny": "うち利益",
      "optSameShort": "見積と同じ",
      "revenueSubAny": "階層価格 × 注文数量 — 1個ではなく注文全体",
      "totalProfitSubAny": "1個あたりの利益 × 注文数量 — 売上から注文のコストを引いた額",
      "fxExtraRule": "除外した項目すべての合計です。",
      "fxMoqRule": "MOQ ベースに、注文数量が該当する率を掛けた額です。",
      "fxMoqBase": "MOQ ベース",
      "fxSlRule": "仕入先 CMT に、リードタイムが該当する短納期率を掛けた額です。",
      "extraInBase": "ベースに含む",
      "unit": "個",
      "totalWord": "合計",
      "estMsrp": "推定 MSRP：",
      "estTo": "〜",
      "estTimes": "倍 →",
      "targetMsrp": "目標 MSRP",
      "targetMsrpHint": "Inline 小売価格 × (1 + プレミアム)。",
      "msrpOverT1": "MSRP ÷ T1",
      "msrpOverT1Hint": "到達する倍率",
      "yTarget": "Y の目標",
      "yTargetHint": "Inline 価格との比率で設定する目標です。任意。",
      "collabVsInline": "Collab と Inline の比較",
      "blockResult": "結果 / オプション",
      "blockDetail": "数値の算出方法",
      "optConditions": "条件",
      "colCollab": "Collab",
      "colInline": "Inline ベンチマーク",
      "profitPart": "利益",
      "ohShare": "うち O.H（{{pct}}）",
      "profitShare": "うち利益（{{pct}}）",
      "dealCase": "ケース",
      "dealCaseHint": "どのコラボレーションモデルか。必須となる階層別比率が、これによって決まります。",
      "dealCasePick": "ケースを選択…",
      "dealCaseBoth": "両方",
      "dealCaseA": "ケース A：HPAC 直接コラボレーション",
      "dealCaseB": "ケース B：子会社主導のコラボレーション",
      "dealCasePath_both": "工場 → HPAC → パートナー   ·   工場 → HPAC → Helinox 子会社 → その市場",
      "dealCasePath_a": "工場 → HPAC → コラボレーションパートナー",
      "dealCasePath_b": "工場 → HPAC → Helinox 子会社 → 自市場",
      "dealCasePathLbl": "誰が誰に販売するか",
      "dealCaseWhat_both": "両方の経路を価格設定します。HPAC が購入して転売し、Helinox 子会社も自市場で販売します。両方の階層別比率が必須です。",
      "dealCaseWhat_a": "HPAC が工場から商品を購入し、コラボレーションパートナーへ直接販売します。間に Helinox 子会社は入らないため、HPAC の階層のみを価格設定します。",
      "dealCaseWhat_b": "Helinox 子会社（Helinox Inc.、Helinox Japan など）が HPAC から購入し、自市場で販売します。この2段目を、子会社の階層が価格設定します。",
      "needPhoto": "保存する前に、写真を1枚以上追加してください。",
      "needCase": "{{sku}}：ケースを選択してください。",
      "needT1": "{{sku}}：このケースでは T1 比率が必須です。",
      "needT2": "{{sku}}：このケースでは T2 比率が必須です。",
      "needInlineRrp": "{{sku}}：Inline 小売価格が必須です。",
      "needPremium": "{{sku}}：Collab プレミアムが必須です。",
      "marginBasis": "マージンの算出基準",
      "marginBasisBase": "マークアップベース（ガイドライン）",
      "marginBasisBuying": "仕入原価の合計（見積シート）",
      "marginBasisBaseHint": "除外項目は T2 の基準の外にあり、代わりに HPAC 借方として回収されます。",
      "marginBasisBuyingHint": "すべてにマークアップが乗るため、別途借方計上はありません。",
      "partnerRatio": "パートナー比率",
      "partnerRatioHint": "MSRPに対するパートナー価格の割合です。",
      "inlineRrp": "インライン小売価格",
      "productPage": "商品ページ",
      "folderPlaceholder": "フォルダ — 例：27SS",
      "folderNone": "未分類",
      "newFolder": "新規フォルダ",
      "newFolderPlaceholder": "フォルダ名",
      "renameFolder": "名前の変更",
      "renameFolderTitle": "{{name}}の名前を変更",
      "deleteFolderTitle": "フォルダ「{{name}}」を削除しますか？",
      "deleteFolderBody": "中の見積は保持され、未分類に戻ります。",
      "dragHint": "行をフォルダにドラッグすると振り分けられます。",
      "approvePricing": "価格を承認",
      "inlineRrpHint": "比較対象となるインライン商品の小売価格です。",
      "premium": "コラボプレミアム",
      "premiumHint": "コラボによる上乗せ分で、インラインRRPに対する%です。",
      "markupBase": "Markup Base",
      "markupBaseSub": "マージンの算出基礎となるコスト",
      "composition": "仕入先FOBの構成",
      "pricingResults": "価格計算結果",
      "buyingCost": "仕入原価合計",
      "buyingCostSub": "マークアップ基準＋除外項目",
      "hpacUnit": "HPACマーケティングコスト",
      "hpacUnitSub": "1個あたり",
      "hpacTotal": "HPACマーケティングコスト",
      "hpacTotalSub": "借方合計・1個あたり×注文数量",
      "t1": "T2（パートナーブランド）",
      "t1Sub": "マークアップ基準 ÷ (1 − T2比率)",
      "colStatus": "ステータス",
      "stDraft": "下書き",
      "colNo": "No.",
      "countAll_one": "{{count}}件の見積",
      "countAll_other": "{{count}}件の見積",
      "countOf": "{{n}}／{{total}}",
      "allTeams": "全チーム",
      "approvalTitle": "価格承認",
      "approvalSub": "2段階です：セールスマネージャー、次にCEO。ここにある見積は、誰かの対応待ちです。",
      "colTeam": "Sales OP",
      "colTrail": "履歴",
      "colSubmittedBy": "提出者",
      "colNote": "メモ",
      "colCreatedBy": "作成者",
      "colCreatedAt": "作成日時",
      "colModifiedBy": "更新者",
      "colModifiedAt": "更新日時",
      "selected": "{{n}}件選択中",
      "approveSelected": "選択項目を承認",
      "clearSelection": "クリア",
      "submitTitle": "{{id}}を提出",
      "submitBody": "{{who}}へのメモを追加してください。この価格にした理由や変更点などです。任意です。",
      "submitPh": "例：9月9日の仕入先見積を受けてフレームコストを更新",
      "recall": "取り下げ",
      "recallTitle": "{{id}}を取り下げ",
      "recallBody": "この見積を{{who}}の待ちキューから外して下書きに戻します。編集して再度送信できます。相手には、対応待ちではなくなったことがメールで通知されます。",
      "recallPh": "取り下げの理由（任意）",
      "remind": "リマインド",
      "remindTitle": "{{id}}のリマインド",
      "remindBody": "{{who}}に、この見積がまだ判断待ちであることをリンク付きのメールでお知らせします。作成者がCCに入ります。リマインドは1つの見積につき4時間に1回です。",
      "remindPh": "ひとことメッセージ（任意）。例：パートナーが金曜までに価格を必要としています",
      "remindSend": "リマインドを送信",
      "remindSent": "{{id}}のリマインドを{{to}}に送信しました。",
      "reminded": "{{who}}がリマインド・{{at}}",
      "remindCount": "これまでのリマインド：{{n}}回",
      "remindSoon": "{{who}}がすでにリマインドを送信済みです。次回は{{at}}以降に送信できます。",
      "noteFrom": "メモ",
      "noteManager": "マネージャー",
      "noteFinal": "最終承認者",
      "gateBy": "{{who}}が提出",
      "openMissing": "{{id}}はこの一覧にありません。すでに承認済みの可能性があります。",
      "deleted": "{{id}}を削除しました。",
      "deleteTitle": "このプロジェクトを削除しますか？",
      "deleteBody": "{{id}}は保存済み一覧から外れます。原価計算自体は保持され、管理者が復元できます。",
      "confirmDelete": "削除",
      "stagePending": "保留中",
      "stagePendingHint": "作成者の手元にあるもの。新しい下書きと差し戻されたものです。どちらかは行のステータスで分かります。",
      "stageManager": "セールスマネージャー — 承認",
      "stageManagerHint": "提出済みで、Sales OPチームのマネージャーの対応待ちです。",
      "stageFinal": "CEO — 承認",
      "stageFinalHint": "マネージャーが承認済みです。最終判断を待っています。",
      "stageDone": "承認済み",
      "stageDoneHint": "承認が完了しています。ここには誰かの対応待ちのものはありません。",
      "stageApproval": "承認",
      "approvedElsewhere": "承認済みの見積は完了した案件です。保存済みプロジェクトにあり、複製できます。",
      "queueMine": "あなたの対応待ち",
      "queueMineHint": "あなたの判断待ちです。承認すると次に進み、差し戻すには理由が必要です。",
      "queueBack": "差し戻し",
      "queueBackHint": "指摘された点を修正して、再度提出してください。",
      "queueDraft": "未提出",
      "queueDraftHint": "まだ誰にも依頼していない下書きです。",
      "queueWaiting": "他の担当者で進行中",
      "queueWaitingHint": "他の人の対応待ちです。「私の見積はどこ？」と聞かなくて済むように、ここに表示しています。",
      "queueDone": "承認済み",
      "queueDoneHint": "確定済みです。複製すると、元の見積を示す新しい下書きが作成されます。",
      "queueEmpty": "該当なし。",
      "trailSubmitted": "{{who}}・{{on}}",
      "trailManager": "セールスマネージャー：{{who}}・{{on}}",
      "trailFinal": "CEO：{{who}}・{{on}}",
      "trailNone": "未提出",
      "resubmit": "再提出",
      "gate": "承認",
      "goApproval": "価格承認画面を開く",
      "reload": "再読み込み",
      "loading": "読み込み中…",
      "stPendingmanager": "待ち：マネージャー",
      "stPendingCEO": "待ち：CEO",
      "stPendingcalculation": "待ち：計算",
      "stageCalc": "計算",
      "stageCalcHint": "Costingが仕入原価を付けて送付したものです。計算ステップで各アイテムのHPAC Overhead %とT2 Markup %を設定し、見積をセールスマネージャーに送るか、Costingに戻します。",
      "sentBackCalc": "計算ステップからCostingに戻されました",
      "submitBodyCalc": "CBDの見積は、まず計算ステップ（アイテムごとのHPAC Overhead %とT2 Markup %）のため{{who}}に送られ、その後{{mgr}}に送られます。メモを追加してください。この価格にした理由や変更点などです。任意です。",
      "calcOpen": "計算する",
      "calcSaved": "計算を保存しました。",
      "calcSent": "{{id}}を送信しました — {{status}}。",
      "calcReturned": "{{id}}をCostingに戻しました。",
      "calcTitle": "計算",
      "calcKindEdit": "各アイテムの2つの割合を設定してください",
      "calcKind": "{{who}}による計算",
      "calcNote": "仕入原価はCostingからの値です。HPAC OverheadとT2 Markupは基本価格＋フレームに適用され、追加料金とHelinox販売資材費はそのまま転嫁されます。空欄の割合にはルールの値（{{oh}}% / {{mk}}%）が使われます。",
      "calcProduct": "商品",
      "calcQty": "注文数量（pcs）",
      "calcBase": "基本価格",
      "calcFrame": "フレーム（Helinox販売資材）",
      "calcOhPct": "HPAC Overhead %",
      "calcOh": "HPAC Overhead",
      "calcMoq": "生産MOQ追加料金",
      "calcSl": "短納期追加料金",
      "calcFees": "Helinox販売資材費",
      "calcT1": "T1価格",
      "calcT1Amt": "T1金額（USD）",
      "calcMkPct": "T2 Markup %",
      "calcT2": "T2価格",
      "calcT2Amt": "T2金額（USD）",
      "calcProfit": "利益（USD/pc）",
      "calcProfitAmt": "利益額（USD）",
      "calcMargin": "マージン %",
      "calcColor": "カラー：{{c}}",
      "calcT2Raw": "丸め前：{{v}}",
      "calcTotal": "合計",
      "calcFoot": "T2はPrice Approvalシートと同様、ドル単位に切り上げられます。利益＝T2 − 仕入原価、マージン＝利益 ÷ T2です。",
      "calcBadPct": "割合は0〜300の範囲で入力してください。",
      "calcSave": "保存",
      "calcReturn": "Costingに戻す",
      "calcSend": "セールスマネージャーに送る",
      "calcSendNote": "セールスマネージャーへのメモ（任意）",
      "calcReturnWhy": "Costingで何を修正する必要がありますか？",
      "calcSendPh": "例：Tableはパートナーの数量を考慮して30%のまま",
      "calcReturnPh": "例：表のフレーム価格が前シーズンのものです",
      "calcSendSaves": "変更した割合が先に保存されます。",
      "calcCancel": "キャンセル",
      "calcSendGo": "送信",
      "calcReturnGo": "Costingに戻す",
      "stApproved": "承認済み",
      "stRejected": "却下",
      "sentBackMgr": "セールスマネージャーが却下",
      "sentBackCeo": "CEOが却下",
      "submit": "提出",
      "reject": "差し戻し",
      "revise": "複製",
      "view": "表示",
      "rejectTitle": "{{id}}を差し戻し",
      "rejectBody": "修正が必要な点を記入してください。差し戻された相手には、この内容だけが手がかりになります。",
      "nowStatus": "完了しました — 見積は現在{{status}}です。{{to}}",
      "revisedInto": "{{id}}に新しい下書きとしてコピーしました。",
      "leadWorked": "XF − PO＝{{days}}日 → 短納期{{rate}}",
      "stepOrder": "注文",
      "stepFactory": "工場コスト",
      "stepFrame": "フレームコスト",
      "stepOthers": "追加コスト1",
      "days": "日",
      "unitCost": "1個あたりのコスト",
      "share": "構成比",
      "bothConventions": "同じ見積を両方の基準で表示",
      "whatTheyPay": "各エンティティとパートナーの支払額",
      "marginTakenOn": "マージンの算出基準",
      "profitAtT1": "T1での利益",
      "profitAtT2": "T2での利益",
      "profitSub": "ティア価格からマージンの算出基準を引いた額（1個あたり）",
      "totalProfitAtT1": "T1での利益合計",
      "totalProfitAtT2": "T2での利益合計",
      "totalProfitSub": "1個あたり利益×{{qty}} EA — 売上から注文のコストを引いた額",
      "revenueAtT1": "T1での売上",
      "revenueAtT2": "T2での売上",
      "revenueSub": "ティア価格×{{qty}} EA — 1個ではなく注文全体",
      "gapNote": "{{tier}}では、2つの基準に{{gap}}の差があります。ガイドラインでは、1個あたり{{unit}}のその他コストはパートナーに別途請求され（{{qty}} EAで{{debit}}）、見積シートではすでに価格に含まれています。同じ金額が2か所に現れるため、見積にはどちらの基準かを明記する必要があります。",
      "basisLine": "{{name}}で提出 — ハイライトされた列が、承認者に承認を求める内容です。",
      "t0": "T1（Helinoxエンティティ）",
      "t0Sub": "マークアップ基準 ÷ (1 − T1比率)",
      "t0SubBuying": "仕入原価合計 ÷ (1 − T1比率)",
      "t1SubBuying": "仕入原価合計 ÷ (1 − T2比率)",
      "marginOnBuying": "仕入原価合計",
      "hpacTotalInPrice": "このマージン基準では価格にすでに含まれています",
      "msrp": "MSRP",
      "msrpSub": "インライン小売価格 × (1 + プレミアム%)",
      "partnerPrice": "パートナー価格",
      "partnerPriceSub": "MSRP × パートナー比率",
      "allSkus": "全SKU",
      "globalInputs": "グローバル入力",
      "licensedSub": "ライセンスモデルは、パートナーの店頭価格から逆算して価格を決めます。ロイヤルティは販売価格に対して支払われるため、重要なのはその後に残るマージンです。",
      "globalMsrp": "グローバルMSRP（USD）",
      "t1Fob": "T1 FOB",
      "logistics": "物流 %",
      "logisticsHint": "T1 FOBに加算して着荷原価を算出します。",
      "wholesale": "卸 %",
      "wholesaleHint": "現地SRPに対する卸価格の割合です。",
      "wsRoyalty": "WSロイヤルティ %",
      "wsRoyaltyHint": "卸価格に対するロイヤルティです。",
      "dtcRoyalty": "DTCロイヤルティ %",
      "dtcRoyaltyHint": "小売価格に対するロイヤルティです。",
      "landed": "着荷原価",
      "landedSub": "T1 FOB × (1 + 物流 %)",
      "entities": "エンティティ",
      "addEntity": "エンティティを追加",
      "entity": "エンティティ",
      "fx": "為替／USD",
      "localSrp": "現地SRP",
      "resultsByEntity": "エンティティ別結果",
      "resultsByEntitySub": "マージンはロイヤルティ前と後を表示します。その差がライセンスのコストです。",
      "srpUsd": "SRP（USD）",
      "wholesaleCol": "卸",
      "wsMargin": "WSマージン",
      "dtcMargin": "DTCマージン",
      "prePost": "前 → 後",
      "fobMult": "FOB ×",
      "addEntityFirst": "エンティティを追加してください",
      "colProject": "プロジェクト",
      "colName": "名前",
      "openQuote": "見積{{id}}を開く",
      "colMode": "モード",
      "colSkus": "SKU",
      "colSavedBy": "保存者",
      "colSaved": "保存日時",
      "general": "一般",
      "licensed": "ライセンス",
      "nothingSaved": "保存されたものはまだありません",
      "skuField": "SKU",
      "skuFieldHint": "計算する単一のアイテムです。",
      "globalMsrpHint": "グローバルの小売価格（USD）を1つ指定します。現地SRPはここから換算されます。",
      "t1FobHint": "仕入先との交渉後、物流費を含む前のエンティティ向け移転価格です。",
      "royaltyNote": "ロイヤルティはコストではありません。製品を作るのに必要な費用ではなく、販売後に売上から支払うブランド使用料です。そのため、コストに積み上げるのではなく、売上の下の独立した行として扱います。また、グループ内のT1移転（HPAC → 各エンティティ）には適用されません。製品が卸売業者や消費者など外部に出る場合にのみ発生します。",
      "burdenNote": "卸価格がSRPの50%の場合、卸ロイヤルティ11%は、DTCロイヤルティ5.5%と実質的に同じ負担になります。卸比率を変更するとこの等価関係が変わるため、両方の率をあわせて見直してください。",
      "autoFillSrp": "現地SRPを自動入力",
      "autoFillHint": "グローバルMSRP × 各為替レート。",
      "resetEntities": "リセット",
      "wholesalePrice": "卸価格",
      "dtcRoyaltyAmt": "DTCロイヤルティ",
      "wsRoyaltyAmt": "ロイヤルティ",
      "wsMarginLabel": "卸マージン",
      "dtcMarginLabel": "DTCマージン",
      "pre": "前",
      "lowMargin": "低マージン",
      "fobBadge": "FOB",
      "cancel": "キャンセル",
      "colAction": "操作",
      "colBuying": "仕入原価",
      "colT1": "T2",
      "edit": "編集",
      "clearFilters": "並べ替えとフィルターを解除",
      "discardTitle": "この原価計算を破棄しますか？",
      "discardBody": "画面上の内容は保存されていません。破棄すると消去され、空のプロジェクトが開始されます。",
      "keepEditing": "編集を続ける",
      "discard": "破棄"
    },
    "ask": {
      "launch": "Catchyに質問",
      "role": "AI生産性アシスタント",
      "note": "チャットはCatchyをより賢くするために使われます。",
      "moveHint": "ドラッグで移動・ダブルクリックで元の位置に戻す",
      "hello": "こんにちは、Catchyです。プロジェクト、SKUとその進行段階、サンプル、チケット、OPA / SCT、NFCトークン、売上など、画面で閲覧できる内容についてご質問ください。スクリーンショットの貼り付けもできます。",
      "s1": "今週期日のサンプルはどれですか？",
      "s2": "期限を過ぎているチケットはどれですか？",
      "s3": "Team 2のSKUでDelayedのものは何件ですか？",
      "hideSugs": "おすすめの質問を隠す",
      "showSugs": "おすすめの質問を表示",
      "otherSugs": "他の質問",
      "placeholder": "質問するか、スクリーンショットを貼り付けてください…",
      "send": "送信",
      "attach": "スクリーンショットを追加",
      "screenshot": "スクリーンショット",
      "screenshotReady": "スクリーンショットを添付済み",
      "remove": "削除",
      "lookingAt": "参照中：",
      "lookingAtHint": "Catchyは「これ」を、この画面で開いている項目と解釈します",
      "dropContext": "これなしで質問",
      "save": "チャットを保存",
      "newChat": "新規チャット",
      "expand": "拡大",
      "shrink": "縮小",
      "close": "閉じる",
      "you": "あなた",
      "leftToday_one": "本日あと{{count}}件質問できます",
      "leftToday_other": "本日あと{{count}}件質問できます",
      "noneLeft": "本日の質問回数を使い切りました。午前0時を過ぎてから再度お試しください。"
    },
    "ps": {
      "titleFor": "{{org}} サンプルトラッカー",
      "partner": "パートナー",
      "loading": "読み込み中…",
      "fills": "{{org}}が入力",
      "requiresReview": "{{reviewer}}のレビューが必要",
      "reviewerDefault": "デザイナー",
      "reviewerNote": "{{reviewer}}のレビュー：下のRound Outcomeにレビュー日と結果を記録してください。",
      "reviewDateHint": "{{reviewer}}がレビューを行った日",
      "internalOnly": "{{org}}社内レビューのみ",
      "internalNote": "{{org}}の社内レビュー記録には、レビュー日と備考を使用してください。このラウンドは、デザイナーの作業量や未回答のフィードバックには含まれません。",
      "internalReview": "{{org}}社内レビュー",
      "location": "場所",
      "allLocations": "すべての場所",
      "locationPh": "場所を選択または入力...",
      "createTitle": "新規サンプル — スタイル／アイテムを入力",
      "createSub": "新しいスタイルには次のBase ID（{{prefix}}-00001、{{prefix}}-00002…）が付与され、写真が必要です。既存のスタイルの場合は、そのBase IDにこのラウンドが追加されます。",
      "styleTypedHint": "ここで入力 — Base IDはスタイル名から付与されます",
      "pickPh": "例：{{prefix}}-00001-P1 または {{prefix}}-00001...",
      "pickNone": "該当するサンプルがありません。新規に作成するには、+ Create Sampleを使ってください。",
      "pickCompany": "このサンプルの対象会社を選択",
      "allCompanies": "すべての会社",
      "empty": "{{org}}のサンプルはまだありません。+ Create Sampleを押して最初のサンプルを作成してください。",
      "tourCreateB": "スタイル／アイテム名を入力し、写真を追加します。新しいスタイルには次のBase IDが付与され、既存のスタイルの場合はそのBase IDの下にラウンドが追加されます。その後、Sample Planを入力してください。",
      "tourFiltersB": "ステータス、担当者、場所で絞り込むか、検索ボックスに入力してください。クリアすると、列見出しのフィルターを含めてすべて元に戻ります。",
      "manual": "ユーザーマニュアル",
      "manualTitle": "このトラッカーのマニュアルを新しいタブで開きます — Tiếng Việt、English、한국어、中文、Français、日本語",
      "tourTabsT": "2通りの見方",
      "tourTabsB": "All Samplesは、各Base IDをラウンドとともに一覧表示します。Sample-level Summaryは、サンプルごとに1行で、R1〜R5のラウンドを横に並べて表示します。"
    },
    "cr": {
      "requestTitle": "クーリエ依頼",
      "requestSub": "Helinoxのクーリエアカウント（FedEx、DHL、UPS …）で発送する前に、まずここから依頼してください。ポータルがコストを契約料金と照合し、承認者が発送前に判断します。通常の海上輸送・航空貨物には使用しません。",
      "approvalTitle": "クーリエ承認",
      "approvalSub": "発送前の判断待ちのクーリエ便です。HINCのFedEx契約料金およびHPACのDHL契約料金と照合されます。承認者：{{who}}。",
      "new": "新規依頼",
      "newTitle": "新規クーリエ依頼",
      "close": "閉じる",
      "cancel": "キャンセル",
      "send": "承認依頼を送信",
      "pick": "選択…",
      "loading": "読み込み中…",
      "clear": "クリア",
      "sendNote": "承認依頼は承認者の{{who}}に送られ、ここで承認または却下されます。依頼者とCCの方にもメールが届きます。",
      "b_requester": "依頼者",
      "b_carrier": "クーリエと請求先アカウント",
      "b_route": "発送元と宛先",
      "b_weight": "重量と箱数",
      "b_cost": "見積コスト",
      "b_goods": "荷物",
      "requester": "依頼者",
      "department": "部署",
      "ccEmails": "CC（アカウント保有エンティティ）",
      "ccHint": "Youngのルール1：アカウント保有エンティティをCCに入れます。@helinox.comのアドレスのみ、カンマ区切りで入力してください。",
      "carrier": "クーリエ",
      "carrierOther": "クーリエ名",
      "service": "サービスレベル",
      "accountHolder": "請求先のHelinoxアカウント",
      "accountHint": "クーリエアカウントの支払い元となるエンティティです。",
      "accountNo": "アカウント番号",
      "from": "発送元",
      "to": "宛先",
      "shipper": "荷送人",
      "receiver": "荷受人",
      "country": "国",
      "city": "都市",
      "address": "住所",
      "zipHint": "郵便番号を含めてください。",
      "toIndividual": "個人宅宛の配送（同僚の自宅、顧客の現場など）",
      "importer": "荷受人および輸入者",
      "importerHint": "Youngのルール5：Helinoxのエンティティを宛先とし、個人は気付（c/o）として記載します。個人のみの宛先にはしないでください。",
      "shipmentTo": "発送先",
      "to_internal": "Helinoxのエンティティまたはチーム",
      "to_direct": "顧客または第三者（直送）",
      "toDirect": "顧客または第三者へ直送（Helinoxのエンティティ宛てではない）",
      "to_customer": "顧客（直送）",
      "to_partner": "パートナーまたは第三者（直送）",
      "freightPayer": "運賃の負担者",
      "payerHint": "Youngのルール6：予約の前に、誰が支払うかを明記してください。",
      "incoterm": "貿易条件（Incoterm）",
      "cartons": "カートン数",
      "actualKg": "実重量（総重量）、kg",
      "dimKg": "容積重量、kg",
      "dimPh": "全カートンの合計",
      "useBoxTitle": "1カートン（縦×横×高さ÷5,000）×カートン数から容積重量を算出します",
      "boxSize": "カートンサイズ、cm（縦×横×高さ）",
      "useBox": "使用",
      "estCost": "見積運賃",
      "currency": "通貨",
      "duties": "見積関税・税金",
      "dutiesDdp": "DDP：Helinoxが負担します — 見積額を入力してください（ない場合は0）。",
      "bulkyNote": "かさばる貨物（容積重量が実重量を上回る場合、または100 kg超）：エクスプレスは標準ではありません。予約前に比較できるよう、フォワーダーの見積を少なくとも1件追加してください（Youngのルール2）。ポール、テント、フレーム、家具は、定義上かさばる貨物です。",
      "fwdName": "フォワーダー",
      "fwdCost": "フォワーダー見積",
      "goodsFor": "荷物の送り先",
      "goodsForHint": "荷物を受け取る人、チーム、または顧客です。",
      "contents": "内容物",
      "purpose": "目的",
      "notes": "備考",
      "checkTitle": "コストチェック",
      "checkWhat": "フォームの入力に合わせて、ポータルが見積コストをHINCのFedEx契約料金と比較します。",
      "checkNeed": "未入力：{{list}}。",
      "need_courier": "クーリエ",
      "need_dest": "宛先の国",
      "need_weight": "実重量",
      "need_cost": "見積コスト",
      "need_currency": "通貨",
      "chargeable": "請求重量",
      "bulky": "かさばる貨物",
      "quoted": "あなたの見積",
      "usdPerKg": "kgあたり",
      "diff": "契約料金との差",
      "fxWeek": "為替レート（NetSuite）",
      "v_reasonable": "妥当",
      "v_review": "確認を推奨",
      "v_high": "高い可能性あり",
      "v_nocontract": "契約料金なし",
      "v_manual": "手動で確認",
      "v_undefined": "—",
      "s_waiting": "待機中",
      "s_approved": "承認済み",
      "s_rejected": "却下",
      "s_withdrawn": "取り下げ済み",
      "tab_waiting": "判断待ち",
      "tab_approved": "承認済み",
      "tab_rejected": "却下",
      "tab_all": "すべて",
      "tab_rates": "料金",
      "empty_waiting": "判断待ちのものはありません。",
      "empty_approved": "承認済みのものはまだありません。",
      "empty_rejected": "却下されたものはありません。",
      "empty_all": "クーリエ依頼はまだありません。",
      "emptyMine": "クーリエ依頼はまだ送信していません。",
      "countRows": "{{n}}／{{total}}",
      "c_no": "依頼",
      "c_created": "送信日時",
      "c_requester": "依頼者",
      "c_entity": "エンティティ",
      "c_route": "区間",
      "c_carrier": "クーリエ",
      "c_originCountry": "発送元の国",
      "c_originCity": "発送元の都市",
      "c_destCountry": "宛先の国",
      "c_destCity": "宛先の都市",
      "c_service": "サービス",
      "c_account": "アカウント",
      "c_kg": "請求kg",
      "c_cost": "見積",
      "c_check": "チェック",
      "c_status": "ステータス",
      "c_decidedBy": "判断者",
      "c_decidedAt": "判断日時",
      "f_route": "区間",
      "f_carrier": "クーリエとサービス",
      "f_account": "請求先アカウント",
      "f_weight": "重量と箱数",
      "f_cost": "見積運賃",
      "f_fwd": "フォワーダー見積",
      "f_goodsFor": "荷物の送り先",
      "f_purpose": "目的",
      "f_contents": "内容物",
      "f_shipper": "荷送人",
      "f_receiver": "荷受人",
      "f_importer": "輸入者",
      "f_direct": "直送（運賃の負担者）",
      "f_incoterm": "貿易条件",
      "ddpShort": "関税・税金はHelinoxが負担",
      "f_requester": "依頼者",
      "f_cc": "CC",
      "f_notes": "備考",
      "actualShort": "実重量",
      "dimShort": "容積重量",
      "chargeableShort": "請求重量",
      "cartonsShort": "カートン",
      "dutiesShort": "関税・税金",
      "raised": "{{at}}に{{by}}が送信。",
      "approvedBy": "{{by}}が承認・{{at}}",
      "rejectedBy": "{{by}}が却下・{{at}}",
      "withdrawnAt": "{{at}}に取り下げ。",
      "rule4": "予約時のキャリアの見積がこの見積額を上回った場合は、発送前に手続きを止めて、その旨を報告してください（Youngのルール4）。",
      "approve": "承認",
      "reject": "却下",
      "withdraw": "取り下げ",
      "withdrawAsk": "{{no}}を取り下げますか？承認者には、判断すべき案件がなくなったことが通知されます。",
      "didApprove": "{{no}}を承認しました — 依頼者に通知されます。",
      "didReject": "{{no}}を却下しました — 理由が依頼者に通知されます。",
      "didWithdraw": "{{no}}を取り下げました。",
      "s_draft": "下書き",
      "notSent": "未送信",
      "saveDraft": "下書きを保存",
      "c_createdBy": "作成者",
      "c_createdAt": "作成日時",
      "checkSource": "HINCのFedEx契約料金ファイルから算出しています — AIによるレビューではありません。",
      "noContract": "この区間には契約価格がありません",
      "contractBase": "燃料サーチャージ前の契約料金",
      "h_shipment": "発送",
      "h_source": "数値の出典",
      "h_findings": "チェック結果",
      "editTitle": "{{no}}を編集",
      "copyTitle": "新規クーリエ依頼 — {{no}}からコピー",
      "savedDraft": "{{no}}を下書きとして保存しました — 準備ができたら送信してください。",
      "didDelete": "{{no}}を削除しました。",
      "didDeleteMailed": "{{no}}を削除しました — 承認者には、判断すべき案件がなくなったことが通知されます。",
      "deleteAsk": "{{no}}を削除しますか？この操作は元に戻せません。",
      "deleteAskWaiting": "{{no}}を削除しますか？承認者の手元にあり、判断すべき案件がなくなったことが通知されます。この操作は元に戻せません。",
      "saveWaiting": "保存",
      "changedByYou": "{{no}}を変更しました — 変更内容は依頼者に通知されます。引き続きあなたの判断待ちです。",
      "changedBy": "最終更新：{{by}}・{{at}}。",
      "why_notWaiting": "判断待ちの依頼のみ",
      "c_managerNote": "マネージャーのメモ",
      "c_action": "操作",
      "a_view": "表示",
      "a_edit": "編集",
      "a_submit": "提出",
      "a_copy": "複製",
      "a_delete": "削除",
      "a_withdraw": "取り下げ",
      "why_waiting": "承認者の手元にあります — 変更するには先に取り下げてください",
      "why_approved": "承認済み — 別の発送には複製してください",
      "why_sent": "すでに承認者の手元にあります",
      "why_done": "すでに判断済みです",
      "why_record": "承認済み — 承認の記録として保持されます",
      "why_notMine": "あなたの依頼ではありません",
      "sent": "{{no}}の承認依頼を送信しました。",
      "sentMailed": "{{no}}の承認依頼を送信しました — 承認者に通知されます。",
      "billed": "請求重量",
      "lane": "契約区間",
      "dir_export": "韓国からの輸出",
      "dir_import": "韓国への輸入",
      "dir_sg-export": "シンガポールからの輸出",
      "dir_sg-import": "シンガポールへの輸入",
      "dhlFreightOnly": "DHL料金表：運賃のみ — 燃料費、関税、DHL手数料は別途",
      "estSurcharge": "見積サーチャージ費用",
      "estSurchargeHint": "運賃に上乗せされる燃料、遠隔地、その他のサーチャージ — 契約料金は運賃のみの価格です",
      "dhlSettingsTitle": "HPAC DHL（シンガポール）— 料金表は運賃のみ",
      "dhlFuelPct": "DHL燃料サーチャージ %",
      "dhlRemarkLabel": "DHLの比較の下に常に表示する備考",
      "ratesTitleDhl": "HPAC DHL Express契約料金（SGD）",
      "ratesNoteDhl": "HPACのDHL Expressシンガポール料金表に基づくDHL Express Worldwideの料金です。30 kgまでは貨物全体の価格で0.5 kg単位、30.1 kg以上は1 kgあたりの価格で1 kg単位です。運賃のみで、燃料サーチャージ、関税、税金、DHL手数料は別途かかります。書類のみの料金と第三国のDHLは読み込んでいません。来年の料金表（.pdf）も同様に、アップロードで取り込みます。",
      "contract": "契約料金",
      "withFuel": "燃料サーチャージ{{pct}}%込み",
      "prioRate": "Priority：Economy料金 × {{f}}",
      "econRate": "Economy料金（ファイルの値）",
      "economyBase": "ファイルのEconomy料金",
      "h_remark": "備考",
      "priorityFactor": "Priority = Economy料金 ×",
      "remarkLabel": "契約料金との比較の下に常に表示する備考",
      "rateFile": "料金ファイル",
      "depPick": "部署を選択または入力",
      "depNone": "「{{name}}」に一致するものがありません",
      "depAddTo": "+「{{name}}」を部署リストに追加",
      "depAdded": "「{{name}}」をリストに追加しました。",
      "rateVersion": "{{file}}の契約料金・{{by}}が読み込み・{{at}}",
      "rateNone": "契約料金はまだ読み込まれていません。",
      "settingsTitle": "チェックによる見積の判定方法",
      "settingsNote": "料金ファイルはFedExのEconomy料金で、Priorityサービスはこれに係数を掛けた額になります。契約には燃料サーチャージが含まれないため、変更がない限り0のままです。契約料金との差が「妥当の上限」以内なら妥当、「要確認の上限」以内なら確認が必要、それを超えると高い可能性ありと判定します。",
      "fuelPct": "燃料サーチャージ %",
      "okPct": "妥当の上限（%）",
      "reviewPct": "要確認の上限（%）",
      "saveSettings": "保存",
      "settingsSaved": "保存しました。",
      "ratesTitle": "HINC FedEx契約料金（KRW）",
      "ratesNote": "20.5 kgまでは貨物全体の価格で0.5 kg単位、21 kg以上は1 kgあたりの価格で1 kg単位です。来年のファイルはアップロードで取り込みます。まず内容を読み取り、その後このリストを置き換えます。",
      "upload": "料金ファイルをアップロード（FedEx .xlsx / DHL .pdf）",
      "previewCounts": "輸出：{{el}}列、{{ec}}仕向地。輸入：{{il}}地域コード、{{ic}}か国。{{rows}}件の価格。",
      "replaceRates": "料金を置き換える",
      "ratesLoaded": "{{file}}から料金を読み込みました。",
      "weightCol": "重量",
      "perKgShort": "（kgあたり）",
      "laneNoCountry": "この列に対応する国がありません",
      "countriesTitle": "各列の国"
    },
    "spl": {
      "title": "販売計画",
      "loading": "読み込み中…",
      "cycle": "注文サイクル",
      "season": "シーズン",
      "next": "次へ",
      "orderDue": "注文",
      "exf": "工場出荷",
      "tab_format": "注文フォーマット",
      "tab_sheets": "注文シート",
      "tab_stock": "在庫",
      "tab_production": "生産",
      "tab_overview": "概要",
      "tab_setup": "設定",
      "fmtNone": "未アップロード",
      "fmtCount": "{{n}} SKU",
      "sheetsCount": "{{done}}/{{n}}完了",
      "stockServed": "在庫から{{n}} pcs",
      "prodCount": "工場設定済み{{set}}/{{n}}",
      "st_open": "オープン",
      "st_closed": "クローズ",
      "closedNote": "この注文はクローズされています。変更するには、注文フォーマット（編集 › ステータス）で再度オープンしてください。",
      "newOrder": "注文を作成",
      "newOrderTitle": "注文を作成",
      "open": "開く",
      "openFormat": "この注文のフォーマットを開く",
      "delOrder": "注文を削除",
      "col_id": "ID",
      "view": "表示",
      "viewOrder": "この注文を表示 — 閲覧のみ",
      "editOrder": "この注文とそのフォーマットを編集",
      "modeView": "閲覧のみ",
      "modeEdit": "編集中",
      "formatHead": "注文フォーマット・{{n}} SKU",
      "col_file": "注文フォーマットファイル",
      "fileBy": "{{by}} · {{at}}",
      "fileNone": "注文フォーマットファイルはまだありません。",
      "col_format": "フォーマット内のSKU",
      "col_sheets": "完了シート",
      "col_qty": "注文数（pcs）",
      "col_createdBy": "作成者",
      "col_createdAt": "作成日時",
      "col_action": "操作",
      "ordersCount": "{{n}}／{{total}}件の注文",
      "clearFilters": "フィルターを解除",
      "noOrderYetMgr": "注文はまだありません。「注文を作成」を押して、注文フォーマットをインポートしてください。",
      "noOrderYet": "注文はまだありません。Sales Planningマネージャーが注文フォーマットで作成します。",
      "fmtSource": "注文フォーマット",
      "src_file": "Master注文フォーマット（.xlsx）をインポート",
      "src_copy": "以前の注文のフォーマットをコピー",
      "src_later": "後で追加",
      "copyOption": "{{date}}・ex-fty {{exf}}・{{n}} SKU",
      "datesFirst": "注文期日とEx-factoryを入力してください。両方が揃うとすぐにファイルが読み込まれます。",
      "pvFile": "シート「{{sheet}}」：{{rows}} SKUがこの注文のフォーマットになります。",
      "pvCopy": "{{date}}の注文から{{n}} SKUがコピーされます。",
      "orderCreated": "注文{{date}}を作成しました — フォーマットに{{n}} SKU。",
      "orderCreatedNoFmt": "注文{{date}}を作成しました — 準備ができたら注文フォーマットをインポートしてください。",
      "orderDeleted": "注文{{date}}を削除しました。",
      "delAsk": "{{date}}期日の注文（ex-factory {{exf}}）とそのフォーマットの{{n}} SKUを削除しますか？まだ誰も作業していません。",
      "formatOf": "注文フォーマット・{{date}}（{{season}}）・Ex-fty {{exf}}",
      "seasonAuto": "シーズン{{s}} — 注文期日から算出（10月〜9月）。",
      "seasonAutoTip": "注文期日から算出されます。シーズンは10月から9月までです。",
      "sh_none": "未着手",
      "sh_open": "進行中",
      "sh_done": "完了",
      "sh_checked": "確認済み",
      "st_done_done": "{{cust}}：完了にしました。Sales Planningマネージャーが確認できます。",
      "st_check_done": "{{cust}}：確認済みにしました。",
      "st_reopen_done": "{{cust}}：再オープンしました。",
      "cancel": "キャンセル",
      "close": "閉じる",
      "save": "保存",
      "saveN": "保存（{{n}}）",
      "saved": "保存しました。",
      "savedCells": "{{n}}件の変更を保存しました。",
      "edit": "編集",
      "remove": "削除",
      "removed": "{{sap}}をこのサイクルから削除しました。",
      "read": "ファイルを読み込む",
      "write": "書き込む",
      "writeN": "{{n}}件の変更を書き込む",
      "search": "SAPコード、商品、カラー…",
      "allCategories": "すべてのカテゴリ",
      "allLineups": "すべてのラインナップ",
      "noRows": "該当なし。",
      "noOrders": "このサイクルの注文はまだありません。",
      "sap": "SAPコード",
      "product": "商品",
      "qty": "注文数",
      "amountUsd": "金額（USD）",
      "total": "合計",
      "buyer": "バイヤー",
      "pic": "担当者",
      "status": "ステータス",
      "fmtEmpty": "このサイクルの注文フォーマットはまだありません。",
      "fmtEmptyHint": "その月のMaster注文フォーマット（.xlsx）をアップロードしてください。そのSKUと価格がこのサイクルの一覧になり、注文シートにはこれらのSKUだけが表示されます。SKUはいつでも追加・修正できます。",
      "fmtWaiting": "Sales Planningマネージャーがアップロードします。",
      "upload": "注文フォーマットをアップロード",
      "uploadNew": "新しいバージョンをアップロード",
      "copyFrom": "{{cycle}}のフォーマットをコピー",
      "addSku": "SKUを追加",
      "fmtDownload": "フォーマットをダウンロード",
      "fmtDownloadTip": "このサイクルの注文フォーマットを、Master注文フォーマットと同じレイアウトの.xlsxで出力します。編集してから再度アップロードしてください。",
      "portalOnly": "ポータルが保持しています — Master注文フォーマットにはこの列がありません。そのSKUがあった直近のサイクルから引き継いでいます。",
      "fmtNote": "{{n}}／{{total}} SKU・価格はUSD",
      "fmtUploadTitle": "Master注文フォーマットをアップロード",
      "fmtUploadBody": "ファイルはまず読み込みのみ行われ、「書き込む」を押したときに初めて書き込まれます。このサイクルにすでにあるSKUはファイルの属性と価格に更新されます。ファイルに記載のないSKUは、下のチェックボックスをオンにしない限り保持されます。",
      "fmtSummary": "シート「{{sheet}}」：{{rows}} SKU — 新規{{added}}件、変更{{changed}}件、このサイクルにあるがファイルにないもの{{missing}}件。",
      "fmtAdded": "新規",
      "fmtChanged": "変更",
      "fmtMissing": "ファイルにない",
      "fmtUsed": "チェック済みまたは注文済みのため保持",
      "fmtRemove": "ファイルになく、チェックも注文もされていない{{n}}件も削除する",
      "fmtNoChange": "ファイルはこのサイクルのフォーマットと一致しています。",
      "fmtDone": "注文フォーマットを書き込みました：新規{{added}}件、変更{{changed}}件、削除{{removed}}件。",
      "fmtCopied": "{{n}} SKUをコピーしました。",
      "skuNew": "SKUを追加",
      "skuEdit": "{{sap}}を編集",
      "skuRemoveAsk": "{{sap}}（{{product}}）をこのサイクルの注文フォーマットから削除しますか？",
      "noFormatYet": "先に注文フォーマットをアップロードしてください。各シートにはそのSKUが表示されます。",
      "priceCol": "適用価格",
      "pf_price_t1": "T1 FOB",
      "pf_price_t2": "T2 FOB",
      "pf_price_hema_dt": "HEMA DT価格",
      "pf_null": "—",
      "ticked": "チェック済みSKU",
      "ordered": "注文済み",
      "updated": "最終保存",
      "myBuyers": "自分のバイヤーのみ",
      "allStatus": "すべてのステータス",
      "sheetsNote": "{{n}}シート中{{done}}シートが完了",
      "sapAll": "SAPアップロード（全バイヤー）",
      "sapOne": "このバイヤーのSAP SOアップロード",
      "sheetTitle": "注文シート{{date}}",
      "customerRef": "顧客リファレンス（バイヤーのPO#）",
      "showTicked": "チェック済み（{{n}}）",
      "showAll": "全SKU（{{n}}）",
      "tick": "チェック",
      "tickShown": "表示中をすべてチェック",
      "untickShown": "表示中をすべて解除",
      "fromLast": "前サイクルと同じSKU",
      "fromLastDone": "{{date}}と同じく{{n}} SKUをチェックしました。",
      "nothingTicked": "まだチェックされていません。このバイヤーが注文できるSKUを（全SKUから）チェックするか、前サイクルから始めてください。",
      "tickedN": "{{n}}件チェック済み",
      "exportForm": "バイヤー用フォーム",
      "exportTip": "チェック済みSKUとこのバイヤーの価格のみを含む注文フォーマットです。バイヤーが注文数を入力します。",
      "tickFirst": "先にこのバイヤーが注文できるSKUをチェックしてください",
      "saveFirst": "先に変更を保存してください",
      "importForm": "バイヤーのフォームをインポート",
      "markDone": "完了",
      "markChecked": "確認済みにする",
      "reopen": "再オープン",
      "doneBy": "{{who}}が完了・{{at}}",
      "checkedBy": "{{who}}が確認・{{at}}",
      "unsaved": "未保存の変更が{{n}}件あります。",
      "keepEditing": "編集を続ける",
      "discard": "破棄",
      "sheetLocked": "このシートは引き渡し済みです。Sales Planningマネージャーは引き続き変更や再オープンができます。",
      "notYours": "このバイヤーのPICは{{pic}}です。このシートを入力できるのは、本人またはSales Planningマネージャーのみです。",
      "flagCycle": "注文フォーマット：{{rule}} — このサイクルでは未オープン",
      "flagPrice": "このバイヤーの価格がありません",
      "formTitle": "{{cust}} — バイヤーのフォームをインポート",
      "formBody": "お送りしたフォームにバイヤーが記入したもの（.xlsx）です。SAP CodeとOrder Q'tyの列が読み込まれます。フォーム上のすべてのSKUに数量が反映され（空欄は注文なし）、フォームにないSKUはそのままです。「書き込む」を押すまで何も書き込まれません。",
      "formSummary": "シート「{{sheet}}」：SKU行{{rows}}件、注文{{total}} pcs — {{n}} SKUが変更されます。",
      "formUnknown": "このサイクルの注文フォーマットにありません（インポートされません）：{{list}}",
      "formDup": "重複して記載されています（最初のものを使用）：{{list}}",
      "formNoChange": "フォームの内容は、シートの現在の内容と同じです。",
      "formWritten": "{{cust}}：フォームから{{n}} SKUを書き込みました。",
      "was": "現在",
      "now": "フォーム上",
      "stockNote": "3つの在庫プールを入力してから割り当ててください。バイヤーは在庫優先順位（設定 › バイヤー）に従って対応され、それぞれKR Domestic、EUSU、KR SOPの順に引き当てられます。",
      "notAllDone": "{{n}}シートがまだ完了していません。提出後にもう一度割り当ててください。",
      "countOver": "{{n}}件のバイヤー行が、注文数より多く在庫から割り当てられています。",
      "pool_kr_dom": "KR国内",
      "pool_eusu": "EUSU (SOP)",
      "pool_kr_sop": "KR (SOP)",
      "avail": "利用可能",
      "fromStock": "在庫から",
      "left": "残り",
      "allocation": "割当先",
      "onlyActive": "注文または在庫のあるSKUのみ",
      "stockTpl": "在庫ファイル",
      "stockImport": "在庫ファイルをインポート",
      "allocate": "在庫を割り当てる",
      "allocateTitle": "在庫を割り当てる",
      "allocateGo": "割り当てる",
      "allocateBody": "在庫のあるすべてのSKUを再度割り当てます。バイヤーは下の順に、それぞれKR Domestic、EUSU、KR SOPの順で、注文数とプールの残りの範囲内で引き当てます。これらのSKUで手修正した数値は置き換えられます。",
      "allocateOrder": "対応順（設定 › バイヤー › 在庫優先順位）：",
      "allocated": "{{skus}} SKUに在庫を割り当てました：在庫から{{pcs}} pcs。",
      "allocEdit": "{{sap}}の割当",
      "allocTotal": "利用可能{{avail}}のうち{{served}}を割当",
      "stockImportBody": "ファイル内のSKUには、その3つの数値が反映されます（空欄は在庫なし）。記載のないSKUはそのままです。レイアウトは在庫ファイルをダウンロードしてご確認ください。",
      "stockSummary": "シート「{{sheet}}」：{{rows}}行 — {{n}} SKUが変更されます。",
      "stockWritten": "{{n}} SKUの在庫を書き込みました。",
      "prodNote": "必要数＝注文数 − 割り当てた在庫を、バイヤーごとに合算したものです。各SKUに工場と上積みの生産数を設定してください。カードは工場ごとの計画数量です。",
      "required": "必要数",
      "overbuild": "上積み生産",
      "planned": "計画",
      "factory": "工場",
      "comment": "コメント",
      "needsOnly": "生産が必要なSKUのみ",
      "allFactories": "すべての工場",
      "unassigned": "未割当",
      "byBuyer": "バイヤー別",
      "m_order": "注文",
      "m_stock": "在庫から",
      "m_prod": "生産",
      "total_order": "注文合計",
      "total_stock": "在庫からの合計",
      "total_prod": "必要数",
      "mNote_order": "オレンジ：このサイクルでオープンしていないSKUへの注文、またはそのバイヤーの価格がないもの。",
      "mNote_stock": "赤：バイヤーの注文数より多く在庫から割り当てられているもの。",
      "mNote_prod": "注文 − 在庫から（バイヤーごと）。",
      "c_orders": "注文合計",
      "c_stock": "在庫から",
      "c_prod": "必要生産数",
      "c_ob": "上積み生産",
      "c_planned": "計画生産数",
      "c_amount": "注文金額",
      "customerReport": "顧客レポート — 商品カテゴリ別",
      "priceRule": "金額＝数量×バイヤーの価格：T2バイヤーはT2 FOB、HEMAの販売店はHEMA DT価格、それ以外はT1 FOBです。",
      "sub_customers": "バイヤー",
      "sub_cycles": "スケジュール",
      "addCustomer": "バイヤーを追加",
      "active": "有効",
      "discontinued": "取引終了",
      "custNote": "PIC＝バイヤーのシートを入力するSale OP担当者です。価格設定とエンティティで価格列が決まり、受注台帳の列を設定するとシート上のバイヤーになり、在庫優先順位は在庫を割り当てる順序です。",
      "cycleNote": "注文とex-factoryのスケジュール（2026年月次注文プログラム）です。クローズしたサイクルは変更できません。",
      "etas": "ETA KR/JP/SIN · AUS · EU · USA",
      "etaLine": "{{a}} · {{au}} · {{eu}} · {{us}}",
      "edit_customer": "バイヤーを編集",
      "edit_customer_new": "バイヤーを追加",
      "edit_cycle": "注文{{date}}を編集",
      "f_customer_key": "バイヤー",
      "f_pic_user_id": "PIC（Sale OP）",
      "f_country": "国",
      "f_pricing": "価格設定",
      "f_entity": "Helinoxエンティティ",
      "f_status": "ステータス",
      "f_sold_to": "Sold-To (SAP)",
      "f_ship_to": "Ship-To (SAP)",
      "f_grid_order": "受注台帳の列",
      "f_alloc_priority": "在庫優先順位",
      "f_remark": "備考",
      "f_sap_code": "新SKU#（SAPコード）",
      "f_product": "商品",
      "f_skin_color": "生地カラー",
      "f_frame_color": "フレームカラー",
      "f_selling_sku": "販売SKU#",
      "f_upc": "UPC",
      "f_line_category": "カテゴリ",
      "f_lineup": "ラインナップ",
      "f_order_cycle": "注文サイクル",
      "f_noos": "NOOS=Never Out of Stock（定番SKU）",
      "f_product_category": "商品カテゴリ",
      "f_ex_factory_loc": "Ex-Factory所在地",
      "f_carton_qty": "カートン入数",
      "f_hts_usa": "米国HTSコード",
      "f_hts_eu": "欧州HTSコード",
      "f_ctn_size": "カートンサイズ（mm）／タイプ",
      "f_frame_category": "フレームカテゴリ",
      "f_price_t1": "グローバルエンティティおよびアジア顧客向けT1 FOB",
      "f_price_hema_dt": "HEMA DT専用のT1 FOB",
      "f_price_t2": "非販売店向けT2 FOB",
      "f_season": "シーズン",
      "f_fc_due": "FC期日",
      "f_order_due": "注文期日",
      "f_ex_factory": "工場出荷",
      "f_items_note": "アイテム",
      "f_eta_asia": "ETA KR/JP/SIN",
      "f_eta_aus": "ETA オーストラリア",
      "f_eta_eu": "ETA 欧州",
      "f_eta_usa": "ETA 米国"
    },
    "nav": {
      "aiPowered": "このポータルの要約と回答は、AnthropicのAIであるClaudeが作成しています",
      "report": "レポート",
      "salesReport": "売上レポート",
      "saleOperation": "その他のツール",
      "development": "開発",
      "salesOperation": "営業オペレーション",
      "production": "生産",
      "productSalesDashboard": "商品別売上ダッシュボード",
      "salesReportDashboard": "業績",
      "marketingDashboard": "マーケティングダッシュボード",
      "dataExplorer": "データエクスプローラー",
      "salesDataLoad": "売上データ更新",
      "inventoryReport": "Global Inventory Report",
      "poleInventory": "ポール在庫クローズ",
      "eusuStock": "EUSU非販売在庫",
      "inventoryDashboard": "在庫ダッシュボード",
      "poleDashboard": "ポール在庫ダッシュボード",
      "demandForecastDashboard": "需要予測ダッシュボード",
      "autoJobs": "Sales Op. Python",
      "dashboard": "ダッシュボード",
      "projectTracker": "プロジェクトトラッカー",
      "documents": "E-Docs",
      "documentLibrary": "ライブラリ",
      "sampleTracker": "サンプルトラッカー",
      "partnerSamples": "DACサンプルトラッカー",
      "ticketStation": "Ticket Station",
      "userManual": "ユーザーマニュアル",
      "projectApproval": "プロジェクト承認",
      "nfcTokenPortal": "NFCトークンポータル",
      "pricingCalculator": "コラボ価格計算ツール",
      "ceoOffice": "CEOオフィス",
      "gtm": "GTM",
      "finance": "財務",
      "cashSetup": "設定",
      "cashImport": "提出",
      "cashApproval": "承認",
      "courierRequests": "クーリエ依頼",
      "courierApproval": "クーリエ承認",
      "courier": "クーリエ",
      "collabPricing": "コラボ価格",
      "arrangeOpen": "メニューを並べ替え",
      "arrangeTitle": "メニューを並べ替え",
      "arrangeHint": "フォルダや項目をドラッグするか、矢印を使ってください。この順序はご自身にのみ表示されます。",
      "arrangeUp": "{{name}}を上へ移動",
      "arrangeDown": "{{name}}を下へ移動",
      "arrangeDone": "完了",
      "arrangeCancel": "キャンセル",
      "arrangeReset": "リセット",
      "arrangeResetHint": "ポータル標準の順序に戻す",
      "arrangeIsDefault": "すでにポータル標準の順序です",
      "arrangeFailed": "メニューの順序を保存できませんでした",
      "arrangeUnfold": "{{name}}の項目を表示",
      "arrangeFold": "{{name}}の項目を非表示",
      "hevnAdmin": "HEVN管理",
      "driverLog": "ドライバー日報",
      "salesPlanning": "販売計画",
      "splFormat": "注文フォーマット",
      "splOrders": "注文シート",
      "splStock": "在庫割当",
      "splProduction": "工場割当",
      "splOverview": "注文概要",
      "splSetup": "計画設定",
      "cashWeekly": "週次キャッシュレポート",
      "cashPlan": "月次キャッシュプラン",
      "cashMonthEnd": "月末照合",
      "cashReport": "キャッシュレポート",
      "gtmProgrammes": "GTMプログラム",
      "gtmApproval": "GTM承認",
      "gtmTracker": "GTMトラッカー",
      "ceoFolder": "CEO",
      "benchmarkLibrary": "インラインコストシート",
      "pricingApproval": "価格承認",
      "costing": "原価計算",
      "opaSct": "OPA / SCT",
      "sctSummary": "SCTサマリー"
    },
    "cash": {
      "title": "設定",
      "sub": "すべてのキャッシュレポートが参照するリストです。エンティティ、銀行口座、週、為替レート、費用カテゴリ、および作成者・確認者・承認者を管理します。変更はGroup CFOが承認して初めて有効になります。",
      "loading": "読み込み中…",
      "tab_entity": "エンティティ",
      "tab_account": "口座",
      "tab_user": "ユーザー",
      "tab_period": "期間",
      "tab_fx": "為替レート",
      "tab_expense": "費用カテゴリ",
      "tab_account_type": "口座種別",
      "tab_role": "ロール",
      "tab_notice": "通知",
      "tab_flow": "フロー",
      "tab_changes": "保留中の変更",
      "tab_history": "履歴",
      "tab_setting": "設定",
      "tab_currency": "通貨",
      "f_code": "コード",
      "f_name": "名称",
      "f_tax_code": "税コード／ID番号",
      "f_legal_address": "登記住所",
      "f_country": "国",
      "f_ho_address": "本社住所",
      "f_acc_mail": "管理／経理メール",
      "f_min_balance_sgd": "最低残高（SGD）",
      "f_status": "ステータス",
      "f_seq": "順序",
      "f_account_id": "口座ID",
      "f_entity_code": "エンティティ",
      "f_account_no": "口座番号",
      "f_currency": "通貨",
      "f_bank_name": "銀行名",
      "f_account_type": "口座種別",
      "f_restricted": "使用制限あり",
      "f_fixed_deposit": "定期預金",
      "f_remarks": "備考",
      "f_user_code": "コード",
      "f_mail": "メール",
      "f_role_key": "ロール",
      "f_year": "年",
      "f_week": "週",
      "f_week_ending": "週末日（金曜日）",
      "f_submit_deadline": "提出期限",
      "f_category_type": "種別",
      "f_describe": "説明",
      "f_type_name": "種別",
      "f_default_restricted": "デフォルト：使用制限あり",
      "f_default_fd": "デフォルト：定期預金",
      "f_action": "操作",
      "f_right_scope": "権限",
      "f_restriction": "制限（職務分掌）",
      "f_notice_id": "通知ID",
      "f_header": "見出し",
      "f_content": "内容",
      "f_report": "レポート",
      "f_send_to_role": "送信先（ロール）",
      "f_send_day": "送信曜日",
      "f_send_time": "送信時刻",
      "f_setting_value": "値",
      "f_rate": "レート",
      "f_week_code": "週",
      "f_trigger_key": "トリガー",
      "tab_log": "通知ログ",
      "trg_report_open": "週次レポート開始（スケジュール）",
      "trg_due_soon": "期限リマインド（スケジュール）",
      "trg_missing": "未提出（スケジュール）",
      "trg_plan_update": "13週計画の更新（スケジュール）",
      "trg_month_open": "月末照合開始（スケジュール）",
      "trg_upload_errors": "アップロードにエラーがあります",
      "trg_submitted": "確認依頼済み",
      "trg_reviewed": "確認済み",
      "trg_approved": "Group CFOが承認",
      "trg_closed": "CEOがクローズ",
      "trg_returned": "差し戻し",
      "trg_below_min": "最低残高を下回っています",
      "trg_setup_submitted": "設定を承認依頼済み",
      "mailHeld": "メール保留中",
      "mailLive": "メール送信中",
      "mailHeldLine": "モジュール構築中のため、Cash Reportのメールは保留されています。以下の通知はすべて作成・記録されていますが、誰にも送信されていません。",
      "mailLiveLine": "Cash Reportのメールは有効です。以下の通知は送信されました。",
      "logRun": "スケジュール通知を今すぐ実行",
      "logRunAt": "この日時として実行",
      "logAtWhy": "今は空欄のままにするか、日時を選ぶとその時点で送信される内容を確認できます（メール保留中のみ）。サーバー時刻です。",
      "logRan_one": "{{at}}として実行しました：通知{{count}}件を作成。",
      "logRan_other": "{{at}}として実行しました：通知{{count}}件を作成。",
      "logEmpty": "Cash Reportのメールはまだ作成されていません。",
      "logWhen": "日時",
      "logStatus": "ステータス",
      "logWhat": "通知",
      "logFor": "エンティティ・期間",
      "logTo": "宛先",
      "logSubject": "件名",
      "log_held": "保留",
      "log_sent": "送信済み",
      "log_failed": "失敗",
      "log_claimed": "送信中…",
      "log_tester": "テスターに送信済み",
      "testAs": "テストするロール",
      "testOff": "オフ — 自分のロール",
      "testOnNote": "{{role}}としてテスト中：実施した各ステップは「（{{role}}としてテスト）」と記録されます。Cashメールが保留されている間のみ利用できます。",
      "testOffNote": "構築中は、作成者または確認者の役を演じて、レポートを2つのステップに沿って進めることができます。",
      "logSim": "シミュレーション",
      "logSimWhy": "「この日時として実行」で作成されたものです。その日の実際の通知は消費しません。",
      "s_base_currency": "基準通貨",
      "s_rate_source": "レートの出典",
      "s_rate_date": "レート日",
      "state_clean": "有効",
      "state_draft": "下書き — 未送信",
      "state_submitted": "Group CFOの承認待ち",
      "bandClean": "これらのタブの内容はすべて承認済みで有効です。",
      "bandEmpty": "承認済みのものはまだありません。設定ワークブックをインポートして開始し、Group CFOに送信してください。",
      "bandCounts": "新規{{insert}}件・変更{{update}}件・削除{{delete}}件 — Group CFOが承認するまで有効になりません",
      "sentBy": "{{by}}が{{at}}に送信",
      "returned": "{{by}}が{{at}}に差し戻し：",
      "bootstrap": "ユーザーリストにはまだ承認済みの行がないため、ポータル管理者であるあなたがCash Report管理者として操作しています。最初のリストが承認されるとこの状態は終了します。",
      "provisional": "まだ何も承認されていないため、提案中のユーザーリストで割り当てられたロール（{{roles}}）でこの画面を表示しています。Group CFOがリストを承認すると確定します。",
      "import": "Excelをインポート",
      "send": "Group CFOに送信",
      "approve": "承認",
      "notePh": "Group CFOへのメモ（任意）",
      "fixFirst": "データチェックでエラーのある行は、送信前に修正する必要があります。",
      "sent": "Group CFOに送信しました。承認されるまで何も変わりません。",
      "approved": "承認しました — 変更はすでに有効です。",
      "rejected": "理由を添えて管理者に差し戻しました。",
      "imported": "インポートしました：新規{{insert}}件、変更{{update}}件、変更なし{{same}}件。下書きに入っており、まだ有効ではありません。",
      "sumErrors_one": "データチェックでエラーのある行：{{count}}行",
      "sumErrors_other": "データチェックでエラーのある行：{{count}}行",
      "sumWarns_one": "警告のある行：{{count}}行",
      "sumWarns_other": "警告のある行：{{count}}行",
      "onlyIssues": "データチェックのメッセージがある行のみ",
      "onlyChanged": "変更された行のみ",
      "rows_one": "{{count}}行",
      "rows_other": "{{count}}行",
      "search": "検索…",
      "clear": "クリア",
      "addRow": "行を追加",
      "save": "保存",
      "cancel": "キャンセル",
      "edit": "編集",
      "remove": "削除",
      "undo": "この変更を元に戻す",
      "was": "承認済みの値",
      "choose": "選択…",
      "auto": "保存時に採番",
      "autoHint": "新しい行のコードはポータルが採番し（Entity-01、EC-0001、N-001…）、再利用されません。",
      "dataCheck": "データチェック",
      "chkOk": "OK",
      "chkError": "エラー",
      "chkWarn": "警告",
      "op_insert": "新規",
      "op_update": "変更",
      "op_delete": "削除予定",
      "noRows": "行がありません。",
      "yes": "はい",
      "no": "いいえ",
      "week": "週",
      "allWeeks": "すべての週",
      "year": "年",
      "addYear": "次の年の全週を追加：",
      "addWeeks": "週を追加",
      "weeksAdded": "{{year}}年の{{count}}週分を下書きに追加しました。",
      "fxHint": "レート＝通貨1単位あたりの基準通貨の単位数です。SGD金額＝外貨金額×レートとなります。レートは週ごとに1つで、Template 1は自分の週のレートを読み込みます。",
      "newCurrency": "例：CHF",
      "addCurrency": "通貨を追加",
      "editRates": "レートを編集",
      "saveRates": "{{count}}セルを保存",
      "fxSync": "NetSuiteから同期",
      "fxSyncTitle": "各週の金曜日のレートをNetSuiteから読み込みます。Group CFOを経由せず、すぐに反映されます。ここで入力したレートは変更されません。",
      "fxLastSync": "NetSuiteからの最終取得：{{when}}",
      "fxNeverSynced": "NetSuiteからまだ同期されていません",
      "fxSynced": "NetSuite：{{weeks}}週分について、{{written}}件のレートを書き込み、{{unchanged}}件は最新のままでした。",
      "fxKeptTyped": "設定で入力された{{n}}件のレートは変更していません（{{list}}）。",
      "fxMissing": "NetSuiteに{{n}}件分のレートがありません（{{list}}）。",
      "fxFromNetsuite": "NetSuiteより — {{day}}のレート",
      "fxBase": "基準通貨",
      "fxTyped": "設定で入力・承認済み — NetSuite同期では変更されません",
      "flowReport": "レポート",
      "step": "ステップ{{n}}",
      "rep_weekly": "週次キャッシュレポート",
      "rep_13w": "13週キャッシュプラン",
      "rep_month": "月末照合",
      "rep_setup": "設定",
      "flowPrep": "作成者：作成",
      "flowReview": "確認者：確認・了承",
      "flowCfo": "Group CFO：承認",
      "flowCeo": "CEO：承認・クローズ",
      "flowAdmin": "Admin：設定を実施",
      "flowNote": "3つのレポートはすべてこの流れで進みます（Finance › キャッシュレポート：週次キャッシュレポート、13週キャッシュプラン、月末照合）。確認者の了承が最後のステップで、了承されるとレポートがキャッシュレポートに表示されます。通知タブでは、何を誰にいつ送るかを確認できます。定期送信は送信日と時刻、ステップによって送信されるものはイベントで示され、通知ログには作成されたすべてのメールが表示されます。",
      "noChanges": "保留中の変更はありません。",
      "list": "リスト",
      "code": "コード",
      "change": "変更",
      "what": "変更内容",
      "by": "担当",
      "noHistory": "承認済みの変更はまだありません。",
      "histLine": "{{n}}件の変更 · {{by}}が{{at}}に送信 · {{cfo}}が{{on}}に承認",
      "histBuild": "{{n}}件の変更 · 構築のため{{by}}が{{on}}に適用 — Group CFOの承認は未取得"
    },
    "cashr": {
      "title": "キャッシュレポート",
      "reviewedOnly": "確認者が了承したレポートのみ、ここに数値が表示されます。"
    },
    "cashw": {
      "h_balance": "残高（{{ccy}}）",
      "h_balanceOrig": "残高（口座通貨）",
      "h_amountIn": "金額（{{ccy}}）",
      "baseLabel": "表示通貨",
      "baseWhy": "すべての金額は、設定にある当週のレート（NetSuite、金曜日）でSGDから換算されます。口座自体の残高は口座の通貨のままです。",
      "baseRate": "設定にある当週のレートで表示：1 {{ccy}} = {{rate}} SGD。",
      "noBaseRate": "設定に当週の{{ccy}}レートがまだありません — SGDで表示しています。",
      "balanceWhy": "銀行口座別に現金を表示",
      "balanceNote": "残高＝週末時点で銀行が保有している現金です。利用可能額＝残高−使用制限−定期預金。口座自体の残高は明細と同じく口座の通貨で、その他の金額は設定にある当週のレート（NetSuite）で換算されます。増減は、両方の週を報告したエンティティが対象です。",
      "tot_balance": "残高",
      "title": "キャッシュレポート · 週次",
      "sub": "各エンティティは提出画面で当週のTemplate 1をインポートします。レポートは作成者から確認者へ進み、確認者が了承するとここに表示されます。ここに表示される数値はすべてSGDで、入力内容からポータルが算出したものです。",
      "prevWeek": "前週",
      "nextWeek": "翌週",
      "weekLine": "{{end}}終了の週 · レポート期日 {{due}}",
      "closedWeek": "クローズ済み",
      "noRates": "設定に当週の為替レートがまだありません。金曜日のレートが公表されるとNetSuiteから取り込まれます。それまでは数値をSGDで表示できず、レポートも送信できません。",
      "h_entity": "エンティティ",
      "h_opening": "期首",
      "h_inflow": "流入",
      "h_outflow": "流出",
      "h_closing": "期末",
      "h_restricted": "使用制限",
      "h_fd": "定期預金",
      "h_available": "利用可能額",
      "h_change": "前週比",
      "h_belowMin": "最低残高未満",
      "h_status": "ステータス",
      "h_no": "No.",
      "h_category": "カテゴリ",
      "h_memo": "メモ",
      "h_amount": "金額（SGD）",
      "h_account": "口座",
      "h_ccy": "通貨",
      "h_closingStmt": "期末（明細）",
      "h_diff": "差異",
      "h_rate": "SGDへのレート",
      "h_closingSgd": "期末（SGD）",
      "h_files": "ファイル",
      "h_kind": "種別",
      "h_other": "相手エンティティ",
      "h_ref": "参照",
      "groupNote": "エンティティ間の取引を除く",
      "groupCount": "{{of}}エンティティ中{{n}}エンティティが確認済み",
      "unmatched": "未相殺のグループ間取引：{{amt}} SGD",
      "unmatchedWhy": "各エンティティが報告した相互の受取額と支払額の合計がゼロになりません。一方がまだ報告していないか、移動中の可能性があります。期末は銀行が保有する現金のため、期首＋流入−流出とはちょうどこの金額だけ一致しません。",
      "nothingYet": "今週はまだどのエンティティもアップロードしていません。",
      "yearTitle": "{{year}}年の全週",
      "yearPick": "年",
      "h_weekEntity": "エンティティ / 口座",
      "h_bank": "銀行",
      "h_acctNo": "口座番号",
      "h_acctType": "口座種別",
      "h_acctFlag": "使用制限 / 定期預金",
      "weekTitle": "第{{code}}週 · {{end}}終了",
      "weekOpenWhy": "この週のエンティティを開閉",
      "weekPickWhy": "この週を表示中の週にする — グラフ、Top 3、レポートが切り替わります",
      "weekNothing": "報告なし",
      "yearLoading": "年の残りを読み込み中…",
      "yearNote": "1年の各週につきGROUPの行が1行あります。▸を押すとその週のエンティティ、エンティティの▸を押すとその口座が開きます。週コードを押すと、その週が表示中の週になります。",
      "origClosing": "期末（{{ccy}}）：{{amt}}",
      "inCcy": "{{ccy}}建て",
      "origWhy": "銀行明細と同じ、口座自体の通貨である{{ccy}}で表示しています。",
      "notUploaded": "まだアップロードされていません。",
      "notReviewed": "まだ確認されていません — 確認者が了承すると数値が表示されます。",
      "expandWhy": "銀行口座別に現金を表示",
      "errorsN_one": "データチェックエラー{{count}}件",
      "errorsN_other": "データチェックエラー{{count}}件",
      "below": "下回り",
      "belowWhy": "利用可能な現金が、このエンティティに設定された最低残高{{min}} SGDを下回っています。",
      "noMinWhy": "このエンティティの最低残高は設定にありません。",
      "interGroup": "グループ間取引",
      "interGroupWhy": "他のHelinoxエンティティとの取引です — GROUPの行からは除外されます。",
      "restrictedTag": "使用制限",
      "fdTag": "定期預金",
      "noTxn": "取引なし",
      "sgdNote": "SGD＝口座自体の通貨×設定にある当週のレート（NetSuite）。口座の期末は、口座自体の通貨でその行に表示されます。流入と流出にはエンティティ内の振替を含みません。利用可能額＝期末−使用制限−定期預金。",
      "topTitle": "Top 3",
      "top_spend": "今週の主な支出 Top 3",
      "top_payable": "来週の支払予定 Top 3",
      "noTops": "今週はまだどのエンティティも報告していません",
      "expandAll": "すべて展開",
      "collapseAll": "すべて折りたたむ",
      "st_none": "未アップロード",
      "st_open": "作成済み — 未送信",
      "st_returned": "差し戻し",
      "st_submitted": "確認者に提出中",
      "st_reviewed": "了承済み",
      "st_approved": "承認済み",
      "st_closed": "クローズ済み",
      "by_submitted": "{{by}}が{{at}}に送信",
      "by_reviewed": "{{by}}が{{at}}に確認",
      "by_approved": "{{by}}が{{at}}に承認",
      "by_closed": "{{by}}が{{at}}にクローズ",
      "by_returned": "{{by}}が{{at}}に差し戻し",
      "weekEnding": "{{d}}終了の週",
      "step_prep": "作成者",
      "step_review": "確認者",
      "step_cfo": "Group CFO",
      "step_ceo": "CEO",
      "notYet": "まだです",
      "returnedBy": "{{by}}が{{at}}に差し戻しました：",
      "weekClosed": "この週は設定でクローズされています — レポートの閲覧はできますが、アップロードはできません。",
      "weekClosedReturned": "この週は設定でクローズされていますが、差し戻されたレポートは修正して再送信できます。",
      "selfBlocked": "このバージョンをアップロードしたか、このレポートで前のステップを実施したため、「{{step}}」は別の方が行う必要があります。",
      "tooBig": "ファイルは最大3.5 MBです。銀行明細はより小さいPDFで保存するか、分割して添付してください。",
      "changeOver_one": "両方の週を報告した{{count}}エンティティが対象",
      "changeOver_other": "両方の週を報告した{{count}}エンティティが対象",
      "template": "テンプレートをダウンロード",
      "upload": "ファイルをインポート",
      "uploadAgain": "再インポート",
      "notePh": "確認者へのメモ（任意）",
      "submit": "確認者に送信",
      "fixFirst": "送信前にデータチェックのエラーを修正してください。",
      "btn_review": "確認・了承",
      "btn_approve": "承認",
      "btn_close": "承認してクローズ",
      "sendBack": "差し戻す",
      "reopen": "修正のため再オープン",
      "reopenWhy": "了承済みです。再オープンすると、理由を添えて作成者に差し戻されます。再度了承されるまで、数値はキャッシュレポートから外れます。",
      "done_submit": "確認者に送信しました。",
      "done_review": "確認・了承しました — キャッシュレポートに表示されます。",
      "done_approve": "承認しました — CEOの確認待ちです。",
      "done_close": "承認してクローズしました。",
      "done_return": "理由を添えて作成者に差し戻しました。",
      "mailHeld": "（メールは送信されていません：モジュール構築中のため、キャッシュレポートのメールは保留されています。）",
      "uploadedOk": "バージョン{{v}}をインポートしました。",
      "replacedOk": "バージョン{{v}}をインポートしました — データチェックに合格し、確認者のもとにあるバージョン{{old}}と置き換わります。",
      "correctWhileReview": "確認者に提出中（バージョン{{v}}）です。下の画面で、または修正したファイルをインポートして、引き続き修正できます。保存してデータチェックに合格すると、確認者が読んでいるバージョンと置き換わります。",
      "uploadedErrors_one": "バージョン{{v}}をアップロードしました — 送信前に修正が必要なデータチェックエラーが{{count}}件あります。",
      "uploadedErrors_other": "バージョン{{v}}をアップロードしました — 送信前に修正が必要なデータチェックエラーが{{count}}件あります。",
      "nothingUploaded": "まだ入力されていません。",
      "sumErrors_one": "データチェックエラー{{count}}件",
      "sumErrors_other": "データチェックエラー{{count}}件",
      "sumWarns_one": "警告{{count}}件",
      "sumWarns_other": "警告{{count}}件",
      "versionLine": "バージョン{{v}}を表示中",
      "accountsTitle": "口座",
      "transfersTitle": "振替",
      "filesTitle": "銀行明細とスクリーンショット",
      "versionsTitle": "バージョン — インポートまたは入力",
      "historyTitle": "履歴とコメント",
      "current": "処理中",
      "rateFrom_setup": "設定のレート",
      "rateFrom_base": "基準通貨",
      "tot_opening": "期首",
      "tot_inflow": "流入",
      "tot_outflow": "流出",
      "tot_closing": "期末",
      "tot_restricted": "使用制限",
      "tot_fixed_deposit": "定期預金",
      "tot_available": "利用可能額",
      "tr_internal": "エンティティ内",
      "tr_group": "グループ間",
      "kind_statement": "明細",
      "kind_balance": "残高のスクリーンショット",
      "kind_other": "その他",
      "wholeEntity": "エンティティ全体",
      "attach": "ファイルを添付",
      "attached": "ファイルを添付しました。",
      "removeFile": "このファイルを削除",
      "noFiles": "添付ファイルはありません。",
      "commentPh": "コメントを入力…",
      "comment": "コメント",
      "noEvents": "まだ何も行われていません。",
      "waitingYou": "あなたの対応待ち",
      "waitingOpen": "承認画面で開いて判断してください",
      "ev_upload": "ファイルからバージョン{{v}}をインポートしました",
      "ev_entry": "ポータルで修正したバージョン{{v}}を保存しました",
      "changesAgainst": "バージョン{{v}}からの変更 — {{n}}",
      "noChange": "バージョン{{v}}から変更された数値はありません。",
      "moreChanges": "さらに{{n}}件を表示",
      "fewerChanges": "表示を減らす",
      "changesCut": "…ほか{{n}}件。",
      "ev_discard": "バージョン{{v}}を取り消しました",
      "cancelled": "取消済み",
      "ev_submit": "バージョン{{v}}を確認者に送信しました",
      "ev_review": "確認・了承しました",
      "ev_approve": "承認しました",
      "ev_close": "承認してクローズしました",
      "ev_return": "差し戻しました",
      "ev_comment": "コメントしました",
      "ev_file": "ファイルを添付しました",
      "ev_unfile": "ファイルを削除しました"
    },
    "cashp": {
      "title": "キャッシュレポート · 13週キャッシュプラン",
      "sub": "各エンティティは13週先までの計画をSGDで作成し（Template 2）、その計画を後に出る週次キャッシュレポートの内容と照らし合わせます。計画は毎週新しく作成します。ステップは週次レポートと同じ2段階です。",
      "startsLine": "{{week}}開始のプラン（{{end}}終了の週）、{{last}}まで",
      "h_week": "週番号",
      "h_end": "週末日",
      "h_planOpen": "期首（前週の期末）",
      "h_planIn": "計画流入",
      "h_planOut": "計画流出",
      "h_planClose": "計画期末（予定）",
      "h_actIn": "実績流入",
      "h_actOut": "実績流出",
      "h_actClose": "実績期末",
      "h_variance": "計画との差異（期末）",
      "h_weekly": "週次レポート",
      "h_reported": "報告済み",
      "h_comment": "コメント",
      "h_planClose13": "計画期末、第13週",
      "h_planOpen1": "期首、第1週",
      "h_planIn13": "計画流入、13週",
      "h_planOut13": "計画流出、13週",
      "noReviewed": "確認済みのプランはまだありません",
      "reportedOf": "{{n}}件報告済み",
      "noPlan": "今週開始のプランをアップロードしたエンティティはまだありません。",
      "openWhy": "このエンティティの年間プランを開閉",
      "groupPlanned": "確認済みのプラン：{{of}}エンティティ中{{n}}エンティティ",
      "listHint": "今週分の各エンティティのプランの状況です。上のグラフと表は選択内容に連動します。",
      "pickLabel": "表示",
      "pickGroup": "GROUP（全エンティティ）",
      "pickGroupWhy": "全エンティティの合計",
      "filtersTitle": "プランを絞り込み",
      "filterEntities": "エンティティ",
      "filtersHint": "GROUP、1つのエンティティ、または複数のエンティティ（合算されます）を選び、次に年を選んでください。下のグラフと53週の表は両方に連動します。",
      "oneYear": "現時点でプランは1年分です",
      "weeksShown": "{{of}}週中{{count}}週",
      "h_planFrom": "参照プラン",
      "planFromWhy": "{{week}}開始のプランから読み込み — この週を対象とする最新のプランです",
      "plannedBy_one": "{{count}}エンティティ",
      "plannedBy_other": "{{count}}エンティティ",
      "yearOf": "{{year}}年の全週",
      "yearNote": "1年の全週です。各週は、その週を対象とする最新のプランから読み込みます。過ぎた週はその週用に提出されたプラン、これから先の週は最新の予測が対象で、「参照プラン」にそのプランが表示されます。",
      "groupTitle_one": "GROUP — {{count}}エンティティが計画",
      "groupTitle_other": "GROUP — 今週計画した{{n}}エンティティの合計",
      "groupNote": "GROUPは今週計画したエンティティの合計です。実績は、そのすべてが当該週を報告した時点で計上されるため、差異が、一部のエンティティの実績を全エンティティの計画と比べる形になることはありません。",
      "entityNote": "実績は週次キャッシュレポート自体のSGD数値です（流入・流出はエンティティ内の振替を除き、期末＝銀行の期末残高）。差異＝実績期末−計画期末。",
      "panelHeading": "{{week}}開始のプラン",
      "opening": "期首現金（SGD）",
      "closing13": "計画期末、第13週（SGD）"
    },
    "cashm": {
      "title": "キャッシュレポート · 月末照合",
      "sub": "各エンティティは月末にすべての口座を照合します（Template 3）。月次の銀行明細の期末残高を、週次キャッシュレポートの週末期末残高（月末以前で最後の週末）と照らし合わせ、両日付の間に動いた金額も確認します。照合＝差異−流入＋流出で、0になる必要があります。ステップは週次レポートと同じ2段階です。",
      "monthLine": "{{month}} · 月末 {{end}}",
      "open": "照合を開始",
      "notEnded": "まだ終了していません",
      "notEndedLine": "この月はまだ終了していません — 終了すると照合を開始できます。",
      "ruleHead": "週末：{{week}}（{{end}}）。",
      "h_reconciled": "照合済み口座",
      "h_totalSgd": "月末期末残高（SGD）",
      "h_monthEnd": "月末期末残高",
      "h_weekEnd": "週末期末残高（{{week}}）",
      "h_variance": "差異",
      "netOff": "相殺",
      "statusGroup": "ステータス",
      "h_netIn": "相殺流入",
      "h_netOut": "相殺流出",
      "h_reconcile": "照合",
      "accountsTitle": "口座",
      "reconciled": "照合済み口座",
      "totalSgd": "月末期末残高（SGD）",
      "unconvertedWhy": "週末の為替レートが設定にない口座は、SGD合計から除外されます。",
      "monthEndOn": "月末 {{d}}",
      "st_submitted": "作成済み",
      "st_reviewed": "確認済み",
      "st_approved": "承認済み",
      "st_closed": "クローズ済み",
      "unconverted": "レートなし{{n}}件",
      "allReconciled": "{{n}}件すべて照合済み",
      "reportNote": "各エンティティの行には、SGDの月末期末残高と、照合を作成・確認した担当者が表示されます。その下に各口座が口座自体の通貨で続きます。エンティティを押すと、その照合が開きます。"
    },
    "cashq": {
      "title": "承認",
      "sub": "作成者が送信したレポート（週次キャッシュレポート、13週キャッシュプラン、月末照合）の一覧です。1件選んで内容を読み、了承するか差し戻してください。確認者が了承すると、レポートがキャッシュレポートに表示されます。差し戻されたレポートは、再送信されるまで「進行中」に残ります。",
      "tab_waiting": "あなたの対応待ち",
      "tab_progress": "進行中",
      "tab_closed": "了承済み",
      "rows_one": "{{count}}件のレポート",
      "rows_other": "{{count}}件のレポート",
      "clear": "並べ替えとフィルターをクリア",
      "colReport": "レポート",
      "colEntity": "エンティティ",
      "colPeriod": "期間",
      "colStatus": "ステータス",
      "colSentBy": "送信者",
      "colSentAt": "送信日",
      "colUpdated": "最終更新",
      "empty_waiting": "判断待ちのものはありません。",
      "empty_progress": "各ステップの途中にあるレポート、または作成者に差し戻されているレポートはありません。",
      "empty_closed": "了承されたレポートはまだありません。",
      "notListed": "そのレポートはあなたのキューにありません — まだ送信されていないか、閲覧権限がない可能性があります。"
    },
    "cashi": {
      "title": "提出",
      "sub": "ご自身のエンティティ用に各テンプレートをダウンロードし、入力してインポートし、チェックして確認者に送信してください。",
      "entity": "エンティティ",
      "yoursOne": "設定のユーザーリストに登録されているご自身のエンティティです。",
      "yoursMany": "あなたは{{n}}エンティティの作成者です — 入力するエンティティを選んでください。",
      "notPreparer": "キャッシュレポートのユーザーリストで、あなたはどのエンティティの作成者にもなっていません。ここでは閲覧とダウンロードのみ可能で、インポートはできません。作成者は設定 › ユーザーで指定されます。",
      "noEntity": "表示するエンティティがありません。",
      "checkPassed": "データチェック合格",
      "saveOrCancel": "先に変更を保存するか取り消してから、インポートしてください。",
      "openReport": "{{report}}を開く",
      "pointer": "このレポートは提出画面でインポートして送信します（{{tpl}}）。",
      "pointerReturned": "作成者に差し戻されました — 提出画面で修正して再送信します。",
      "goImport": "提出を開く",
      "pointerDecide": "このレポートはあなたの判断待ちです — 承認画面で了承するか差し戻してください。",
      "nothingYet": "まだ入力されていません — エンティティの作成者が提出画面で{{tpl}}をインポートします。"
    },
    "cashc": {
      "byEntity": "エンティティ別の現金（{{ccy}}）",
      "byEntitySub": "残高を利用可能額、使用制限、定期預金に分けて表示 — 今週は{{of}}エンティティ中{{n}}エンティティが確認済みです。",
      "trend": "GROUPの現金、直近12週（{{ccy}}）",
      "trendSub": "各週に報告したエンティティの残高と利用可能額です。途切れている箇所は、誰も報告しなかった週です。",
      "reported": "{{of}}中{{n}}件報告済み",
      "noneYet": "まだ報告したエンティティはありません。",
      "noTrend": "この期間にレポートのある週はまだありません。",
      "planTitle": "プラン — {{who}}（SGD）",
      "planSub": "計画流入は上向き、計画流出は下向きで表示します。破線は計画期末、実線は週次キャッシュレポートの実績期末です。",
      "monthCash": "エンティティ別の月末現金（SGD）",
      "monthCashSub": "今月は{{of}}エンティティ中{{n}}エンティティが報告済みです。",
      "noRateAll": "{{week}}の為替レートが設定に入るとSGDで表示されます — 報告済みの口座はまだどれも換算できません。",
      "noRateSome": "未表示 — {{week}}の為替レートがまだありません：{{list}}。",
      "recon": "照合済み口座",
      "reconSub": "エンティティ別：照合が0の口座と、差異のある口座です。",
      "reconciled": "照合済み",
      "difference": "差異あり",
      "accounts_one": "{{count}}口座",
      "accounts_other": "{{count}}口座"
    },
    "cashf": {
      "inputTitle": "入力 — {{tpl}}",
      "enterHere": "ポータルで入力",
      "editHere": "ポータルで編集",
      "inputClosed": "このレポートをインポートできるのは、開いている間または差し戻し中のエンティティの作成者だけです。",
      "field1": "フィールド1 — エンティティの実績キャッシュフロー（SGD）",
      "field2": "フィールド2 — エンティティの口座：全取引の合計",
      "field3": "フィールド3 — エンティティ内振替（エンティティ自身の口座間）",
      "field4": "フィールド4 — グループ間取引（他のHelinoxエンティティとの取引）",
      "field5": "フィールド5 — 今週の主な支出 Top 3",
      "field6": "フィールド6 — 来週の支払予定 Top 3",
      "f1Entity": "エンティティ",
      "f1Overall": "全体",
      "f1Group": "グループ間取引",
      "f1NoRate": "フィールド1は、すべての口座の通貨について当週のレートが設定 › 為替レートに入った時点で、SGDで算出されます。",
      "h_rate": "為替レート",
      "h_noTxn": "取引なしの確認",
      "h_restrictedAcct": "使用制限口座",
      "h_fdAcct": "定期預金",
      "h_upStatement": "明細をアップロード",
      "h_upBalance": "残高のスクリーンショットをアップロード",
      "h_entity": "エンティティ",
      "h_no": "No.",
      "h_category": "カテゴリ",
      "h_memo": "メモ",
      "h_amountSgd": "金額（SGD）",
      "fromSetup": "設定の口座種別から取得",
      "rateFromSetup": "設定にある当週のレート",
      "rateMissing": "設定 › 為替レート（NetSuiteから同期）に当週の{{ccy}}レートがありません — ここでは入力できません",
      "closingCalc": "期末＝期首＋流入−流出",
      "closingFiled": "インポートしたファイルの期末は{{v}}でしたが、期首＋流入−流出は表示中の数値になります。ここで保存すると、算出した数値が残ります。",
      "closingDiff": "期首＋流入−流出が、この期末と{{d}}異なっています",
      "memoPh": "内容 — 必要なだけ記入してください",
      "f4None": "今週のグループ間取引はありません。",
      "rateOpt": "SGDへのレート（任意）",
      "noTxn": "取引なし",
      "check": "チェック",
      "ok": "OK",
      "diff": "差異 {{d}}",
      "notNumber": "数値ではありません",
      "noTxnAmounts": "取引なしですが、金額が入力されています",
      "upStatement": "明細",
      "upBalance": "残高",
      "addRow": "行を追加",
      "removeRow": "この行を削除",
      "save": "新しいバージョンとして保存",
      "cancel": "編集を取り消す",
      "cancelImport": "インポートを取り消す",
      "cancelBack": "バージョン{{v}}を取り除き、レポートをバージョン{{back}}に戻します。",
      "cancelEmpty": "バージョン{{v}}を取り除きます — レポートは空に戻り、再インポートできる状態になります。",
      "discardedBack": "バージョン{{v}}を取り消しました — バージョン{{back}}に戻りました。",
      "discardedEmpty": "バージョン{{v}}を取り消しました — レポートは再び空になりました。",
      "noChanges": "まだ変更はありません — 数値を編集するか、ファイルをインポートしてください。",
      "saveHint": "保存すると新しいバージョンが作成され、データチェックが再実行されます。",
      "payrollRule": "給与は合計1行のみです。従業員名や個人の給与額は絶対に入力しないでください。",
      "savedOk": "バージョン{{v}}を保存しました。",
      "savedReplaced": "バージョン{{v}}を保存しました — データチェックに合格し、確認者のもとにあるバージョン{{old}}と置き換わります。",
      "savedErrors_one": "バージョン{{v}}を保存しました — 送信前に修正が必要なデータチェックエラーが{{count}}件あります。",
      "savedErrors_other": "バージョン{{v}}を保存しました — 送信前に修正が必要なデータチェックエラーが{{count}}件あります。",
      "openingFrom": "第1週の前週期末は、{{week}}の週次キャッシュレポートの期末です。誤っている場合のみ修正してください。",
      "prepareDate": "作成日",
      "entityGroup": "エンティティ / グループ",
      "entityLabel": "エンティティ",
      "currency": "通貨",
      "currencySgd": "SGD — このテンプレートの数値はすべてSGDです",
      "planCloseExp": "計画期末（予定）",
      "prevWeek": "前週",
      "thisWeek": "今週",
      "openingNone": "前週の週次キャッシュレポートがありません — 期首現金を入力してください。"
    },
    "gtm": {
      "title": "GTMプログラム",
      "subtitle": "7つの質問に沿ってプログラムを作成し、レビューに送信してください。承認者はGTM › 承認で判断します。",
      "newProgramme": "新規プログラム",
      "createTitle": "プログラムを開始",
      "nameLabel": "タイトル",
      "namePlaceholder": "例：Sunset Chair (re) Home · Book Reading Edition",
      "create": "作成",
      "cancel": "キャンセル",
      "back": "すべてのプログラム",
      "none": "プログラムはまだありません。",
      "openDecisions": "要判断",
      "openVerifies": "要確認",
      "regionsWaiting": "返答待ちの地域",
      "committed": "コミット数量",
      "ofTarget": "／{{n}}",
      "editProgramme": "プログラムを編集",
      "headline": "見出し",
      "openItem": "未対応項目",
      "openItems": "判断、作業、確認",
      "noItems": "この質問に関する項目はまだありません。",
      "lineTitle": "内容",
      "lineDetail": "詳細",
      "inThisProgrammeHint": "含まれる理由、または含まれない理由 — 表がその横に表示する一文です。",
      "discardAsk": "入力した内容を破棄しますか？",
      "needed": "まだ必要です：{{fields}}",
      "editTable": "表を編集",
      "editTableWhy": "表のロックを解除し、好きなだけ行を変更してから、1回の操作で保存します",
      "editTableHint": "自由に入力してください。保存するまで何も書き込まれず、保存は一括で行われます。すべて反映されるか、何も変わらないかのどちらかです。",
      "saveTable": "表を保存",
      "saveTableN": "表を保存（{{n}}）",
      "layerHead": "販売チャネルの上位で動くもの",
      "stage": "ステージ",
      "role": "役割",
      "condition": "条件",
      "addStage": "ステージを追加",
      "orderHead": "順序",
      "orderLabel": "実施する順序",
      "step": "ステップ",
      "stepDetail": "内容",
      "addStep": "ステップを追加",
      "savedN": "{{n}}件の変更を保存しました。",
      "savedNothing": "変更はありませんでした。",
      "regionsHint": "このプログラムの対象地域を優先順に並べています。行をドラッグするか矢印を使うと、順序を変更できます。",
      "sheetLocked": "このシートを変更するには「編集」を押してください。",
      "sheetOpen": "シートは編集可能です。自由に入力してください。「保存」を押すまで何も書き込まれません。行の移動は操作と同時に保存されます。",
      "acrossProgramme": "プログラム全体",
      "qOpenCount": "未対応{{n}}件",
      "removeYes": "削除",
      "waitingOnYou": "あなたの判断待ち",
      "rev_draft": "レビュー未送信",
      "rev_in_review": "承認者に提出中",
      "rev_approved": "承認済み",
      "rev_rejected": "却下",
      "approver": "承認者",
      "sentForReview": "レビュー送信済み",
      "approvedOn": "承認済み",
      "rejectedOn": "却下",
      "sendForReview": "レビューに送信",
      "reviewAgain": "再度レビューに送信",
      "approve": "承認",
      "resubmit": "再提出",
      "sent": "送信済み",
      "view": "表示",
      "kpiAll": "すべてのプログラム",
      "kpiMine": "自分のプログラム",
      "scopeMine": "自分のプログラム",
      "scopeAll": "すべてのプログラム",
      "noneMine": "あなたのプログラムはまだありません — ご自身が作成・送信した、または担当しているものはありません。",
      "showAll_one": "{{count}}件のプログラムを表示",
      "showAll_other": "{{count}}件のプログラムをすべて表示",
      "backApproval": "GTM承認",
      "approvalTitle": "GTM承認",
      "approvalSub": "判断のためにあなたへ送られたプログラムです。下書きは作成者のもとに残り、ここには表示されません。",
      "approvalSubAdmin": "判断のために送られたプログラムです。adminはすべての承認者のキューを閲覧できます。下書きはここには表示されません。",
      "tabWaiting": "判断待ち",
      "tabApproved": "承認済み",
      "tabRejected": "却下",
      "emptyQueue_in_review": "判断待ちのものはありません。",
      "emptyQueue_approved": "承認済みのものはまだありません。",
      "emptyQueue_rejected": "却下されたものはありません。",
      "colSentBy": "送信者",
      "colSentOn": "送信日",
      "colDecidedOn": "判断日",
      "colCreatedBy": "作成者",
      "colCreatedAt": "作成日時",
      "colUpdatedBy": "更新者",
      "colUpdatedAt": "更新日時",
      "colManagerNote": "マネージャーのメモ",
      "colSkus": "プロジェクトSKU",
      "skuHead": "紐付けたプロジェクトSKU",
      "skuHint": "このプログラムで発売するプロジェクトSKUです。同じ紐付けが、Project Tracker内の各SKUのGTM項目になります。",
      "skuNone": "紐付けられたプロジェクトSKUはまだありません。",
      "skuId": "プロジェクトSKU ID",
      "skuName": "SKU名",
      "skuGroup": "プロジェクトグループ",
      "skuStatus": "ステータス",
      "skuPh": "プロジェクトSKUを選択または入力（例：9048 または SKU-09048）",
      "skuAdd": "SKUを紐付け",
      "skuUnlink": "このSKUの紐付けを解除",
      "deleteLockedSent": "レビュー送信済みです — 承認者が保持している間は削除できません。",
      "deleteLockedApproved": "承認済みです — 承認済みのプログラムは削除できません。",
      "countAll_one": "{{count}}件のプログラム",
      "countAll_other": "{{count}}件のプログラム",
      "countOf": "{{total}}件中{{n}}件のプログラム",
      "searchPh": "コード、タイトル、担当者を検索…",
      "clear": "クリア",
      "noMatch": "これらの条件に一致するプログラムはありません。",
      "loading": "読み込み中…",
      "colNo": "No.",
      "colCode": "GTM ID",
      "colTitle": "プログラム",
      "colStatus": "ステータス",
      "colOwner": "担当者",
      "colApprover": "承認者",
      "colLaunch": "発売",
      "colDecisions": "要判断",
      "colVerify": "要確認",
      "colRegions": "地域",
      "colAction": "操作",
      "reviewDone_submit": "レビューに送信しました。",
      "reviewDone_approve": "承認しました。",
      "reviewDone_reject": "却下しました。",
      "coverEyebrow": "GTMプログラム",
      "printedOn": "印刷日",
      "coverStatus": "レビュー",
      "coverDecisionNote": "判断メモ",
      "exportPdf": "PDFをエクスポート",
      "delete": "削除",
      "deleteProgramme": "このプログラムを削除",
      "deleteBody": "これにより、{{n}}行と、その配下の{{photos}}枚の写真が削除されます。",
      "deleteWarn": "この操作は元に戻せません。",
      "exporting": "エクスポート中…",
      "pdf": "PDF",
      "addStop": "停止条件を追加",
      "stopKind_manual": "手動で監視",
      "stopKind_commit_min": "地域のコミットが基準値未満",
      "stopKind_anchor_consent": "主導地域の担当者が同意していない",
      "stopKindAsk": "ポータルは何を読み取りますか？",
      "deleteYes": "削除する",
      "measureHead": "成功の測り方",
      "measureHint": "それぞれが何であり、何をもって良好とするか。",
      "measureItem": "指標",
      "measureWhat": "内容と判断基準",
      "measurePh": "Defence、Edition、Inline…",
      "timelineHead": "タイムライン · 担当者",
      "timelineHint": "このプログラムの進め方と、各ステップの担当者。",
      "timelineStep": "ステップ",
      "timelineStage": "フェーズ",
      "timelineWho": "実施内容",
      "timelinePh": "担当者の割り当て、判断、発売…",
      "timelineWhen": "予定",
      "timelineNote": "対象者",
      "stopWhere": "現在の状況",
      "stopThreshold": "基準値",
      "removeDoc": "それでも削除",
      "removeDocWhy": "この行はマスタープランから取り込まれたものです。インポートを再実行すると元に戻ります。",
      "keepIt": "残す",
      "specHead": "項目と内容",
      "specHint": "発売前に用意すべきもの：各項目とその内容。それ以外は行を追加してください。",
      "specItem": "項目",
      "specItemPh": "フレーム、ポケット、価格…",
      "specA": "Inline",
      "specB": "Edition",
      "photosHead": "写真",
      "photosHint": "このプログラムが参照する画像です。キャプションで、それぞれが何を指しているかを説明します。",
      "discoverHead": "見つけてもらう方法",
      "discoverHint": "発売前、発売当日、発売後に行うこと。",
      "discoverPh": "コンテンツ、シーディング、招待…",
      "noLines": "まだ何もありません。",
      "collapseAll": "すべて折りたたむ",
      "expandAll": "すべて展開",
      "fieldTitle": "タイトル",
      "stopHead": "停止条件（案）",
      "stopNone": "停止条件は設定されていません。",
      "tripped": "停止発動",
      "holding": "継続中",
      "addLine": "行を追加",
      "lineKind": "種別",
      "persona": "ペルソナ",
      "channel": "チャネル",
      "inThisProgramme": "このプログラムに含む",
      "remarks": "備考",
      "select": "選択",
      "selectHint": "行にチェックを入れるか、下の追加ボックスで選ぶと選択されます。選択した行の並び順が優先順位です。行をドラッグするか矢印を使うと、順序を変更できます。",
      "regionsCount": "このプログラムの地域",
      "specContent": "内容",
      "timelineOwner": "担当者",
      "discoverItem": "項目",
      "discoverDetail": "実施内容",
      "trkTitle": "GTMトラッカー",
      "trkSub": "承認済みのプログラムと、各プログラムのタイムライン · 担当者に沿ったステップごとの進捗です。作業の進行に合わせてステップを「進行中」または「完了」にしてください。予定日を過ぎても完了していないステップには「遅延」が付きます。",
      "trkApproved": "承認済みプログラム",
      "trkStepsDone": "完了したステップ",
      "trkOverdue": "遅延",
      "trkOnlyOverdue": "遅延ステップのあるプログラムのみ表示",
      "trkSearch": "プログラム、ステップ、担当者を検索…",
      "trkToday": "本日：{{day}}",
      "trkNone": "承認済みのプログラムはまだありません。",
      "trkApprovedBy": "承認者",
      "trkStepsOf": "{{total}}ステップ中{{done}}ステップ完了",
      "trkNoSteps": "タイムラインのステップはまだありません",
      "trkOverdueN_one": "遅延{{count}}件",
      "trkOverdueN_other": "遅延{{count}}件",
      "trkNext": "次",
      "trkAllDone": "すべてのステップが完了しています",
      "trkStatus": "ステータス",
      "trkDoneOn": "完了日",
      "trkNoStepsHint": "このプログラムにはタイムラインのステップがまだありません。プログラムのタイムライン · 担当者で追加してください。",
      "st_not_started": "未着手",
      "st_in_progress": "進行中",
      "st_done": "完了",
      "trkProgress": "進捗",
      "trkNextDue": "次のステップの期日",
      "trkApprovedOn": "承認済み",
      "listNew": "新規：次回以降のためにリストに追加されます。",
      "listAllIn": "リストにあるものはすべて、すでにこのプログラムに含まれています。新しく入力してください。",
      "listDup": "このプログラムですでに選択されています。",
      "listHave": "すでにこのプログラムに含まれています。",
      "listPick": "リストから選ぶか、新しく入力してください",
      "addPersona": "ペルソナを追加",
      "addChannel": "チャネルを追加",
      "removeRow": "削除",
      "removeAsk": "「{{name}}」を削除しますか？この操作は元に戻せません。",
      "add": "追加",
      "noteOnTable": "この表についてのメモ",
      "noteOnTableHint": "上の表では伝えられないこと — 注意点や、表に含まれていないこと。",
      "moveUp": "上へ移動",
      "moveDown": "下へ移動",
      "targetAudience": "選択したペルソナ — 優先順",
      "notATarget": "未選択",
      "channelsInUse": "選択したチャネル — 優先順",
      "channelsOut": "未選択",
      "chStatus_green": "全社のチャネル状況：良好",
      "chStatus_amber": "全社のチャネル状況：要注意",
      "chStatus_red": "全社のチャネル状況：低調",
      "notYet": "まだ回答できません",
      "unmeasured": "手動で監視",
      "stopNote": "プログラムを運営する担当者が、各条件の現状を記入します。",
      "question": "質問{{n}}",
      "emptySection": "まだ回答がありません。",
      "oneChange": "1つのセクションが変更されました",
      "nChanges": "{{count}}個のセクションが変更されました",
      "discard": "破棄",
      "edit": "編集",
      "save": "保存",
      "decision": "要判断",
      "verify": "要確認",
      "addDecision": "判断事項を追加",
      "addVerify": "確認事項を追加",
      "todo": "対応予定",
      "addTodo": "対応事項を追加",
      "phaseFilter": "発売フェーズ",
      "allPhases": "すべてのフェーズ",
      "phaseHintOne": "{{phase}}のみ表示中 — 未対応{{all}}件のうち{{hidden}}件が非表示です。もう一度押すか「すべてのフェーズ」を押すと、元に戻ります。",
      "phaseWhy_all": "プラン内の、時期が決まっているものすべて",
      "phaseWhy_before": "Q5 — 作業開始前に用意すべきものと、まだ未決の判断事項",
      "phaseWhy_pre": "Q6 — 発売前：発売日より前",
      "phaseWhy_launch": "Q6 — 発売：当日",
      "phaseWhy_post": "Q6 — 発売後：発売された後",
      "workNone": "まだ何も登録されていません。",
      "phase_before": "開始前",
      "phase_pre": "発売前",
      "phase_launch": "発売",
      "phase_post": "発売後",
      "noPhase": "フェーズなし",
      "owner": "担当者",
      "noOwner": "担当者なし",
      "due": "期日",
      "noDue": "日付なし",
      "answer": "回答",
      "answered": "回答済み",
      "dropped": "取り下げ済み",
      "open": "未対応",
      "remove": "削除",
      "regionsHead": "地域",
      "region": "地域",
      "person": "担当者",
      "replyStatus": "返答",
      "consent": "同意",
      "commitQty": "コミット",
      "replyDue": "返答期限",
      "anchor": "主導",
      "note": "メモ",
      "addRegion": "地域を追加",
      "metricsHead": "成功の測り方",
      "metric": "指標",
      "baseline": "ベースライン",
      "baselineWindow": "期間",
      "live": "開始日",
      "takeBaseline": "ベースラインを取得",
      "retakeBaseline": "再取得",
      "baselineTaken": "{{when}}に取得",
      "baselineNotTaken": "未取得",
      "manualMetric": "手入力",
      "baselineWhy": "取得した日の値で固定されます。Shopifyの注文は数か月後に返金されることがあり、数値が自動で再計算されると、基準としている比較の前提が動いてしまうためです。",
      "units": "ユニット",
      "sourceDoc": "元ドキュメント",
      "status": "ステータス",
      "launchTarget": "発売",
      "notSet": "未設定",
      "saved": "保存しました",
      "saveFailed": "保存できませんでした"
    },
    "account": {
      "profile": "プロフィール",
      "listUsers": "ユーザー一覧",
      "createUser": "ユーザーを作成",
      "accessRequests": "アクセス申請",
      "rolesPermissions": "ロールと権限",
      "portalInsights": "ポータル統計",
      "masterData": "マスターデータ",
      "activityLog": "アクティビティログ",
      "logout": "ログアウト"
    },
    "quote": {
      "label": "今日の名言"
    },
    "doc": {
      "title": "ライブラリ",
      "subtitle": "社内ドキュメントです。ここで閲覧するか、バージョンが分かる名前のコピーをダウンロードできます。ポータルには常に最新版があります。",
      "folders": "フォルダ",
      "allDocs": "すべてのドキュメント",
      "unfiled": "未分類",
      "newFolder": "新規フォルダ",
      "newFolderIn": "{{name}}内に新規フォルダ",
      "folderName": "フォルダ名",
      "renameFolder": "名前を変更",
      "deleteFolder": "削除",
      "deleteFolderAsk": "フォルダ「{{name}}」を削除しますか？中身は削除されません。",
      "folderField": "フォルダ",
      "folderNone": "未分類",
      "folderSaved": "フォルダを保存しました。",
      "search": "タイトルまたはコードを検索…",
      "upload": "アップロード",
      "refresh": "更新",
      "none": "あなたと共有されているドキュメントはまだありません。",
      "noMatch": "検索に一致するものはありません。",
      "unread": "未読",
      "acknowledged": "既読",
      "code": "コード",
      "docTitle": "タイトル",
      "version": "バージョン",
      "updated": "更新日",
      "status": "ステータス",
      "changeNote": "変更内容",
      "uploadedBy": "アップロード者",
      "author": "作成者",
      "authorNone": "— 記載なし —",
      "versionAuthor": "このバージョンの作成者",
      "authorSame": "— 前のバージョンと同じ —",
      "byAuthor": "{{name}}作成",
      "authorHint": "文書を書いた人です。アップロードした人とは限りません。",
      "newDoc": "新規ドキュメント",
      "newVersion": "新しいバージョンをアップロード",
      "addingVersionTo": "新しいバージョンを追加：",
      "findDocPh": "コードまたはタイトルを入力 — HB-0001、handbook…",
      "findDocNone": "「{{q}}」に一致するドキュメントはありません。",
      "currentlyAt": "現在{{version}} — 新しいバージョンを追加しても、古いバージョンは下の履歴から閲覧できます",
      "kind": "種別",
      "codeAuto": "Portalが採番します",
      "summary": "概要",
      "everyone": "ライブラリを開ける全員が閲覧できます",
      "narrowHint": "それ以外の場合は、共有するまで、あなたと他のライブラリ管理者のみが閲覧できます。",
      "file": "ファイル",
      "fileKinds": "HTML、PDF、PNG、JPEG、Word、PowerPoint、Excel（.xlsx）はすべてここで閲覧できます。ダウンロードは常に元のファイルです。",
      "noPreview": "この種類のファイルは、どのブラウザでもページ内に表示できません。バージョンとともにここに保存され、アップロード時の名前でダウンロードされます。",
      "download": "ダウンロード",
      "imgBroken": "この画像を開けません — ファイルが破損しているか、ブラウザが読み込めない形式です。ファイルはここに保存されており、アップロード時の名前でダウンロードされます。",
      "versionLabel": "バージョン",
      "versionAuto": "空欄の場合：Portalが直前のバージョンの続きとして付けます",
      "versionFound": "ドキュメント自体から取得：{{version}}",
      "versionNotFound": "ドキュメントの表紙にバージョンが見つかりません — 空欄のままにするとv1.0になります。入力することもできます。",
      "changeNoteLabel": "変更内容（1行）",
      "uploading": "アップロード中…",
      "allDocuments": "すべてのドキュメント",
      "history": "バージョン履歴",
      "latest": "最新",
      "view": "開く",
      "readingOld": "古いバージョンを閲覧中です —",
      "backToLatest": "最新版に戻る",
      "iHaveRead": "読みました",
      "recording": "記録中…",
      "youAcknowledged": "{{version}}を読んだことを確認済みです",
      "noVersion": "バージョンはまだアップロードされていません。",
      "readers": "閲覧状況",
      "readersCount": "通知{{notified}}件中{{opened}}件が開封 · {{acked}}件が確認済み",
      "notified": "通知済み",
      "opened": "開封済み",
      "confirmed": "確認済み",
      "nobody": "まだ誰にも通知していません。",
      "share": "共有",
      "shareLink": "リンクをコピー",
      "linkCopied": "リンクをコピーしました",
      "shareByEmail": "メールで送信",
      "emails": "メールアドレス",
      "emailsHint": "複数の場合は、カンマまたはスペースで区切ってください。",
      "groups": "グループ",
      "person": "宛先",
      "groupsNone": "グループを選択…",
      "groupsClear": "クリア",
      "addGroup": "グループを追加",
      "addGroupName": "グループ名",
      "addGroupEmail": "グループのメールアドレス",
      "addGroupSave": "リストに追加",
      "addGroupHint": "今後、ドキュメントを共有するすべての人にこのグループが表示されます。",
      "groupAdded": "「{{name}}」をリストに追加しました。",
      "groupRemoved": "「{{name}}」をリストから削除しました。",
      "removeGroupConfirm": "全員のグループリストから「{{name}}」を削除しますか？",
      "sharers": "共有できる人",
      "sharersIntro": "{{code}}はあなたがアップロードしたため、送信はあなたの役割です。ここで指名した人も送信できます。",
      "sharersIntroAdmin": "{{code}}は{{owner}}がアップロードしました。あなたは管理者として送信でき、ここで指名された人も送信できます。",
      "sharersNone": "他にはいません。このドキュメントを送信できるのは、{{owner}}と管理者のみです。",
      "sharersAdd": "ユーザーを追加",
      "sharersPick": "ユーザーを選択…",
      "sharersFind": "名前またはアドレスを入力…",
      "sharersNoMatch": "該当する人はいません。",
      "sharersAddN": "共有権限を付与（{{count}}）",
      "sharersSaved": "共有できる人を保存しました。",
      "sharersUploader": "アップロード者",
      "cannotShare": "このドキュメントを送信できるのは、{{owner}}と管理者のみです。",
      "sendNote": "メモ（任意 — 未入力の場合は変更内容を使用）",
      "send": "通知を送信",
      "sending": "送信中…",
      "sentTo": "{{count}}件の宛先に送信しました。",
      "remove": "削除",
      "edit": "編集",
      "save": "保存",
      "saving": "保存中…",
      "savedMsg": "保存しました。",
      "noteOfVersion": "変更内容は、現在リストにあるバージョン{{version}}のものです。",
      "comments": "コメント",
      "noComments": "コメントはまだありません。最初の質問は、他の誰かも疑問に思っていることが多いものです。",
      "commentPlaceholder": "このドキュメントについて質問する、または誰かに返信する…",
      "commentHint": "このドキュメントを開ける全員にコメントが表示されます。Ctrl+Enterで投稿します。",
      "post": "投稿",
      "posting": "投稿中…",
      "commentGone": "このコメントは削除されました。",
      "deleteComment": "削除",
      "deleteCommentTitle": "このコメントを削除しますか？",
      "deleteCommentBody": "全員から見えなくなります。会話内の位置は、削除済みとして残ります。",
      "removeTitle": "このドキュメントを削除しますか？",
      "removeConfirm": "全員のリストから消え、リンクも開けなくなります。閲覧記録は保持され、コードが別のドキュメントに割り当てられることはありません。",
      "removedMsg": "{{code}}をライブラリから削除しました。",
      "cancel": "キャンセル",
      "removed": "削除しました。"
    },
    "home": {
      "morning": "おはようございます",
      "afternoon": "こんにちは",
      "evening": "こんばんは",
      "myWork": "私の業務 — {{role}}",
      "notLinkedToEmployee": "このポータルアカウントは、まだ従業員レコードに紐付けられていないため、業務をあなたに関連付けられません。管理者に紐付けを依頼してください。",
      "notLinkedToSalesRep": "このアカウントは、まだSales Repに紐付けられていないため、プロジェクトをあなたに関連付けられません。管理者に紐付けを依頼してください。",
      "targetLaunch": "目標発売月",
      "ack": "了解",
      "ackTitle": "この却下を確認したことを記録します — このカードには表示されなくなります",
      "lateThreshold": "遅延とみなす日数",
      "saved": "保存しました",
      "lateThresholdRange": "1-365",
      "save": "保存",
      "ackUndo": "元に戻す",
      "seenCount": "確認済み{{n}}件 — 表示",
      "viewAs": "表示対象",
      "allOf": "全員 — {{role}}",
      "viewAll": "全員",
      "repNoAccount": "アカウント未紐付け",
      "openThisList": "このリストをSample Trackerで開く",
      "andMore": "ほか{{n}}件",
      "workload": {
        "title": "週別ワークロード",
        "sub": "毎週月曜日のスナップショット — その朝に各PICが抱えていた案件です",
        "rounds": "進行中のラウンド",
        "projects": "進行中のプロジェクト",
        "pic": "担当者",
        "change": "前週比",
        "total": "合計",
        "reconstructed": "この週は、その月曜日の朝には集計されておらず、後から補完されたものです。",
        "cellRounds": "生産中 {{prod}} · 結果待ち {{pending}} · RM待ち {{wait}}",
        "note": "進行中のラウンド＝In Production＋Pending Outcome。*の付いた週は、その月曜日には集計されておらず、後から補完されたものです。"
      },
      "noModules": "あなたのアカウントには、まだモジュールが付与されていません。管理者にアクセスを依頼してください。"
    },
    "tc": {
      "colNo": "No.",
      "colAction": "操作",
      "stateActive": "有効",
      "stateInactive": "無効",
      "title": "チケットコード",
      "subtitle": "チケットコードのドロップダウンの元になるマスターリストです。{{n}}件のコード。",
      "readOnly": "— あなたのロールでは閲覧のみです。",
      "newCode": "新規コード",
      "exportExcel": "Excelにエクスポート",
      "searchPh": "コード、名称、フェーズ、チームを検索…",
      "showInactive": "無効を表示",
      "clearTools": "並べ替えとフィルターをクリア",
      "countOf": "{{total}}件中{{n}}件",
      "loading": "読み込み中…",
      "saving": "保存中…",
      "btnEdit": "編集",
      "btnView": "表示",
      "btnViewHint": "このコードを表示（閲覧のみ）",
      "btnClose": "閉じる",
      "formView": "チケットコード {{code}}",
      "viewOnly": "閲覧のみ",
      "btnSave": "保存",
      "btnCancel": "キャンセル",
      "formNew": "新規チケットコード",
      "formEdit": "{{code}}を編集",
      "fCode": "コード",
      "fTeam": "チーム",
      "fCase": "ケース",
      "fCategory": "カテゴリ",
      "fName": "チケット名",
      "fPhase": "フェーズ",
      "fAssignedTo": "担当者",
      "fGroupEmail": "グループメール",
      "fNote": "メモ",
      "fActive": "有効 — 無効にしたコードは、すでにそのコードを使っているチケットには残りますが、新規チケットフォームでは選択肢に表示されなくなります",
      "phCase": "A / B / 空欄",
      "phName": "サンプル開発依頼",
      "phTeamSearch": "チームを検索…",
      "everyCategory": "すべてのカテゴリ",
      "created": "{{code}}を作成しました。",
      "saved": "{{code}}を保存しました。",
      "nothingToExport": "エクスポートするものがありません",
      "preparingExport": "Excelエクスポートを準備中…",
      "exported": "{{n}}件のコードをエクスポートしました",
      "exportFailed": "エクスポートに失敗しました",
      "exportInclInactive": "無効なコードを含む",
      "exportActiveOnly": "有効なコードのみ"
    },
    "pa": {
      "title": "プロジェクト承認",
      "subtitle": "新規プロジェクトは、ここで承認されるまで保留のままです。承認されていないプロジェクトには、チケットを発行できません。",
      "tabPending": "保留中",
      "tabApproved": "承認済み",
      "tabRejected": "却下",
      "tabSettings": "設定",
      "loading": "読み込み中…",
      "saving": "保存中…",
      "working": "処理中…",
      "countAll": "{{n}}件のプロジェクト",
      "countOf": "{{total}}件中{{n}}件のプロジェクト",
      "chartPick": "グラフ：{{label}} · {{n}}件のプロジェクト",
      "chartPickClear": "すべてのプロジェクトを再表示",
      "allTeams": "すべてのチーム",
      "scopeHint": "どのチームのプロジェクトを表示するか",
      "clearTools": "並べ替えとフィルターをクリア",
      "searchPh": "プロジェクト、SKU、チーム、担当者を検索…",
      "rejectedChip": "却下 · {{n}} SKU",
      "rejectedChipHint": "承認者から差し戻されたSKUが{{n}}件あります — 修正して「再提出」を押してください。",
      "selected": "{{n}}件選択中",
      "decideSelected": "選択分を判断",
      "clearSelection": "選択を解除",
      "emptyFiltered": "検索または列フィルターに一致するプロジェクトはありません。",
      "emptyPending": "承認待ちのものはありません。",
      "emptyTab": "{{tab}}のプロジェクトはありません。",
      "colNo": "No.",
      "colProjectId": "プロジェクトグループID",
      "colProjectName": "プロジェクト名",
      "colTeam": "チーム",
      "colManager": "マネージャー",
      "colOwner": "担当者",
      "colSalesRep": "営業担当",
      "colCategory": "カテゴリ",
      "colSeason": "シーズン",
      "colPartner": "パートナー / ライン",
      "colTargetLaunch": "目標発売",
      "colSkus": "SKU",
      "colRequestedBy": "依頼者",
      "colRequestedAt": "依頼日時",
      "colManagerNote": "マネージャーのメモ",
      "colApprovedBy": "承認者",
      "colApprovedAt": "承認日時",
      "colApprovedOpinion": "承認コメント",
      "colRejectedBy": "却下者",
      "colRejectedAt": "却下日時",
      "colReason": "理由",
      "colAction": "操作",
      "btnView": "表示",
      "btnApprove": "承認",
      "btnEdit": "編集",
      "btnResubmit": "再提出",
      "btnCancel": "キャンセル",
      "btnClose": "閉じる",
      "btnSaveChanges": "変更を保存",
      "btnApproveN": "{{n}}件を承認",
      "btnRejectN": "{{n}}件を却下",
      "notYourTeam": "このプロジェクトは別のチームのものです — 変更できるのは、プロジェクト担当者、そのチームのマネージャー、またはadminのみです。",
      "dlgResubmitTitle": "{{id}}を再提出",
      "dlgDecisionOne": "{{id}}の判断",
      "dlgDecisionBulk": "{{n}}件のプロジェクトの判断",
      "dlgStatus": "承認ステータス",
      "dlgAgree": "同意",
      "dlgReject": "却下",
      "skuToggle": "このプロジェクトの{{n}}件のSKUを表示",
      "skuNone": "このプロジェクトにはまだSKUがありません。",
      "skuId": "SKU",
      "skuItem": "アイテム",
      "skuCategory": "カテゴリ",
      "skuQty": "数量",
      "skuPrice": "目標",
      "skuExf": "EXF",
      "skuPic": "開発担当 / デザイナー",
      "skuStatus": "ステージ",
      "skuTba": "TBA",
      "skuState": "承認",
      "skuNote": "承認者のメモ",
      "skuSt_unsent": "未送信",
      "skuSt_waiting": "承認待ち",
      "skuSt_approved": "承認済み",
      "skuSt_rejected": "未承認",
      "skuPicked": "{{n}}件のSKUを選択中",
      "skuWithApprover": "送信済み — 承認者が判断します。",
      "skuNotYours": "未送信 — 依頼元のチームが送信します。",
      "skuDoneAlready": "判断済みです。",
      "skuNoneYours": "あなたの対応待ちのものはありません。",
      "submitPickFirst": "送信するSKUにチェックを入れるか、プロジェクトにチェックを入れてすべて送信してください。",
      "skuNotRefused": "却下されていません — 差し戻すものはありません。",
      "resubmitSome": "{{n}}件を再提出",
      "dlgBackHead": "各SKUの変更内容（{{n}}件を差し戻し）",
      "dlgBackWas": "未承認",
      "dlgBackWhy": "このSKUの変更内容",
      "skuMgrNote": "マネージャーのメモ",
      "submitSome": "{{n}}件を提出",
      "submitSomeHint": "下でチェックした{{n}}件のSKUのみ送信します。残りはそのままです。",
      "approveSome": "{{n}}件を判断",
      "approveSomeHint": "下でチェックした{{n}}件のSKUのみ判断します。",
      "dlgSkuHead": "SKUごとに判断（{{n}}件待ち）",
      "dlgAllApprove": "すべて承認",
      "dlgAllReject": "すべて却下",
      "dlgSkuWhy": "このSKUを承認しない理由",
      "dlgSkuDefault": "✕を付けない限り、ここのSKUはすべて承認されます。",
      "dlgSkuYes": "承認",
      "dlgSkuNo": "未承認",
      "dlgSkuUndo": "このSKUを承認に戻す",
      "dlgWasApproved": "以前に承認済み",
      "dlgWasRejected": "以前に却下済み",
      "btnApproveSkus": "{{n}}件のSKUを承認",
      "btnRejectSkus": "{{n}}件のSKUを却下",
      "btnPartial": "{{yes}}件を承認、{{no}}件を却下",
      "stPartial": "一部承認",
      "dlgUnchangedTitle": "却下後に何も編集されていません。",
      "dlgUnchangedBody": "承認者から求められた点を修正するか（行の「編集」）、このまま承認すべき理由を下に記入してください。変更なしで差し戻すにはメモが必須です。",
      "dlgManagerOpinion": "マネージャー意見",
      "dlgApproverOpinion": "承認者意見",
      "dlgPhReject": "このプロジェクトを承認しない理由は何ですか？チームに表示されます。",
      "dlgPhResubmitRequired": "必須：変更なしで承認すべき理由は何ですか？",
      "dlgPhResubmit": "却下後に何を変更しましたか？（任意）",
      "dlgPhOptional": "内容を入力（任意）",
      "secProject": "プロジェクト情報",
      "secSku": "SKU情報",
      "fTeam": "チーム",
      "fOwner": "プロジェクトオーナー（Sales OP）",
      "fCategory": "カテゴリー",
      "fSeason": "シーズン",
      "fPartner": "パートナー／ライン",
      "fKeyword": "キーワード",
      "fTargetLaunch": "目標発売時期（月）",
      "fCase": "ケース",
      "fEntity": "エンティティ",
      "selectTeam": "チームを選択…",
      "selectOwner": "オーナーを選択…",
      "pickTeamFirst": "先にチームを選択してください",
      "noMember": "このチームにはまだメンバーがいません。List Usersで設定してください",
      "addSku": "+ SKUを追加",
      "noSkuYet": "SKUはまだありませんが、問題ありません。SKUはいつでも追加できます。",
      "skuSaveHint": "新しいSKUは保存時に作成されます。既存のSKUの削除は、保存を待たずにすぐ実行されます。",
      "fillRequired": "先に必須項目を入力してください：",
      "couldNotSave": "保存できませんでした：",
      "rejectedBy": "{{who}}が却下：",
      "managerNoteLabel": "マネージャーメモ：",
      "submit": "提出",
      "submitSelected": "選択分を承認者に提出",
      "readyToSubmit": "{{total}}件中{{n}}件が提出可能",
      "nothingToSubmit": "提出できるものがチェックされていません。送信済みか、他チームのものです。",
      "sent": "送信済み",
      "submittedOn": "承認者に提出済み：{{when}}",
      "remind": "催促",
      "remindHint": "送信：{{when}}・{{n}}件のSKUが承認者の対応待ちです。催促を送信します。",
      "remindSent": "{{to}}に催促を送信しました。{{n}}件のSKUが待機中です",
      "lockedSubmitted": "提出済みです。承認者が保持しており、受信したメールには送信時の値がそのまま表示されています。",
      "drop": "削除",
      "dropTitle": "このプロジェクトを削除",
      "dropSubmitted": "提出済みのため削除できません。",
      "dropHead": "{{id}}を削除しますか？",
      "dropChecking": "このプロジェクトに紐づく内容を確認しています…",
      "dropWarnOne": "1件のSKUが削除されます。サンプルのラウンドは残り、プロジェクトなしでSample Trackerに残ります。この操作は元に戻せません。",
      "dropWarnMany": "{{n}}件のSKUが削除されます。サンプルのラウンドは残り、プロジェクトなしでSample Trackerに残ります。この操作は元に戻せません。",
      "dropTicketsOne": "このプロジェクトの1件のチケットがキャンセルされ、受付チームに通知されます：",
      "dropTicketsMany": "このプロジェクトの{{n}}件のチケットがキャンセルされ、受付チームに通知されます：",
      "dropEmailed": "メール送信済み",
      "dropReason": "キャンセルする理由は何ですか？（メールに記載されます）",
      "dropConfirm": "プロジェクトを削除",
      "dropBusy": "削除中…",
      "approverNoteLabel": "承認者メモ：",
      "setTitle": "承認メール",
      "setNote": "「プロジェクト承認依頼」メールの送信先です。ここで変更できます。デプロイは不要です。",
      "setApprover": "承認者（To）",
      "setCc": "CC（カンマ区切り）",
      "setGate": "承認ゲートが有効（新規プロジェクトは保留で開始し、チケットはブロックされます）",
      "setSave": "承認設定を保存",
      "setSaved": "承認設定を保存しました。"
    },
    "tour": {
      "title": "画面ガイド",
      "ciTabsT": "テンプレートごとに1タブ",
      "ciTabsB": "テンプレート1はWeekly Cash Report、テンプレート2は13 Weeks Cash Plan、テンプレート3はMonth-End Reconcileです。提出するものを選んでください。",
      "ciPeriodT": "あなたのエンティティと期間",
      "ciPeriodB": "エンティティは担当に連動します。Cash ReportのUserリストにあるPreparer行から決まり、複数のエンティティを担当する場合のみドロップダウンが表示されます。矢印で前後の週（または月）に移動し、横の行にレポートの期日が表示されます。",
      "ciStepsT": "このレポートの進捗",
      "ciStepsB": "Preparer → Reviewer。完了したステップが点灯し、Reviewerが同意するとレポートの数値がCash Reportに表示されます。",
      "ciTemplateT": "テンプレートをダウンロード",
      "ciTemplateB": "このエンティティと期間用のExcelテンプレートで、口座はあらかじめ入力済みです。記入してインポートしてください。数値はPortal上では入力しません。",
      "ciImportT": "ファイルをインポート",
      "ciImportB": "記入済みのテンプレートをインポートします。バージョンとして登録され、Data Checkが実行されて結果の数値が下に表示されます。誤ったファイルは取り消して、修正版を再度インポートできます。",
      "ciFormT": "ここで修正",
      "ciFormB": "テンプレートをインポートすると、その数値がここに開きます。数値を修正して保存すると、同じData Checkを経て次のバージョンになります。ファイルを再インポートする必要はありません。",
      "ciCheckT": "Data Check",
      "ciCheckB": "すべてのバージョンがチェックされます。エラーはレポートを送信する前に修正が必要です。警告はReviewerが確認できるよう一緒に送られます。",
      "ciSendT": "Reviewerに送信",
      "ciSendB": "Reviewerに伝えたいことがあればメモを追加して送信してください。送信済みのレポートは変更できません。差し戻された場合は、ここで修正して再送信します。",
      "ciFilesT": "銀行明細とスクリーンショット",
      "ciFilesB": "各口座の明細または残高のスクリーンショットを添付してください。レポートをレビュー・承認する全員が閲覧できます。",
      "ciHistoryT": "履歴とコメント",
      "ciHistoryB": "インポート、入力、送信、判断のすべてが、実行者と日時とともにここに一覧表示されます。このレポートについて質問や回答をするには、コメントを書いてください。",
      "ciTestAsT": "テストユーザーとして実行",
      "ciTestAsB": "テスト専用：Cashメールが保留中の間、各ロールを演じて一連の流れを試せます。実行した手順はすべて「test as …」として記録されます。",
      "cqTabsT": "3つのタブ",
      "cqTabsB": "「あなたの対応待ち」には、あなたのレビュー待ちのレポートが古い順に並びます。「進行中」には、別のReviewerが担当しているものと、理由付きでPreparerに差し戻されたものが入ります。「同意済み」にはReviewerが同意したレポートが入り、Cash Reportに表示されるのはこれらです。",
      "cqListT": "送信済みのすべてのレポートを1つのリストに",
      "cqListB": "Weekly Cash Report、13 Weeks Cash Plan、Month-End Reconcileを、全エンティティ・全期間分表示します。各ヘッダーはExcelのように並べ替え・絞り込みができます。行をクリックすると下にそのレポートが開き、もう一度クリックすると閉じます。",
      "cqDecideT": "あなたの判断",
      "cqDecideB": "Review & agreeが最終ステップです。同意するとレポートの数値がCash Reportに表示されます。ボタンを押すとダイアログが開き、同意するか、理由を付けてPreparerに差し戻せます。同意済みのレポートも、理由を付けてここから修正のために再開できます。差し戻されたレポートは、再送信されるまで「進行中」で待機します。",
      "cqCheckT": "Data Check",
      "cqCheckB": "エラーがあるとPreparerは送信できないため、送信済みのレポートにエラーはありません。警告は、判断の前にお読みいただくために一緒に送られています。",
      "cqBodyT": "インポートされた内容",
      "cqBodyB": "Preparerがテンプレートからインポートした数値そのままです。週次レポートのFields 1〜6、プランの13週分、または各口座のreconcileが表示されます。ここでは何も変更できません。誤った数値は差し戻してください。",
      "cqFilesT": "銀行明細とスクリーンショット",
      "cqFilesB": "Preparerが各口座に添付したものです。開いて、数値を銀行の記録と照合してください。",
      "cqHistoryT": "履歴とコメント",
      "cqHistoryB": "誰がいつインポート、送信、判断したかを表示します。レポートを差し戻さずにPreparerへ質問するには、コメントを書いてください。",
      "crNewT": "依頼を開始",
      "crNewB": "商品の送付先、運送会社と請求先のHelinoxアカウント、発送元と宛先、重量、見積コスト、貿易条件を入力します。フォーム横のコストチェックは、入力に合わせて見積をHINCのFedEx契約レートと比較します。「下書きを保存」で入力途中のフォームを保持し、「承認依頼を送信」で承認者に送ります。",
      "crListT": "あなたの依頼",
      "crListB": "1依頼につき1行です。最初の5列は固定され、残りは横にスクロールします。行をクリックすると、送信時のフォームの形で依頼を確認できます。",
      "crCheckT": "コストチェック",
      "crCheckB": "見積を契約レートと比較します：妥当（15%超まで）、要確認（35%超まで）、高い可能性あり。契約の対象外のレーンや運送会社は手動で確認します。",
      "crStatusT": "進捗状況",
      "crStatusB": "下書き（未送信）、承認待ち（承認者が対応中）、承認済み、却下、取り下げ。",
      "crNoteT": "マネージャーメモ",
      "crNoteB": "承認者が判断と一緒に書いた内容です。クリックすると全文を読めます。",
      "crActT": "できること",
      "crActB": "表示・編集（下書き、却下または取り下げ済みの依頼、あるいは承認待ちのもの。保存すると変更点が承認者に通知されます）・下書きの提出・複製して新しい依頼を作成・未承認のものの削除。グレーのボタンは、カーソルを合わせると理由が表示されます。",
      "crqTabsT": "3つのタブ",
      "crqTabsB": "「判断待ち」があなたのキューです。「承認済み」と「却下」には判断済みのものが残ります。",
      "crqListT": "依頼",
      "crqListB": "依頼者、所属エンティティ、経路、運送会社を表示します。最初の5列は固定されます。行をクリックすると、コストチェック付きで依頼を確認できます。",
      "crqNoteT": "マネージャーメモ",
      "crqNoteB": "判断と一緒にあなたが書いた内容です。依頼者の一覧にも表示されます。",
      "crqActT": "表示・編集・承認",
      "crqActB": "編集は承認待ちの依頼を修正します。依頼は承認待ちのままで、変更点が依頼者にメールで通知されます。承認で判断画面が開き、却下はその中にあり、理由が必要です。",
      "crqRatesT": "レート",
      "crqRatesB": "コストチェックが参照するFedEx契約レートのファイル、そのアップロード、燃油サーチャージ、2つのしきい値です。",
      "crTabsT": "3つのレポート",
      "crTabsB": "Weekly Cash Report、13 Weeks Cash Plan、Month-End Reconcileです。ここにはReviewerが同意した数値のみ表示されます。PreparerまたはReviewerの手元にあるレポートは、その所在を示す1行で表示されます。",
      "crPeriodT": "期間",
      "crPeriodB": "週（Month-Endタブでは月）を選択します。矢印で前後に移動します。横の行にレポートの期日が表示されます。",
      "crChartsT": "グラフ",
      "crChartsWB": "エンティティ別の現金（Available、Restricted、Fixed depositに分類）と、GROUPの直近12週間の現金です。棒や点にカーソルを合わせると数値が表示されます。",
      "crChartsPB": "計画の入金は上向き、出金は下向きです。破線は計画の期末残高、実線はWeekly Cash Reportの実績の期末残高です。",
      "crChartsMB": "エンティティ別の月末現金と、照合済みの口座数、差異のある口座数です。",
      "crWeekT": "GROUP、続いて各エンティティ",
      "crWeekB": "最初の行がGROUPで、各エンティティがSGDで続きます。エンティティの行をクリックすると、そのintercompany行と口座が開き、Bank、Account No.、Type of account、Restricted / Fixed depositの列が表示されます。各口座はアップロードされたとおり、それぞれの通貨で表示されます。",
      "crExpandT": "すべてのエンティティを開く／折りたたむ",
      "crExpandB": "「すべて展開」で、各エンティティをここで口座まで、下でTop 3まで開きます。「すべて折りたたむ」で元に戻します。",
      "crTopT": "Top 3",
      "crTopB": "各エンティティの今週の主な支出3件と、来週の支払予定3件をSGDで表示します。アップロードしていないエンティティも一覧に載るため、漏れはありません。",
      "crFiltersT": "2つのフィルター",
      "crFiltersB": "エンティティ：GROUP、1つのエンティティ、または複数をまとめてチェック（合算されます）。年：表示する週の年。グラフと下の表は両方に連動します。",
      "crPlanTableT": "1年の全週",
      "crPlanTableB": "1週につき1行です。過ぎた週はその週に提出されたプランから、これから来る週は最新のプランから読み込まれ、From plan列にその旨が表示されます。実績は、Weekly Cash Reportが同意された後にそこから取得されます。表示中の週は点灯し、各ヘッダーはExcelのように並べ替え・絞り込みができます。",
      "crPlanListT": "今週のプランを作成した人",
      "crPlanListB": "表示中の週における各エンティティのプランです。13週目の計画期末残高と、プランの進捗状況を表示します。",
      "crMonthT": "Reconcile",
      "crMonthB": "各エンティティの行に、SGDの月末残高と、作成者・レビュー担当者が表示されます。その下に各口座がそれぞれの通貨で続きます。Reconcileはすべての口座で0である必要があります。",
      "crWaitingT": "あなたの対応待ち",
      "crWaitingB": "次のステップがあなたの担当であるレポートには、このタグが付きます。クリックするとApprovalでレポートが開き、同意または差し戻しができます。",
      "step": "{{of}}のうちステップ{{n}}",
      "next": "次へ",
      "back": "戻る",
      "done": "完了",
      "skip": "スキップ",
      "stCreateT": "ここで新しいサンプルを開始",
      "stCreateB": "サンプルの対象となるプロジェクトSKUを選択します。1つのSKUにはサンプルが1つだけなので、まだサンプルがないSKUのみ表示されます。このためにProject Trackerへ移動する必要はなくなりました。",
      "stRoundT": "既存のサンプルにラウンドを追加",
      "stRoundB": "P1、P2、P3など。まずサンプルID、Base ID、またはスタイル名を入力してサンプルを探してください。選択すると、それ以外の項目が開きます。",
      "stTrialT": "プロジェクトに紐づかないサンプル",
      "stTrialB": "まだプロジェクトSKUになっていない作業のための例外です。SMPではなくTSMP番号が付きます。",
      "stCardsT": "カードがフィルターになります",
      "stCardsB": "カードをクリックすると、下の表にその条件のものだけが表示されます。もう一度クリックすると解除されます。上の行はサンプル数、その下の行はラウンド数です。",
      "stFiltersT": "さらに絞り込む",
      "stFiltersB": "担当者、デザイナー、R&D拠点で絞り込むか、検索ボックスに入力します。「クリア」を押すと、列ヘッダーのフィルターも含めてすべて元に戻ります。",
      "stRowT": "サンプルを開くとラウンドが表示されます",
      "stRowB": "行の矢印をクリックすると、そのBase IDのすべてのラウンドが表示されます。「すべて展開」で一度にすべて開きます。",
      "stExportT": "Excelに書き出す",
      "stExportB": "フィルターも含め、表に表示されている内容をそのままエクスポートします。"
    },
    "st": {
      "tabAll": "すべてのサンプル",
      "tabSummary": "サンプル別サマリー",
      "tagTrial": "トライアル",
      "pillProject": "プロジェクトサンプル（SMP）",
      "pillTrial": "トライアルサンプル（TSMP）",
      "pillBoth": "両方",
      "pillCtrlHint": "Ctrl／⌘＋クリックで、もう一方と一緒に表示",
      "hintTrial": "プロジェクトSKUに紐づかない単発のサンプルです。Base IDはSMPではなくTSMPです。",
      "titleTracker": "サンプルトラッカー",
      "titleSummary": "サンプル別サマリー",
      "hintTracker": "カードをクリックすると表が更新されます。サンプル行をクリックするとラウンドが展開されます",
      "hintSummary": "Base ID／製品ごとに1行で、最新のスケジュールとラウンドのステータスを表示します",
      "groupSample": "サンプル／Base ID",
      "groupRounds": "ラウンド／ワークフロー",
      "totalSamples": "サンプル合計",
      "totalSamplesSub": "全ステータスのサンプル記録",
      "inProgressSamples": "進行中のサンプル",
      "confirmedSamples": "確定したサンプル",
      "reworkSamples": "Reworkのサンプル",
      "droppedSamples": "中止したサンプル",
      "onHoldSamples": "保留中のサンプル",
      "totalRounds": "ラウンド合計",
      "totalRoundsSub": "全ステータスのラウンド記録",
      "inProgressRounds": "進行中のラウンド",
      "confirmedRounds": "確定したラウンド",
      "reworkRounds": "Reworkのラウンド",
      "droppedRounds": "中止したラウンド",
      "onHoldRounds": "保留中のラウンド",
      "pendingOutcome": "結果待ち",
      "pendingOutcomeSub": "完成日あり、結果なし",
      "rmWaiting": "RM待ち",
      "rmWaitingSub": "材料が未準備",
      "inProduction": "生産中",
      "inProductionSub": "RM準備済み、未完成",
      "allRounds": "すべてのラウンド",
      "allDevelopers": "すべての担当者",
      "allDesigners": "すべてのデザイナー",
      "allLocations": "すべてのR&D拠点",
      "allStatus": "すべてのステータス",
      "searchPlaceholder": "IDまたは品目を検索...",
      "clear": "クリア",
      "newRound": "+ 新規ラウンド",
      "csButton": "+ サンプルを作成",
      "tourButton": "ガイド",
      "tourReopen": "この画面を案内してもらう",
      "csTitle": "サンプルを作成",
      "csIntro": "このサンプルの対象となるプロジェクトSKUを選択してください。サンプルのないSKUのみ表示されます。1つのSKUにはサンプルが1つだけです。",
      "csSearch": "プロジェクト、SKUコード、スタイルを検索…",
      "csCount": "{{projects}}件のプロジェクトに{{skus}}件のSKU",
      "csNone": "有効なSKUにはすべてサンプルがあります。",
      "csNoMatch": "該当するものがありません。",
      "csMore": "ほか{{n}}件。検索を絞り込むと表示されます",
      "trButton": "+ トライアルサンプル（プロジェクト外）",
      "trTitleNew": "新規トライアルサンプル",
      "trAddNewSample": "新規サンプルを追加",
      "trTitle": "トライアルサンプル：プロジェクトなし",
      "trSub": "プロジェクトSKUに紐づかない単発用です。Base IDはSMPではなくTSMPとして発行されます。",
      "trStylePh": "スタイル／品名を入力",
      "trStyleHint": "上で入力してください。トライアルサンプルには、取得元となるプロジェクトSKUがありません",
      "expandAll": "すべて展開",
      "collapseAll": "すべて折りたたむ",
      "exportExcel": "Excelにエクスポート",
      "backToBase": "Base IDビューに戻る",
      "colBaseId": "Base ID",
      "colStyleItem": "スタイル／品目",
      "colRound": "ラウンド",
      "colSeason": "シーズン",
      "colLocation": "R&D拠点",
      "colDeveloper": "担当者",
      "colDesigner": "デザイナー",
      "colProjectId": "プロジェクトSKU ID",
      "colRequestDate": "依頼日",
      "colDevelopmentDue": "開発期日",
      "colRmReady": "RM準備完了",
      "colRoundDue": "ラウンド期日",
      "colSampleFinish": "サンプル完成日",
      "colReceived": "受領",
      "colComment": "コメント",
      "colQty": "数量",
      "colRounds": "ラウンド",
      "colStatus": "ステータス",
      "colDday": "D-day",
      "colDdayHint": "D-DAY＝今日−開発期日。正の値はその日数分だけサンプルが遅延していること、負の値はその日数だけ残りがあることを示します。",
      "colDaysWaiting": "待機日数",
      "goToProject": "このSKUをProject Trackerで開く",
      "colRemarks": "備考",
      "colActions": "操作",
      "colRework": "やり直し",
      "ptNo": "No.",
      "ptId": "ID",
      "ptProjectItem": "プロジェクト／品目",
      "ptNotYours": "このプロジェクトを変更できるのは、プロジェクトオーナー、チームマネージャー、または管理者のみです。",
      "ptNotYourSku": "このSKUを変更できるのは、割り当てられた担当者、プロジェクトオーナー、またはチームマネージャーのみです。",
      "ptDeleteNotYours": "SKUを削除できるのは、プロジェクトオーナー、チームマネージャー、または管理者のみです。",
      "ptCompletedLocked": "このSKUはCompleteで、Productionに通知済みです。編集も削除もできません。",
      "ptTicketNotYours": "このプロジェクトでチケットを発行できるのは、プロジェクトオーナー、チームマネージャー、または管理者のみです。",
      "ptTeam": "チーム",
      "ptOwner": "プロジェクトオーナー",
      "ptCategory": "カテゴリー",
      "ptCase": "ケース",
      "ptEntity": "エンティティ",
      "ptItemCategory": "品目カテゴリー",
      "ptFrameColor": "フレームカラー",
      "ptQty": "QTY",
      "ptAssigned": "担当",
      "ptAllocation": "割り当て",
      "ptStatus": "ステータス",
      "ptSalesRep": "営業担当",
      "ptWhere": "プロジェクトステータス",
      "ptWhereComplete": "完了",
      "ptWhereDropped": "中止",
      "ptWhereActive": "進行中",
      "ptAiHead": "Claudeによる要約",
      "ptAiWriting": "要約中…",
      "ptStart": "開始",
      "ptExfDate": "EXF日",
      "ptTargetPrice": "目標価格（USD）",
      "ptLaunchDate": "発売日",
      "ptWeeksLeft": "残り週数",
      "ptProgress": "進捗",
      "ptRemark": "備考",
      "ptSampleId": "サンプルID",
      "ptAction": "操作",
      "ptTitle": "プロジェクトトラッカー",
      "ptHint": "すべての開発プロジェクトを管理・追跡します",
      "ptGroups": "プロジェクトグループ",
      "ptProjectComplete": "完了したプロジェクト",
      "ptProjectCompleteSub": "すべてのSKUがComplete（またはDropped）",
      "ptProjectDropped": "中止したプロジェクト",
      "ptProjectDroppedSub": "すべてのSKUがDropped",
      "ptProjectActive": "進行中のプロジェクト",
      "ptProjectActiveSub": "未完了のSKUが残っている",
      "ptSkus": "プロジェクトSKU",
      "ptComplete": "SKU完了",
      "ptDrop": "SKU中止",
      "ptActive": "SKU進行中",
      "ptPriority": "SKU優先度",
      "ptViewProject": "このプロジェクトを表示（読み取り専用）",
      "ptViewSku": "このSKUを表示（読み取り専用）",
      "ptViewTag": "閲覧のみ",
      "rmTitleView": "サンプルラウンド",
      "viewRound": "このラウンドを表示（読み取り専用）",
      "viewBase": "このBase IDを表示（読み取り専用）",
      "tkView": "このチケットを表示（読み取り専用）",
      "tkTitleView": "チケット",
      "viewClose": "閉じる",
      "ptViewHint": "読み取り専用です。ここでは何も変更・保存できません。",
      "ptViewClose": "閉じる",
      "ptOnTrack": "SKU順調",
      "ptConcern": "SKU要注意",
      "ptDelayed": "SKU遅延",
      "ptOnHold": "SKU保留",
      "ptShipFinished": "SKU出荷完了",
      "ptAllTeams": "すべてのチーム",
      "ptAllOwners": "すべてのオーナー",
      "ptByMember": "メンバー別",
      "ptByMemberTitle": "プロジェクトオーナー別の作業量",
      "ptByMemberHint": "行をクリックすると、そのオーナーでトラッカーを絞り込みます。件数は上のフィルターに連動します。",
      "ptOverdueExf": "EXF超過",
      "ptAllCategories": "すべてのカテゴリー",
      "ptAllAssignees": "すべての担当者",
      "ptAllAllocation": "すべての割り当て",
      "ptSearch": "プロジェクト／品目を検索...",
      "ptExpandAll": "すべて展開",
      "ptCollapseAll": "すべて折りたたむ",
      "ptColumns": "列",
      "ptReport": "レポート",
      "ptNewProject": "+ 新規プロジェクト",
      "ptExpand": "展開",
      "ptCollapse": "折りたたむ",
      "ptNoProjects": "プロジェクトが見つかりません。",
      "stgLdSoff": "L/D S/OFF",
      "stgProto": "Proto",
      "stgCounter": "Counter",
      "stgCosting": "コスティング",
      "stgHandOffMeeting": "引き継ぎミーティング",
      "stgPpsPpm": "PPS/PPM",
      "stgProduction": "生産",
      "stgFinalInspection": "最終検品",
      "stgExfShipment": "出荷ステータス",
      "stgPayment": "支払い",
      "stgPoStatus": "POステータス",
      "pfNewProject": "新規プロジェクト",
      "pfProjectInfo": "プロジェクト情報",
      "pfProjectInfoHint": "基本情報、スケジュール、ステータス、ステージ、リンクしたサンプル",
      "pfCategory": "カテゴリー",
      "pfSelectCategory": "カテゴリーを選択...",
      "dgpTitle": "プロジェクト{{id}}を削除しますか？",
      "dgpChecking": "このプロジェクトに紐づく内容を確認しています…",
      "dgpSkus": "{{n}}件のSKUが削除されます。",
      "dgpRounds": "サンプルのラウンドは削除されません。プロジェクトとのリンクなしでSample Trackerに残ります。",
      "dgpTickets": "{{n}}件のチケットがキャンセルされ、担当チームに通知されます。",
      "dgpUndo": "ポータルからは元に戻せません。",
      "dgpConfirm": "プロジェクトを削除",
      "dt1Title": "チケット{{id}}を削除しますか？",
      "dt1Emailed": "このチケットはすでに{{to}}にメール送信されています。削除すると依頼がキャンセルされ、以下の理由とともに相手に通知されます。",
      "dt1NotEmailed": "このチケットはメール送信されていないため、ポータル外の誰も存在を知りません。削除しても誰にも通知されません。",
      "dt1ReasonHint": "この行は、受付チームが依頼が消えた理由を知るために読む内容です。",
      "dt1Confirm": "チケットを削除",
      "dt1ConfirmMail": "削除して通知",
      "dtTitle": "{{id}}を削除：チケットがあります",
      "dtLead": "この{{n}}件のチケットはこのプロジェクトに属しています。削除するとキャンセルされ、受け取ったチームに通知されます：",
      "dtNeverEmailed": "メール未送信",
      "dtReason": "削除する理由は何ですか？",
      "dtReasonPh": "例：パートナーがコラボレーションを中止した",
      "dtReasonHint": "この行はキャンセルのメールに記載されます。受付チームが依頼が消えた理由を知るために読む内容です。",
      "dtConfirm": "削除してチケットをキャンセル",
      "gmSkuOnlyHint": "お使いのチームが編集できるのはSKUセクションのみです。上のプロジェクト情報はSales OPの管轄です。",
      "pfReadOnlyHere": "ここでは読み取り専用です。「プロジェクトグループを編集」から編集してください",
      "bmHint": "1つのラウンドではなくBase ID自体に属する内容です：写真と、すべてのラウンドが繰り返し使うスタイル名（ここに{{rounds}}件のラウンド）。",
      "bmStyleHint": "名前の変更は、このBase IDのすべてのラウンドに一括で適用されます。",
      "bmRename": "スタイル名を変更",
      "rmBasePhotos": "サンプル写真（Base ID）",
      "rmPhotoRequired": "必須",
      "rmPhotoNewBase": "このスタイルは新規のため、保存すると新しいBase IDが作成されます。サンプルの写真が最低1枚必要です。写真はBase IDに属するので、以降のラウンドで再度求められることはありません。",
      "rmPhotoExistingBase": "このスタイルはすでに{{baseId}}として存在し、写真もあります。ここで追加するものはありません。",
      "rmPhotoNoStyle": "先にスタイル／品目を入力してください。新しいスタイルは新しいBase IDを作成し、写真が必要です。",
      "pfPurpose": "プロジェクトの目的",
      "pfPurposePh": "なぜ行うのか、どこで販売するのか。",
      "pfPurposeHint": "Sales OP ManagerはSales repに確認する必要があります。CEOはこの行を読んで、go／no-goを判断します。",
      "pfNote": "メモ",
      "pfTeam": "チーム",
      "pfOwner": "プロジェクトオーナー（Sales OP）",
      "pfHandover": "このプロジェクトを{{who}}に引き渡します。保存すると編集できなくなり、{{who}}、{{mgr}}、または管理者のみが編集できます。",
      "pfHandoverMgr": "チームマネージャー",
      "pfYear": "年",
      "pfYearPick": "年を選択…",
      "pfSeasonParts": "シーズン",
      "pfSeasonMax2": "任意。最大2つまで選択",
      "pfSeasonCode": "プロジェクトコード：{{code}}",
      "seasonSpring": "春",
      "seasonSummer": "夏",
      "seasonFall": "秋",
      "seasonWinter": "冬",
      "pfSeason": "シーズン",
      "pfPartner": "パートナー／ライン",
      "pfKeyword": "キーワード",
      "pfTargetLaunch": "目標発売時期（月）",
      "pfNameHint": "システムが自動生成します。PRJ-IDが恒久的なキーで、こちらは人が読むための名前です。",
      "pfSelectTeam": "チームを選択…",
      "pfSelectOwner": "オーナーを選択…",
      "pfPickTeamFirst": "先にチームを選択してください",
      "gmTitle": "プロジェクトグループを編集",
      "gmSaveGroup": "グループを保存",
      "gmSaveTickets": "チケットを保存",
      "pfProjectName": "プロジェクト名",
      "pfProjectNamePh": "例：25 PARTICULIER",
      "pfCase": "ケース",
      "pfSelectCase": "ケースを選択...",
      "pfEntity": "エンティティ",
      "pfSelectEntity": "エンティティを選択...",
      "pfSkuInfo": "SKU情報",
      "pfAddSku": "+ SKUを追加",
      "mvBtn": "プロジェクトからSKUを移動",
      "mvBtnTitle": "このチームの別プロジェクトから承認済みSKUを持ってきます。承認状態は引き継がれます",
      "mvNeedTeam": "先にプロジェクトのチームを選択してください",
      "mvNotManager": "SKUを移動できるのは、管理者またはこのチームのマネージャーのみです",
      "mvHead": "承認済みSKUをこのプロジェクトに移動",
      "mvIntro": "同じチームのプロジェクトを選び、その承認済みSKUをチェックしてください。このフォームを保存すると、SKU ID、承認、サンプル、ステージを保ったまま移動します。CEOへの再提出はありません。すでに発行済みのチケットは元のプロジェクトに残ります。担当者、デザイナー、プロジェクトオーナーにメールが送られます。",
      "mvSource": "移動元",
      "mvSearch": "プロジェクトまたはSKUを検索",
      "mvSearchPh": "PRJ番号、プロジェクト名、SKU番号、品名…",
      "mvNoMatch": "該当なし。もっと短いキーワードをお試しください。",
      "mvPicked": "{{n}}件チェック済み",
      "mvChoose": "プロジェクトを選択…",
      "mvLoading": "読み込み中…",
      "mvApprovedN": "承認済み{{n}}件",
      "mvNone": "承認済みSKUのある他のプロジェクトはこのチームにありません。",
      "mvAllTaken": "このプロジェクトの承認済みSKUはすべて選択済みです。",
      "mvAll": "すべてチェック",
      "mvColItem": "品目",
      "mvColApproved": "承認日",
      "mvColDeveloper": "担当者",
      "mvColDesigner": "デザイナー",
      "mvCancel": "キャンセル",
      "mvAdd": "{{n}}件のSKUを追加",
      "mvListHead": "保存時に移動：{{n}}件のSKU",
      "mvFrom": "移動元：{{id}}",
      "mvApprovedBy": "承認者：{{who}}",
      "mvRemove": "これは移動しない",
      "mvSaveHint": "まだ何も移動していません。これらのSKUは、フォームを保存するとこのプロジェクトに移動します。",
      "mvTeamChanged": "これらのSKUは、上で選択したチームとは別のチームのプロジェクトのものです。削除するか、チームを元に戻してください。",
      "pfSkuHint": "各SKUは、1つのPGプロジェクトの下に、それぞれ独立したPRJ項目として保存されます。SKUを展開すると、情報、初期ステージ、リンクしたサンプルを編集できます。",
      "pfUnassigned": "未割り当て",
      "pfNoCategory": "カテゴリーなし",
      "pfQty": "QTY",
      "pfStageChip": "ステージ",
      "pfRemoveSku": "SKUを削除",
      "pfDuplicateSku": "このSKUを複製",
      "pfApprovalNoteHead": "承認待ちとして保存しました。まだ承認者には送信されていません。",
      "pfApprovalNoteBody": "Project Approvalを開き、「提出」を押して依頼を送信してください。承認後にチケットを発行できます。",
      "pfDeveloper": "担当者",
      "pfDesigner": "デザイナー",
      "pfNoDesigner": "デザイナーなし",
      "ptDesigner": "デザイナー",
      "ptAllSalesReps": "すべてのSales Rep",
      "ptAllDesigners": "すべてのデザイナー",
      "pfAssignedTo": "担当",
      "pfAllocation": "割り当て",
      "pfProductCategory": "製品カテゴリー",
      "pfFrameColor": "フレームカラー",
      "pfFrameColorPh": "色を検索または追加…",
      "pfItemName": "品名／SKU名",
      "pfItemNamePh": "例：Backpack 17L",
      "pfEstQty": "見込QTY",
      "pfStartDate": "開始日",
      "pfExfShipDate": "EXF出荷日",
      "pfTargetPrice": "目標価格（USD）",
      "pfLaunchDate": "発売日",
      "pfProjectStatus": "プロジェクトステータス",
      "pfRemark": "備考",
      "pfInitialStages": "初期プロセスステージ",
      "pfPctComplete": "完了",
      "pfStageHint": "リストからステータスを選ぶか、自由に入力してください。日付はdd/mm/yyyyで入力します。空欄のまま保存するとPendingになります。",
      "pfRepeatOrder": "リピート注文",
      "pfRepeatOrderHint": "すでに開発済みのスタイルの再注文です。プロトやカウンターサンプル、L/Dの承認、引き継ぎミーティングは不要のため、この4つはCompleteに設定されます。",
      "pfStagePh": "Pendingまたはdd/mm/yyyy",
      "pfStageAuto": "自動：リンクしたサンプルから",
      "pfLinkSample": "サンプルをリンク（任意）",
      "pfLinkSampleHint": "サンプルID／Base IDを1つ以上、カンマ区切りで入力します。サンプルを選ぶと、このPRJ項目にリンクされます。",
      "pfLinkSamplePh": "サンプルID／Base IDを選択または入力",
      "pfGtm": "GTMプログラム（任意）",
      "pfGtmHint": "このSKUが発売されるGTMプログラムです。GTMシートにも表示されます",
      "pfGtmPh": "GTMコードを選択または入力（例：GTM-26-001）",
      "pfTickets": "チケット",
      "pfTicketsAdded": "{{count}}件のチケットを追加済み",
      "pfNoTicketYet": "チケットはまだ追加されていません",
      "pfAllReceivingTeams": "すべての受付チーム",
      "pfAddTicket": "＋ チケットを追加…",
      "pfTicketHint": "このプロジェクトのチーム、ケース、カテゴリーに一致するコードのみが、フェーズ別に表示されます。受付チームを選び、「＋ チケットを追加」を押してください。新しいチケットは、グループを保存したときに作成されます。",
      "pfClearTickets": "チケットをクリア",
      "pfPhotosOnSku": "写真は上の各SKUに添付します。SKUを開いて「写真を追加」を使ってください。",
      "pfTicketEmpty": "チケットはまだ追加されていません。「＋ チケットを追加」から選択してください。",
      "pfCancel": "キャンセル",
      "pfSaving": "保存中...",
      "pfAddProject": "プロジェクトを追加",
      "pfDiscardTitle": "このプロジェクトを破棄しますか？",
      "pfDiscardBody": "入力した内容はまだ保存されていません。フォームを閉じると失われます。",
      "pfDiscardKeep": "編集を続ける",
      "pfDiscardConfirm": "破棄",
      "dgEditTitle": "変更を破棄しますか？",
      "dgEditBody": "ここで変更した内容はまだ保存されていません。フォームを閉じると変更は失われます。",
      "pfSaveChanges": "変更を保存",
      "pfViewSample": "リンクしたサンプルを表示",
      "pfSampleBtn": "サンプル",
      "pfNewSku": "新規SKU",
      "pfEditPrefix": "編集",
      "pfGroupLevelHint": "グループレベルの情報です。プロジェクトグループから編集してください",
      "pfNewTag": "新規",
      "pfSaveAddSku": "SKUを追加",
      "thSortFilter": "並べ替えと絞り込み",
      "thSortAZ": "A→Zで並べ替え",
      "thSortOldNew": "古い順に並べ替え",
      "thSortZA": "Z→Aで並べ替え",
      "thSortNewOld": "新しい順に並べ替え",
      "thSearch": "検索...",
      "thSelectAll": "（すべて選択）",
      "thNoMatches": "該当なし",
      "thOk": "OK",
      "thCancel": "キャンセル",
      "thBlanks": "（空白）",
      "thFiltered": "絞り込み済み：{{count}}件の値を保持",
      "pgSharedHint": "このグループのすべてのSKUに共通の基本情報",
      "pgPrjItems": "件のPRJ項目",
      "pgSkuHint": "各SKUは、このPGプロジェクトの下にある独立したPRJ項目です。SKUをクリックすると、情報、ステージ、リンクしたサンプルを編集できます。",
      "pgNoSku": "このグループにはまだSKUがありません。",
      "pgRemoveSku": "このSKUをグループから削除",
      "rmTitleNew": "新規ラウンド",
      "rmTitleNewSample": "新規サンプル",
      "rmTitleEdit": "既存ラウンドを編集",
      "rmTitleAdvance": "次のラウンド（Advanceに必須）",
      "tkFiles": "添付ファイル",
      "tfPick": "クリックしてファイルを添付",
      "tfHint": "PDF、Excel、CSV、Word、画像。1ファイルあたり最大{{max}} MB。チケットのメールと一緒に送信されます",
      "tfUploading": "アップロード中…",
      "tfRemove": "このファイルを削除",
      "tfTotal": "{{n}}件のファイル、{{size}}。チケットのメールに添付されて送信されます",
      "tfSaveFirst": "このチケットにはファイルを添付できません。",
      "tfDraftNote": "チケットを保存したときに添付されます",
      "tfTooBig": "{{name}}は{{mb}} MBあり、1ファイルの上限は{{max}} MBです。",
      "rmPickSample": "ラウンドを追加する既存のサンプルを選択",
      "rmPickSampleSub": "— サンプルID、Base ID、スタイル名を入力",
      "rmPickPh": "例：SMP-2601-P1 または SMP-2601...",
      "rmPickRequired": "このラウンドが属するサンプルを選択してください。ラウンドは必ず既存のサンプルに追加されます。",
      "rmPickFirst": "ここから始めます。サンプルIDを入力してください。サンプルを選択すると、フォームの残りが開きます。",
      "rmStyleFromSample": "上で選択したサンプルから取得されます",
      "rmStyleFromSku": "このサンプルの対象となるプロジェクトSKUから取得されます",
      "rmStylePlaceholder": "上でサンプルを選択してください",
      "rmSalesTeam": "営業チーム",
      "rmProjectOwner": "プロジェクトオーナー",
      "rmProjectName": "プロジェクト",
      "rmNoLinkedSku": "SKUにリンクされていません",
      "rmClear": "クリア",
      "rmAddingTo": "ラウンドの追加先：",
      "rmChange": "変更",
      "rmAdvanceNote": "はAdvanceに設定されます。これは開発が次のラウンドに進むことを意味します。そのラウンドを入力して保存してください。両方が一緒に保存されます。",
      "rmAdvanceNoteSub": "キャンセルすると、Advanceの結果も保存されず、ラウンドは元のままになります。",
      "rmDupWarn": "重複の可能性があります：{{sampleId}}には、このスタイルのラウンド「{{round}}」がすでにあります（結果：{{outcome}}）。",
      "rmDupOpen": "開く",
      "rmOwnership": "項目の入力担当：",
      "rmHevnFills": "HEVNが入力",
      "rmHincFills": "HINC Designが入力",
      "rmBothTeams": "両チーム",
      "rmAutoGen": "自動生成",
      "rmMandatory": "＝必須項目",
      "rmSampleIdent": "サンプルの識別",
      "rmStyleItem": "スタイル／品目",
      "rmStyleHint": "既存のものを選ぶか、新規に入力してください。Base IDは自動で割り当てられます",
      "rmStylePh": "例：Chair Zero LT",
      "rmBaseId": "Base ID",
      "rmAutoAssigned": "自動割り当て",
      "rmSampleId": "サンプルID",
      "rmSampleIdHint": "Base ID＋ラウンド＋オプション（自動）",
      "rmRound": "ラウンド",
      "rmOption": "オプション",
      "rmOptionHint": "構造が異なる場合のみ",
      "rmOptionPh": "生地／メッシュ（色違いの場合は空欄）",
      "rmCategory": "カテゴリー",
      "rmSeason": "シーズン",
      "rmDevelopmentDue": "開発期日",
      "rmDevDueHint": "必須。シートでは黄色です",
      "rmTargetPrice": "目標価格（USD）",
      "rmLinkedSku": "リンクしたプロジェクトSKU",
      "rmOptional": "任意",
      "rmLinkedSkuHint": "このサンプルをプロジェクトSKUにリンクします",
      "rmSearchProject": "プロジェクトを検索...",
      "rmReviewType": "レビュー種別",
      "rmHevn": "HEVN",
      "rmRequiresDesigner": "デザイナーのレビューが必要",
      "rmInternalOnly": "HEVN社内レビューのみ",
      "rmInternalNote": "HEVN社内レビューの記録には、レビュー日と備考を使用します。このラウンドは、デザイナーの作業量や未対応のフィードバックには数えられません。",
      "rmDesignerNote": "デザイナーレビューでは、現在のHINCのレビューと結果の流れが維持されます。",
      "rmInternalReview": "HEVN社内レビュー",
      "rmRequestDate": "依頼日",
      "rmInternalReqHint": "HINC Designレビューの依頼日と同じ項目です。こちらは社内レビューの日付です",
      "rmRemarks": "備考",
      "rmInternalRemarksPh": "この社内レビューに関するメモ...",
      "rmSamplePlan": "サンプル計画",
      "rmDeveloper": "担当者",
      "rmDeveloperPh": "選択または名前を入力...",
      "rmEitherName": "担当者かデザイナーのどちらか一方で構いません。",
      "rmLocation": "R&D拠点",
      "rmRmReady": "RM Ready日",
      "rmRmReadyHint": "予定日の場合は「予定」にチェックを入れ、材料／仕様が整ったらチェックを外してください。",
      "pfNeedOwner": "このプロジェクトにはまだプロジェクトオーナーがいないため、チケットを発行できません。メールが「Project Owner: -」のまま送られ、受付チームが誰に戻せばよいか分からなくなります。行の鉛筆アイコンからプロジェクトを開き、プロジェクトオーナーを設定して保存してから、ここに戻ってください。",
      "pfNeedOwnerShort": "先にプロジェクトのプロジェクトオーナーを設定してください",
      "rmMaterials": "材料リスト",
      "rmMaterialsHint": "ここにあるすべての列はSKUに属し、SKU側で編集します。コピーではなく1つのリストなので、そこで追加した材料はすべてのラウンドに表示されます。例外はRM ready日で、これはこのラウンドに属し、ラウンドと一緒に保存されます。",
      "rmMaterialsNoSku": "材料リストはまだありません。リストはプロジェクトSKUに属しますが、このラウンドはSKUにリンクされていません。上の「リンクしたプロジェクトSKU」を入力すると、その材料がここに表示されます。",
      "rmExpectedDate": "予定日",
      "rmSampleFinish": "サンプル完成日",
      "rmQty": "QTY",
      "rmActualCost": "実績コスト（USD）",
      "rmAutoCalc": "自動計算（読み取り専用）：",
      "rmMakeDays": "製作日数",
      "rmShipDays": "出荷日数",
      "rmRoundCycle": "ラウンドサイクル",
      "rmDday": "D-day",
      "rmHincReview": "HINC Designレビュー",
      "rmHincDesigner": "HINCデザイナー",
      "rmHincReqHint": "HINCがこのサンプルを依頼した日",
      "rmRoundDue": "ラウンド期日",
      "rmRoundDueHint": "HINCが目標とするサンプル完成日",
      "rmReceivedDate": "受領日",
      "rmReceivedHint": "HINCがサンプルを受領した日",
      "rmReviewDate": "レビュー日（コメント日）",
      "rmReviewDateHint": "HINCがフィードバックを返した日",
      "rmRoundOutcome": "ラウンド結果",
      "rmOutcomeHint": "週次コメントミーティングの後に設定します",
      "rmNotSetYet": "— 未設定 —",
      "rmOutcomePick": "結果を選択すると、その意味が表示されます。",
      "rmReworkTitle": "Rework：理由が必須",
      "rmReworkReason": "Reworkの理由",
      "rmSelectAll": "（該当するものをすべて選択）",
      "rmRoundRemarksPh": "このラウンドに関するメモ...",
      "rmSaving": "保存中...",
      "rmSaveChanges": "変更を保存",
      "rmSaveAdvance": "Advanceと新規ラウンドを保存",
      "rmAddNewRound": "新規ラウンドを追加",
      "rmCancel": "キャンセル",
      "rmCancelAdvance": "キャンセル（Advanceも破棄）",
      "tkTitle": "Ticket Station",
      "tkHint": "プロジェクトのチケット、オーナーのフォローアップ、期日、ステータス更新を追跡します。",
      "tkAll": "すべてのチケット",
      "tkDone": "完了",
      "tkCancelled": "キャンセル",
      "tkPending": "未完了",
      "tkOverdue": "期限超過",
      "tkAllRequesters": "すべての依頼者",
      "tkAllTeams": "すべての受付チーム",
      "tkAllSopTeams": "すべてのSales OPチーム",
      "tkAllPriority": "すべての優先度",
      "tkSearch": "チケット／プロジェクトを検索...",
      "tkNewTicket": "+ 新規チケット",
      "tkTabTickets": "Ticket Station",
      "tkManageCodes": "チケットコード",
      "tkColTicketId": "チケットID",
      "tkColTicket": "チケット",
      "tkColProject": "プロジェクト",
      "tkColProjectName": "プロジェクト名",
      "tkColTeam": "受付チーム",
      "tkColRequester": "依頼者",
      "tkColType": "種別",
      "tkColPriority": "優先度",
      "tkColDue": "期日",
      "tkColCreatedBy": "作成者",
      "tkColCreatedAt": "作成日時",
      "tkColUpdatedBy": "更新者",
      "tkColUpdatedAt": "更新日時",
      "tkColNote": "メモ",
      "tkColAssigneeReply": "担当者の返信",
      "tkLinkNotSent": "先にチケットを送信してください。受付チームの誰もまだこのチケットの存在を知らないため、このリンクから回答する人がいません。",
      "tkColDescription": "内容",
      "tkColAssigneeNote": "担当者メモ",
      "tkColEmailSent": "メール送信",
      "tkExportEmpty": "エクスポートするものがありません。現在のフィルターに一致するチケットがありません。",
      "tkManagerStatus": "マネージャーステータス",
      "tkRemind": "催促",
      "tkRemindHint": "このチケットがまだ未完了であることを受付チームにメールで知らせます",
      "tkSend": "送信",
      "tkSendHint": "このチケットはまだメール送信されていません。受付チームに依頼を送信します",
      "tkSendDone": "チケット{{id}}を{{to}}にメール送信しました。",
      "tkSendFailed": "送信に失敗しました：{{err}}",
      "tkDdayHint": "D-DAY＝今日−期日。正の値は、その日数分だけチケットが期限を超過していることを示します。チケットがDoneまたはCancelledになると、クローズした日で固定されます。",
      "tkNotYourTeam": "このチケットを変更できるのは、起票者、プロジェクトオーナー、そのチームのマネージャー、または管理者のみです。",
      "tkExpandAll": "すべて展開",
      "tkCollapseAll": "すべて折りたたむ",
      "tkTicketsSingular": "件のチケット",
      "tkTicketsPlural": "件のチケット",
      "tkNoProject": "（プロジェクトなし）",
      "tkEdit": "チケットを編集",
      "tkDuplicate": "チケットを複製",
      "tkDelete": "チケットを削除",
      "tkOpenLink": "公開ステータスリンクを開く",
      "tkLink": "リンク",
      "tkNoTickets": "チケットが見つかりません。",
      "tkTitleNew": "新規チケット",
      "tkTitleEdit": "チケットを編集",
      "tkTitleDup": "チケットを複製",
      "tkAuto": "自動",
      "tkProjectGroup": "プロジェクトグループ",
      "tkSearchGroup": "プロジェクトグループを検索...",
      "tkAutoFromGroup": "プロジェクトグループから自動入力",
      "tkSelectTeam": "受付チームを選択...",
      "tkTicketCode": "チケットコード",
      "tkSelectCode": "取り決め済みのチケット種別を選択...",
      "tkTicketName": "チケット名",
      "tkSelectTypeFirst": "チケット種別を選択してください",
      "tkDescription": "内容",
      "tkDescriptionPh": "チケットの詳細／期待する成果物",
      "tkRequesterPh": "ログインユーザーから自動入力",
      "tkGroupEmail": "グループメール",
      "tkGroupEmailPh": "受付チームから自動入力",
      "tkDueDate": "期日",
      "tkSentAt": "メール送信日",
      "tkAttachment": "添付リンク",
      "tkAttachmentPh": "Driveやファイルのリンクを貼り付け",
      "tkNotePh": "社内メモまたは最新の更新",
      "tkSendAfterSave": "保存後にメールを送信",
      "tkSent": "送信済み",
      "tkNotSent": "未送信",
      "tkEmailSubject": "メールの件名",
      "tkSystemGenerated": "システム生成",
      "tkEmailCc": "メールのCC",
      "tkEmailMessage": "メール本文",
      "tkReadOnly": "読み取り専用",
      "tkEmailMessagePh": "メール本文",
      "tkGeneratedNote": "メールの件名と本文は自動生成されるため、編集できません。",
      "tkSendEmail": "メールを送信",
      "tkDeleteTicket": "チケットを削除",
      "tkSaveTicket": "チケットを保存",
      "tkNoDueDate": "期日なし",
      "tkRemoveTicket": "チケットを削除",
      "tkOptionalNote": "メモ（任意）",
      "tkWillSend": "保存時に送信されます",
      "tkQueued": "送信待ち",
      "tkQueuedCancelTitle": "送信待ち：クリックでキャンセル",
      "tkSendBlocked": "先に上の必須項目を入力してください。入力しないとメールを送信できません",
      "tkSendTitle": "チケットは保存時に作成されるため、メールはその直後に送信されます"
    },
    "rt": {
      "bold": "太字（Ctrl+B）",
      "italic": "斜体（Ctrl+I）",
      "underline": "下線（Ctrl+U）",
      "strike": "取り消し線",
      "colour": "文字色",
      "bullets": "箇条書き",
      "numbers": "番号付きリスト",
      "clear": "書式をクリア",
      "cDefault": "既定",
      "cRed": "赤",
      "cOrange": "オレンジ",
      "cGreen": "緑",
      "cBlue": "青",
      "cPurple": "紫",
      "cGrey": "グレー"
    },
    "nfc": {
      "stDraft": "未提出",
      "stWaiting": "承認待ち",
      "stApproved": "承認済み",
      "stRejected": "却下",
      "replOk": "OK",
      "replNotFound": "見つかりません",
      "replReplaced": "交換済み",
      "replDuplicate": "重複",
      "notSignedIn": "（未ログイン）",
      "role": "ロール",
      "manager": "マネージャー",
      "coordinator": "コーディネーター",
      "unassigned": "未割り当て",
      "loading": "読み込み中…",
      "noAccessTitle": "アクセス権がありません",
      "noAccessBody": "にはNFCポータルのCoordinator／Managerロールが割り当てられていません。追加をご希望の場合はSpecial Projectにご連絡ください。",
      "accountWord": "アカウント",
      "createTitle": "トークン発行依頼を作成",
      "tabIssuance": "トークン発行",
      "tabReplacement": "不良NFCの交換",
      "labelType": "ラベル種別",
      "labelNfc": "NFCラベル",
      "labelQr": "QR熱転写ラベル",
      "projectName": "プロジェクト名",
      "batchName": "バッチ名",
      "qty": "数量（QTY）",
      "qtyPh": "品目をインポートする場合を除き必須",
      "style": "スタイル／製品",
      "stylePh": "例：Chair One (re)",
      "color": "カラー",
      "vendor": "仕入先",
      "vendorPh": "例：Metric / TheSang",
      "code": "コード",
      "codePh": "例：10001555",
      "importTitle": "複数の品目をインポート（任意）",
      "importReplTitle": "不良NFCトークンをインポート",
      "downloadTemplate": "CSVテンプレートをダウンロード",
      "chooseCsv": "CSVを選択",
      "noFile": "ファイルが選択されていません",
      "importSummary": "{{count}}件の品目を読み込みました。合計QTY：{{qty}}。提出前に確認・編集してください。",
      "importInvalid": "無効な行があります（プロジェクト、バッチ、数量が必要です）。",
      "importEmpty": "インポートファイルが読み込まれていません。空のままにすると、上の単一品目の項目が使用されます。",
      "replSummary": "{{count}}件の不良トークンを読み込みました。提出前に確認してください。",
      "replChecking": "台帳と照合中…",
      "warning": "警告：",
      "oldToken": "旧トークン／NFC URL",
      "reason": "理由",
      "notes": "メモ",
      "status": "ステータス",
      "checking": "確認中…",
      "notChecked": "未確認",
      "replEmpty": "不良トークンが読み込まれていません。テンプレートをダウンロードし、CSVをアップロードして開始してください。",
      "optional": "任意",
      "saving": "保存中…",
      "save": "保存",
      "cancel": "キャンセル",
      "myRequests": "自分の依頼",
      "reload": "再読み込み",
      "colId": "ID",
      "colProject": "プロジェクト",
      "colBatch": "バッチ",
      "colQty": "数量",
      "colItems": "品目",
      "colLabel": "ラベル",
      "colVendor": "仕入先",
      "colCode": "コード",
      "colStatus": "ステータス",
      "colUpdated": "更新日時",
      "colFile": "ファイル",
      "colAction": "操作",
      "colOld": "旧",
      "colNew": "新",
      "colOutput": "出力",
      "colRequestedBy": "依頼者",
      "colEmail": "メール",
      "colAddedBy": "追加者",
      "downloadOrder": "発注ファイルをダウンロード",
      "viewDetail": "詳細を表示",
      "edit": "編集",
      "submitApproval": "承認に提出",
      "delete": "削除",
      "reject": "却下",
      "noRequests": "依頼はまだありません。",
      "reviewTitle": "依頼のレビュー",
      "accessTitle": "ポータルのアクセス管理",
      "accessHint": "このNFCポータルへのCoordinator／Managerアクセスを付与または取り消します。変更は、ユーザーが次にポータルを読み込んだときに反映されます。",
      "grantAccess": "アクセスを付与",
      "noUsers": "割り当て済みのユーザーはまだいません。",
      "detailTitle": "依頼の詳細",
      "lblNotes": "メモ",
      "lblOutputFile": "出力ファイル",
      "openOutput": "出力を開く",
      "lblDecisionNote": "判断メモ",
      "replItems": "交換品目",
      "items": "品目",
      "close": "閉じる",
      "genTitle": "トークンを生成中",
      "genLead": "を承認しています。このタブを開いたままにして、",
      "genLeadBold": "承認を再度クリックしないでください",
      "requestWord": "依頼",
      "working": "処理中...",
      "rejectTitle": "依頼を却下",
      "rejectReason": "理由（依頼者に送信されます）",
      "rejectReasonPh": "却下する理由は何ですか？",
      "rejectReasonReq": "却下の理由を入力してください。",
      "rejectBtn": "依頼を却下",
      "deleteTitle": "依頼を削除",
      "deleteBody": "依頼{{id}}を削除しますか？削除できるのは、下書きまたは却下された依頼のみです。",
      "nReplacements": "{{count}}件の交換",
      "nItems": "{{count}}件の品目",
      "single": "単一",
      "nCodes": "{{count}}件のコード",
      "flashCleared": "依頼フォームをクリアしました。",
      "flashSubmitted": "依頼{{id}}を承認に提出しました。",
      "flashDraft": "依頼{{id}}を下書きとして保存しました。",
      "flashLoadedEdit": "{{id}}を編集用に読み込みました。",
      "flashDeleted": "依頼{{id}}を削除しました。",
      "flashApproved": "依頼{{id}}を承認しました。{{qty}}件のトークンを生成しました。",
      "flashGranted": "{{email}}に{{role}}を付与しました。",
      "flashRevoked": "{{email}}の{{role}}を取り消しました。",
      "flashEmailReq": "メールアドレスを入力してください。",
      "flashLoadedFile": "{{name}}を読み込みました。",
      "flashRejected": "依頼{{id}}を却下しました。",
      "progStarting": "承認を開始しています...",
      "progCompleted": "完了",
      "progGenerated": "{{qty}}件のトークンを生成しました",
      "progSavedImport": "保存済みのインポートを読み込みました"
    },
    "dd": {
      "title": "ダッシュボード",
      "scopeNote": "プロジェクトサンプルのみです。トライアルサンプル（TSMP）は、このページのすべての数値から除外されています。Sample Trackerには両方が表示されます。",
      "loading": "ダッシュボードを読み込み中…",
      "retry": "再試行",
      "noData": "データなし",
      "totalRounds": "ラウンド合計",
      "acrossSamples": "{{count}}件のサンプル全体",
      "avgRoundsSample": "サンプルあたりの平均ラウンド数",
      "higherSpinning": "高いほど堂々巡りが多い",
      "reworkRatio": "Rework率",
      "mainKpi": "主要KPI",
      "pastDue": "開発期日超過",
      "pastDueSub": "D-day ≥ 0の{{unit}}",
      "reworkByRoom": "開発ルーム別Rework率",
      "reworkAttribution": "Reworkの原因帰属（双方向）",
      "hevnCaused": "HEVN（原因）",
      "hincCaused": "HINC（原因）",
      "external": "外部",
      "hevnRatio": "HEVN起因の割合",
      "stuckTime": "滞留時間の目安",
      "avgCommentDiffers": "平均コメント日数：「differs」ラウンド",
      "avgCommentAdvance": "平均コメント日数：Advanceラウンド",
      "avgCommentAll": "平均コメント日数：全体",
      "spinning": "堂々巡りのサンプル（4ラウンド以上）",
      "sampleSpeed": "サンプルスピード",
      "sampleSpeedNote": "RM Ready Date＝生地／材料／仕様が整い、サンプルルームがサンプルの製作を開始できる日です。サンプルスピードは、RM Ready DateからSample Finish Dateまでを数えます。実際の準備完了日がないラウンドや、準備完了の予定日が将来にあるラウンドはRM Waitingのままとなり、集計から除外されます。",
      "avgMakeHevn": "平均製作日数（HEVN R&D）",
      "avgMakeTs": "平均製作日数（TS）",
      "avgMakeMs": "平均製作日数（MS）",
      "avgMakeTotal": "平均製作日数（合計）",
      "byDeveloper": "担当者別：詳細内訳",
      "colDeveloper": "担当者",
      "colSamples": "サンプル",
      "colRounds": "ラウンド",
      "colRework": "やり直し",
      "colReworkRate": "Rework率",
      "colAvgRounds": "平均ラウンド数",
      "colAvgMakeDays": "平均製作日数",
      "colPending": "保留"
    }
  }
};

export default ja;
